"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4374],{

/***/ 6051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgArrowRight = function SvgArrowRight(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 14,
        viewBox: "0 0 8 14"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "m.313 12.045 5.113-5.112L.313 1.821A1.065 1.065 0 1 1 1.82.312L7.687 6.18a1.064 1.064 0 0 1 0 1.508L1.82 13.554a1.065 1.065 0 1 1-1.507-1.508"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowRight);


/***/ }),

/***/ 14759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LG": function() { return /* binding */ LG; },
/* harmony export */   "MD": function() { return /* binding */ MD; },
/* harmony export */   "l": function() { return /* binding */ buttonThemes; }
/* harmony export */ });
/* harmony import */ var styles_colors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12573);

var buttonThemes = {
    iris: {
        color: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].iris */ .Z.iris,
        background: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].white */ .Z.white
    },
    black: {
        color: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].mud */ .Z.mud,
        background: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].white */ .Z.white
    },
    white: {
        color: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].white */ .Z.white,
        background: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].mud */ .Z.mud
    }
};
// PLAY BUTTON SIZES
var MD = "md";
var LG = "lg";


/***/ }),

/***/ 99433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14759);

/* harmony default export */ __webpack_exports__["Z"] = ({
    poster: "/static/img/tags/video_image.png",
    videoId: "l-7awVpecvU",
    fitToParent: false,
    playButtonColor: "iris",
    playButtonSize: _constants__WEBPACK_IMPORTED_MODULE_0__.MD,
    showShadow: true
});


/***/ }),

/***/ 86199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ youtube_video_with_poster_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/core/youtube-video/youtube-video-component.js + 1 modules
var youtube_video_component = __webpack_require__(14831);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./components/core/youtube-video-with-poster/youtube-video-with-poster-component.scss.js


var StyledYoutubeVideoWithPosterComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1yvzfjg0"
})("display:flex;flex-direction:column;align-items:center;position:relative;cursor:pointer;.poster-image-wrapper{top:0;left:0;transition:opacity 0.1s ease-out;opacity:1;&.with-shadow{box-shadow:0 2px 16px 0 rgba(0,0,0,0.2);}img{width:100%;height:100%;object-fit:cover;}}.video-component-wrapper{opacity:0;iframe{display:block;}}&:hover{.play-button-container{transform:translate(-50%,-50%) scale(1.1);}}.play-button-container{border:none;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:80px;height:80px;border-radius:50%;background-color:", colors/* default.white */.Z.white, ";box-shadow:0 2px 16px 0 rgba(0,0,0,0.2);pointer-events:none;transition:transform 0.2s ease-in-out;.play-button{box-sizing:border-box;border-top-color:transparent;border-bottom-color:transparent;border-right-color:transparent;border-left-color:rgb(51,51,51);border-style:solid;border-width:16px 0 16px 28px;position:absolute;left:calc(50% + 4px);top:50%;transform:translate(-50%,-50%);}&.lg{width:128px;height:128px;.play-button{border-width:24px 0 24px 36px;left:calc(50% + 8px);}}}&.hide-poster{.poster-image-wrapper{opacity:0;z-index:-1;}.video-component-wrapper{opacity:1;z-index:1;}}");

// EXTERNAL MODULE: ./components/core/youtube-video-with-poster/constants.js
var constants = __webpack_require__(14759);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./components/core/youtube-video-with-poster/default-props.js
var default_props = __webpack_require__(99433);
;// CONCATENATED MODULE: ./components/core/youtube-video-with-poster/youtube-video-with-poster-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}









var YOUTUBE_ASPECT_RATIO = 9 / 16;
var YoutubeVideoWithPosterComponent = function(props) {
    var ref = (0,react.useState)(true), isPosterVisible = ref[0], setIsPosterVisible = ref[1];
    var ref1 = (0,react.useState)(false), playVideo = ref1[0], setPlayVideo = ref1[1];
    var ref2 = (0,react.useRef)(null);
    var width = props.width, fitToParent = props.fitToParent, playButtonColor = props.playButtonColor, poster = props.poster, previewRenderer = props.previewRenderer, alt = props.alt, playButtonSize = props.playButtonSize, translate = props.translate, showShadow = props.showShadow, videoId = props.videoId, muted = props.muted, volume = props.volume, videoOpts = props.videoOpts;
    var onPlayButtonClicked = function(e) {
        setIsPosterVisible(false);
        setPlayVideo(true);
    };
    var getInlineStyle = function() {
        var _ref_current;
        var styleWidth = (_ref_current = ref2.current) === null || _ref_current === void 0 ? void 0 : _ref_current.offsetWidth;
        if (fitToParent && styleWidth) {
            return {
                width: styleWidth,
                height: styleWidth * YOUTUBE_ASPECT_RATIO
            };
        }
        return {
            height: "auto",
            width: width
        };
    };
    var getButtonContainerStyle = function() {
        var _buttonThemes_playButtonColor;
        if (!playButtonColor) return {};
        return {
            backgroundColor: (_buttonThemes_playButtonColor = constants/* buttonThemes */.l[playButtonColor]) === null || _buttonThemes_playButtonColor === void 0 ? void 0 : _buttonThemes_playButtonColor.color
        };
    };
    var getButtonArrowStyle = function() {
        var _buttonThemes_playButtonColor;
        if (!playButtonColor) return {};
        return {
            borderLeftColor: (_buttonThemes_playButtonColor = constants/* buttonThemes */.l[playButtonColor]) === null || _buttonThemes_playButtonColor === void 0 ? void 0 : _buttonThemes_playButtonColor.background
        };
    };
    var renderPreview = function() {
        if (previewRenderer) {
            return isPosterVisible && previewRenderer();
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("poster-image-wrapper", {
                "with-shadow": showShadow
            }),
            style: {
                display: isPosterVisible ? "block" : "none"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: classnames_default()("play-button-container", playButtonSize),
                    style: getButtonContainerStyle(),
                    "aria-label": translate("accessibility.button.playVideo"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "play-button",
                        style: getButtonArrowStyle()
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                    pictureClass: "poster-image",
                    alt: alt,
                    src: poster,
                    screenRatios: {
                        mobile: 0.99,
                        mobileRetina: 0.99
                    }
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledYoutubeVideoWithPosterComponent, {
        className: classnames_default()("youtube-video-with-poster-component", {
            "hide-poster": !isPosterVisible
        }),
        onClick: onPlayButtonClicked,
        ref: ref2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "video-component-wrapper",
                style: {
                    display: isPosterVisible ? "none" : "block"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(youtube_video_component/* default */.ZP, {
                    videoId: videoId,
                    playing: playVideo,
                    muted: muted,
                    volume: volume,
                    opts: _object_spread({}, getInlineStyle(), videoOpts),
                    showShadow: showShadow
                })
            }),
            renderPreview()
        ]
    });
};
/* harmony default export */ var youtube_video_with_poster_component = ((0,generic_config_context/* withGenericConfig */.P)(YoutubeVideoWithPosterComponent));
YoutubeVideoWithPosterComponent.defaultProps = default_props/* default */.Z;


/***/ }),

/***/ 91237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ segments; }
});

// EXTERNAL MODULE: ./segments/desktop/asset/layouts/regular-asset/regular-asset-component.js + 1 modules
var regular_asset_component = __webpack_require__(98181);
// EXTERNAL MODULE: ./components/segments/basic-segments.js + 7 modules
var basic_segments = __webpack_require__(1241);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var styled_jsx_style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/segments/two-columns-with-carousel/two-columns-with-carousel-component.scss.js

var _defaultExport = new String(".two-columns-with-carousel{min-height:500px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;&.with-signup{min-height:-webkit-calc(100vh - 50px);min-height:-moz-calc(100vh - 50px);min-height:calc(100vh - 50px)}&:not(.with-signup){min-height:-webkit-calc(90vh);min-height:-moz-calc(90vh);min-height:calc(90vh)}.top-line{-webkit-box-flex:1;-webkit-flex:1 0 auto;-moz-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;.content-column{-webkit-box-flex:0;-webkit-flex:0 0 50%;-moz-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;.content-inner{width:80%;.content-title{font-size:3vw;margin-bottom:20px;font-weight:300;&.bold{font-weight:bold}}.content-body{div,li{font-size:1.3vw;font-weight:300;line-height:1.6;margin-bottom:10px}}.button-link-wrapper{margin-top:40px}}}.asset-column{-webkit-box-flex:0;-webkit-flex:0 0 50%;-moz-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;position:relative;.asset-inner{width:80%;position:relative;.main-image{width:100%;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}.main-image.round{-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%}iframe{width:100%}}.hot-dog{position:absolute;width:60vw;height:26vw;background:orange;right:-20vw;-webkit-border-radius:15vw;-moz-border-radius:15vw;border-radius:15vw;-webkit-transform:rotate(-20deg);-moz-transform:rotate(-20deg);-ms-transform:rotate(-20deg);-o-transform:rotate(-20deg);transform:rotate(-20deg);top:25px}&.with-shadow{.asset-inner{-webkit-box-shadow:0px 2px 20px 1px rgba(177,177,177,.4);-moz-box-shadow:0px 2px 20px 1px rgba(177,177,177,.4);box-shadow:0px 2px 20px 1px rgba(177,177,177,.4)}}}}&.asset-left{.top-line{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-webkit-flex-direction:row-reverse;-moz-box-orient:horizontal;-moz-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse;.asset-column{.hot-dog{right:auto;left:-20vw;-webkit-transform:rotate(-20deg);-moz-transform:rotate(-20deg);-ms-transform:rotate(-20deg);-o-transform:rotate(-20deg);transform:rotate(-20deg);top:120px}}}}.bottom-line{height:20vh;-webkit-box-flex:0;-webkit-flex:0 0 auto;-moz-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;text-align:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;.signup-title{font-size:1.5vw;font-weight:400;margin-bottom:16px}}@media(max-width:".concat(vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){height:auto;margin-top:40px;.top-line{-webkit-box-orient:vertical!important;-webkit-box-direction:normal!important;-webkit-flex-direction:column!important;-moz-box-orient:vertical!important;-moz-box-direction:normal!important;-ms-flex-direction:column!important;flex-direction:column!important;min-height:680px;.content-column{.content-inner{.content-title{font-size:1.375rem}.content-body{div,li{font-size:.875rem}}}}.asset-column{min-height:100vw;.hot-dog{width:130vw;height:60vw;-webkit-border-radius:30vw;-moz-border-radius:30vw;border-radius:30vw;right:-40vw}}}.bottom-line{height:auto;.signup-title{padding:0px 20px;font-size:.875rem}}&.asset-left{.top-line{.asset-column{.hot-dog{right:auto;left:-40vw}}}}}}"));
_defaultExport.__hash = "3174d24f69e2995d";
/* harmony default export */ var two_columns_with_carousel_component_scss = (_defaultExport);

// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-component.js + 2 modules
var signup_form_component = __webpack_require__(24494);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/core/button-link/button-link-component.scss.js


var StyledButtonLinkComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1syzmyp0"
})("display:flex;a{position:relative;padding:16px 32px;cursor:pointer;font-size:1rem;border-radius:40px;color:", colors/* default.white */.Z.white, ";border:none;font-weight:400;text-align:center;text-decoration:none;&:not(:hover){transition:0.2s ease all;}&:hover{filter:brightness(90%);}&.loading{cursor:default;}.spinner{position:absolute;left:calc(50% - 12px);top:calc(50% - 12px);}}");

// EXTERNAL MODULE: ./components/enhancements/spinner/spinner-component.js + 1 modules
var spinner_component = __webpack_require__(79067);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/core/button-link/button-link-component.js













var ButtonLinkComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ButtonLinkComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ButtonLinkComponent);
    function ButtonLinkComponent(props) {
        (0,_class_call_check/* default */.Z)(this, ButtonLinkComponent);
        var _this;
        _this = _super.call(this, props);
        _this.onClick = _this.onClick.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(ButtonLinkComponent, [
        {
            key: "onClick",
            value: function onClick(e) {
                var _props = this.props, onClickCallback = _props.onClickCallback, placement = _props.placement, href = _props.href;
                BigBrain("track", bigbrain_event_types.BUTTON_LINK_CLICKED, {
                    placement: placement,
                    info1: href
                });
                if (onClickCallback) {
                    onClickCallback(e);
                }
                return true; // continue the location change
            }
        },
        {
            key: "getUrlParams",
            value: function getUrlParams() {
                var router = this.props.router;
                var searchParams = router.asPath.split(/\?/)[1];
                return "?" + searchParams;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, className = _props.className, tabIndex = _props.tabIndex, children = _props.children, href = _props.href, target = _props.target, color = _props.color, loading = _props.loading, fontSize = _props.fontSize, textColor = _props.textColor, shouldForwardUrlParams = _props.shouldForwardUrlParams;
                var hrefWithParamsIfNeeded = href;
                if (shouldForwardUrlParams) {
                    hrefWithParamsIfNeeded += this.getUrlParams();
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonLinkComponent, {
                    className: classnames_default()("button-link-component", {
                        loading: loading
                    }),
                    children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner_component/* default */.Z, {
                        className: "spinner",
                        color: "white",
                        size: "24px",
                        speed: "slow"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: hrefWithParamsIfNeeded,
                        target: target,
                        tabIndex: tabIndex,
                        className: classnames_default()(className, {
                            loading: loading
                        }),
                        onClick: this.onClick,
                        style: {
                            backgroundColor: colors/* default */.Z[color],
                            color: colors/* default */.Z[textColor],
                            fontSize: fontSize
                        },
                        children: children
                    })
                });
            }
        }
    ]);
    return ButtonLinkComponent;
}(react.PureComponent);
ButtonLinkComponent.defaultProps = {
    onClickCallback: null,
    tabIndex: -1,
    className: "",
    color: "brand-pink",
    textColor: "white",
    loading: false
};
/* harmony default export */ var button_link_component = ((0,router.withRouter)(ButtonLinkComponent));

// EXTERNAL MODULE: ./utils/arrays.js
var arrays = __webpack_require__(84657);
;// CONCATENATED MODULE: ./components/segments/two-columns-with-carousel/two-columns-with-carousel-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}










var DEFAULT_HOTDOG_COLOR = "brand-purple";
var TwoColumnsWithCarouselComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TwoColumnsWithCarouselComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TwoColumnsWithCarouselComponent);
    function TwoColumnsWithCarouselComponent() {
        (0,_class_call_check/* default */.Z)(this, TwoColumnsWithCarouselComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(TwoColumnsWithCarouselComponent, [
        {
            key: "renderParagraphs",
            value: function renderParagraphs(paragraphs, disableHtmlSupport) {
                if (disableHtmlSupport) {
                    if (paragraphs.length == 1 && paragraphs[0]) {
                        paragraphs = paragraphs[0].split("\n");
                    }
                    return paragraphs.map(function(paragraph, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: paragraph
                        }, index);
                    });
                }
                return paragraphs.map(function(paragraph, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: paragraph
                        }
                    }, index);
                });
            }
        },
        {
            key: "renderList",
            value: function renderList(bullets, disableHtmlSupport) {
                if (disableHtmlSupport) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "content-list",
                        children: bullets.map(function(bullet, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: bullet
                            }, index);
                        })
                    });
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "content-list",
                    children: bullets.map(function(bullet, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            dangerouslySetInnerHTML: {
                                __html: bullet
                            }
                        }, index);
                    })
                });
            }
        },
        {
            key: "renderButtonLink",
            value: function renderButtonLink() {
                var _buttonLink = this.props.content.buttonLink, text = _buttonLink.text, href = _buttonLink.href, color = _buttonLink.color, openInNewTab = _buttonLink.openInNewTab;
                var target = openInNewTab ? "_blank" : undefined;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "button-link-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_link_component, {
                        color: color,
                        href: href,
                        target: target,
                        children: text
                    })
                });
            }
        },
        {
            key: "renderAsset",
            value: function renderAsset() {
                var _asset = this.props.asset, shadow = _asset.shadow, image = _asset.image, youtube = _asset.youtube;
                if (!image && !youtube) return undefined;
                if (image) {
                    var pictureClassName = "main-image ".concat(image.roundImage ? "round" : "");
                    var style = image.specificAssetStyle ? image.specificAssetStyle : {
                        width: "".concat(image.widthPercentage, "%")
                    };
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "asset-inner",
                        style: style,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, _object_spread({
                            className: pictureClassName
                        }, image))
                    });
                } else if (youtube) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "asset-inner",
                        style: {
                            width: "".concat(youtube.widthPercentage, "%")
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            frameBorder: 0,
                            src: youtube.src,
                            style: {
                                height: "".concat(youtube.height, "px")
                            }
                        })
                    });
                } else {
                    return undefined;
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, assetSide = _props.assetSide, signupForm = _props.signupForm, content = _props.content, hotDog = _props.hotDog, asset = _props.asset, hideIfNoContent = _props.hideIfNoContent;
                var contentTitle = content.title, contentBody = content.body, contentType = content.contentType, buttonLink = content.buttonLink, disableHtmlSupport = content.disableHtmlSupport;
                var shadow = asset.shadow, image = asset.image;
                var withSignupForm = signupForm && signupForm.enabled;
                contentBody = (0,arrays.convertToArrayIfNeeded)(contentBody);
                if (hideIfNoContent && (contentBody.length == 0 || !contentBody[0])) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(two_columns_with_carousel_component_scss.__hash) + " " + (classnames_default()("two-columns-with-carousel", {
                        "asset-left": assetSide == "left",
                        "with-signup": withSignupForm
                    }) || ""),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-".concat(two_columns_with_carousel_component_scss.__hash) + " " + "top-line",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-".concat(two_columns_with_carousel_component_scss.__hash) + " " + "content-column",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "jsx-".concat(two_columns_with_carousel_component_scss.__hash) + " " + "content-inner",
                                        children: [
                                            !disableHtmlSupport && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                dangerouslySetInnerHTML: {
                                                    __html: contentTitle
                                                },
                                                className: "jsx-".concat(two_columns_with_carousel_component_scss.__hash) + " " + "content-title"
                                            }),
                                            disableHtmlSupport && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "jsx-".concat(two_columns_with_carousel_component_scss.__hash) + " " + "content-title bold",
                                                children: contentTitle
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "jsx-".concat(two_columns_with_carousel_component_scss.__hash) + " " + "content-body",
                                                children: contentType === "list" ? this.renderList(contentBody, disableHtmlSupport) : this.renderParagraphs(contentBody, disableHtmlSupport)
                                            }),
                                            buttonLink && this.renderButtonLink()
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "jsx-".concat(two_columns_with_carousel_component_scss.__hash) + " " + (classnames_default()("asset-column", {
                                        "with-shadow": shadow
                                    }) || ""),
                                    children: [
                                        hotDog && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                background: colors/* default */.Z[hotDog.color] || colors/* default */.Z[DEFAULT_HOTDOG_COLOR]
                                            },
                                            className: "jsx-".concat(two_columns_with_carousel_component_scss.__hash) + " " + "hot-dog"
                                        }),
                                        this.renderAsset()
                                    ]
                                })
                            ]
                        }),
                        withSignupForm && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(two_columns_with_carousel_component_scss.__hash) + " " + "bottom-line",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "jsx-".concat(two_columns_with_carousel_component_scss.__hash) + " " + "signup-wrapper",
                                children: [
                                    signupForm.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "jsx-".concat(two_columns_with_carousel_component_scss.__hash) + " " + "signup-title",
                                        children: signupForm.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, {})
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: two_columns_with_carousel_component_scss.__hash,
                            children: two_columns_with_carousel_component_scss
                        })
                    ]
                });
            }
        }
    ]);
    return TwoColumnsWithCarouselComponent;
}(react.PureComponent);

TwoColumnsWithCarouselComponent.defaultProps = {
    content: {},
    asset: {},
    hotDog: {
        color: DEFAULT_HOTDOG_COLOR
    },
    hideIfNoContent: false
};

;// CONCATENATED MODULE: ./components/segments/person-component/person-component.scss.js


var componentStyles = new String(".person-component.jsx-4021719501c349b9{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;.person-image.jsx-4021719501c349b9{margin-right:1.5vw;img {\n        border-radius: 50%;\n        height: 5vw;\n        min-height: 32px;\n      }\n    }.text-container.jsx-4021719501c349b9{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-align:left;line-height:3vw;.text.jsx-4021719501c349b9{font-size:2vw;a,\n        span {\n          font-weight: 400;\n        }\n      @media(max-width:".concat(vp_sizes/* TABLET_QUERY_MIN_WIDTH */.Al, "){font-size:1.125rem;line-height:24px}}.name-and-vendor-container.jsx-4021719501c349b9{.person-name.jsx-4021719501c349b9{text-decoration:none;color:").concat(colors/* default.black */.Z.black, ';font-family:"Reenie Beanie",cursive;font-size:2.5vw;@media(max-width:').concat(vp_sizes/* TABLET_QUERY_MIN_WIDTH */.Al, "){font-size:1.375rem}}.vendor-name.jsx-4021719501c349b9{color:").concat(colors/* default.black */.Z.black, ";text-decoration:none}}}}"));
componentStyles.__hash = "4021719501c349b9";

// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
;// CONCATENATED MODULE: ./components/segments/person-component/person-component.js










var PersonComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(PersonComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(PersonComponent);
    function PersonComponent() {
        (0,_class_call_check/* default */.Z)(this, PersonComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(PersonComponent, [
        {
            key: "trackLinkClick",
            value: function trackLinkClick(event) {
                var target = event.target;
                var href = target.href || target.parentElement.href; /* For Logo image*/ 
                var isUser = href.indexOf("/user/") != -1;
                var id = href.substring(href.lastIndexOf("/") + 1);
                (0,bigbrain_service.trackCommunityEvent)(bigbrain_event_types.SHOW_TEMPLATES, {
                    kind: isUser ? "user" : "account",
                    info1: id
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, personName = _props.personName, personImageSrc = _props.personImageSrc, personUrl = _props.personUrl, vendorName = _props.vendorName, vendorUrl = _props.vendorUrl, namePrefix = _props.namePrefix, postfix = _props.postfix;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(componentStyles.__hash) + " " + "person-component",
                    children: [
                        personImageSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(componentStyles.__hash) + " " + "person-image",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: personImageSrc,
                                alt: personName,
                                className: "jsx-".concat(componentStyles.__hash)
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(componentStyles.__hash) + " " + "text-container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "jsx-".concat(componentStyles.__hash) + " " + "name-and-vendor-container text",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "jsx-".concat(componentStyles.__hash),
                                        children: namePrefix
                                    }),
                                    personUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: personUrl,
                                        onClick: this.trackLinkClick,
                                        className: "jsx-".concat(componentStyles.__hash) + " " + "person-name",
                                        children: personName
                                    }),
                                    !personUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "jsx-".concat(componentStyles.__hash) + " " + "person-name",
                                        children: personName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "jsx-".concat(componentStyles.__hash),
                                        children: " from "
                                    }),
                                    vendorUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: vendorUrl,
                                        onClick: this.trackLinkClick,
                                        className: "jsx-".concat(componentStyles.__hash) + " " + "vendor-name",
                                        children: vendorName
                                    }),
                                    !vendorUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "jsx-".concat(componentStyles.__hash) + " " + "vendor-name",
                                        children: vendorName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "jsx-".concat(componentStyles.__hash) + " " + "story text",
                                        children: postfix
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: componentStyles.__hash,
                            children: componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return PersonComponent;
}(react.PureComponent);

PersonComponent.defaultProps = {
    personName: "",
    personImageSrc: "",
    personUrl: "",
    vendorName: "",
    vendorUrl: "",
    namePrefix: "Hi I'm ",
    postfix: "This is how I use monday.com"
};

// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./components/segments/title-and-subtitle/title-and-subtitle-component.scss.js



var title_and_subtitle_component_scss_componentStyles = new String(".title-and-subtitle-component.jsx-c0e008509349b5be{position:relative;.title-and-subtitle-content.jsx-c0e008509349b5be{position:relative;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;z-index:".concat(z_index/* LAYER_ONE */.KW, ";.title.jsx-c0e008509349b5be{margin-top:4vh;margin-bottom:.5vh;text-align:center;max-width:80vw;font-size:2.5vw;font-weight:bold;b{font-weight:500}}.subtitle.jsx-c0e008509349b5be{font-size:1.5vw;margin-top:0;font-weight:300;max-width:80vw;text-align:center;line-height:2.4vw;margin-bottom:0}&.white-text.jsx-c0e008509349b5be{.title.jsx-c0e008509349b5be,.subtitle.jsx-c0e008509349b5be{color:").concat(colors/* default.white */.Z.white, "}}}@media(max-width:").concat(vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.title-and-subtitle-component.jsx-c0e008509349b5be{min-height:auto;padding:0px 20px;text-align:center;.title.jsx-c0e008509349b5be{font-size:1.575rem;margin-bottom:1.5vh;line-height:1.3;font-weight:300}.subtitle.jsx-c0e008509349b5be{font-size:.875rem;line-height:1.5}}}}"));
title_and_subtitle_component_scss_componentStyles.__hash = "c0e008509349b5be";

;// CONCATENATED MODULE: ./components/segments/title-and-subtitle/title-and-subtitle-component.js









var TitleAndSubtitleComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TitleAndSubtitleComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TitleAndSubtitleComponent);
    function TitleAndSubtitleComponent() {
        (0,_class_call_check/* default */.Z)(this, TitleAndSubtitleComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(TitleAndSubtitleComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, subtitle = _props.subtitle, textColor = _props.textColor, paddingBottom = _props.paddingBottom;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        paddingBottom: "".concat(paddingBottom)
                    },
                    className: "jsx-".concat(title_and_subtitle_component_scss_componentStyles.__hash) + " " + "title-and-subtitle-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-".concat(title_and_subtitle_component_scss_componentStyles.__hash) + " " + (classnames_default()("title-and-subtitle-content", {
                                "white-text": textColor === "white"
                            }) || ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "jsx-".concat(title_and_subtitle_component_scss_componentStyles.__hash) + " " + "title",
                                    children: title
                                }),
                                subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    dangerouslySetInnerHTML: {
                                        __html: subtitle
                                    },
                                    className: "jsx-".concat(title_and_subtitle_component_scss_componentStyles.__hash) + " " + "subtitle"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: title_and_subtitle_component_scss_componentStyles.__hash,
                            children: title_and_subtitle_component_scss_componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return TitleAndSubtitleComponent;
}(react.PureComponent);

TitleAndSubtitleComponent.defaultProps = {
    title: "",
    subtitle: "",
    textColor: "",
    paddingBottom: 0
};

// EXTERNAL MODULE: ./components/segments/videos-gallery/videos-gallery-component.js + 4 modules
var videos_gallery_component = __webpack_require__(44980);
;// CONCATENATED MODULE: ./components/core/videos-carousel/desktop/videos-carousel-desktop-component.scss.js

var videos_carousel_desktop_component_scss_defaultExport = new String(".video-carousel-desktop-component{.video-carousel-title{margin-bottom:48px;.colorful-title,.colored{font-size:2.25rem;text-align:center;font-weight:700}}.stories-slick-carousel{@media(max-width:650px){margin-left:-14px;width:auto;.slick-slider{.slick-arrow{display:none}}}}}@media(max-width:".concat(vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.video-carousel-desktop-component{.items-without-carousel{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;overflow:hidden;.video-carousel-item-component{margin-bottom:48px}}.video-carousel-title{.colorful-title,.colored{font-size:1.75rem}}}}"));
videos_carousel_desktop_component_scss_defaultExport.__hash = "7852e2d16fea78be";
/* harmony default export */ var videos_carousel_desktop_component_scss = (videos_carousel_desktop_component_scss_defaultExport);

;// CONCATENATED MODULE: ./components/core/community/home/stories-slick-carousel/slick.scss.js
/* Slider */ var slickStyle = '\n  .slick-slider {\n    position: relative;\n    display: block;\n    box-sizing: border-box;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -ms-touch-action: pan-y;\n    touch-action: pan-y;\n    -webkit-tap-highlight-color: transparent;\n  }\n  .slick-list {\n    position: relative;\n    overflow: hidden;\n    display: block;\n    margin: 0;\n    padding: 0;\n\n    &:focus {\n      outline: none;\n    }\n\n    &.dragging {\n      cursor: pointer;\n      cursor: hand;\n    }\n  }\n  .slick-slider .slick-track,\n  .slick-slider .slick-list {\n    -webkit-transform: translate3d(0, 0, 0);\n    -moz-transform: translate3d(0, 0, 0);\n    -ms-transform: translate3d(0, 0, 0);\n    -o-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n\n  .slick-track {\n    position: relative;\n    left: 0;\n    top: 0;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n\n    &:before,\n    &:after {\n      content: "";\n      display: table;\n    }\n\n    &:after {\n      clear: both;\n    }\n\n    .slick-loading & {\n      visibility: hidden;\n    }\n  }\n  .slick-slide {\n    float: left;\n    height: 100%;\n    min-height: 1px;\n    [dir="rtl"] & {\n      float: right;\n    }\n    img {\n      display: block;\n    }\n    &.slick-loading img {\n      display: none;\n    }\n\n    display: none;\n\n    &.dragging img {\n      pointer-events: none;\n    }\n\n    .slick-initialized & {\n      display: block;\n    }\n\n    .slick-loading & {\n      visibility: hidden;\n    }\n\n    .slick-vertical & {\n      display: block;\n      height: auto;\n      border: 1px solid transparent;\n    }\n  }\n  .slick-arrow.slick-hidden {\n    display: none;\n  }\n';

;// CONCATENATED MODULE: ./components/core/community/home/stories-slick-carousel/slick-theme.scss.js
/* Slider */ var slickThemeStyle = '\n  @charset "UTF-8";\n\n  // Default Variables\n\n  $slick-font-path: "./fonts/" !default;\n  $slick-font-family: "slick" !default;\n  $slick-loader-path: "./" !default;\n  $slick-arrow-color: white !default;\n  $slick-dot-color: black !default;\n  $slick-dot-color-active: $slick-dot-color !default;\n  $slick-dot-size: 0.338rem !default;\n  $slick-opacity-default: 0.75 !default;\n  $slick-opacity-on-hover: 1 !default;\n  $slick-opacity-not-active: 0.25 !default;\n\n  @function slick-image-url($url) {\n    @if function-exists(image-url) {\n      @return image-url($url);\n    } @else {\n      @return url($slick-loader-path+$url);\n    }\n  }\n\n  @function slick-font-url($url) {\n    @if function-exists(font-url) {\n      @return font-url($url);\n    } @else {\n      @return url($slick-font-path+$url);\n    }\n  }\n\n  /* Slider */\n\n  .slick-list {\n    .slick-loading & {\n      background: #fff slick-image-url("ajax-loader.gif") center center no-repeat;\n    }\n  }\n\n  /* Arrows */\n\n  .slick-prev,\n  .slick-next {\n    position: absolute;\n    display: block;\n    height: 20px;\n    width: 20px;\n    line-height: 0px;\n    font-size: 0rem;\n    cursor: pointer;\n    background: transparent;\n    color: transparent;\n    top: 50%;\n    -webkit-transform: translate(0, -50%);\n    -ms-transform: translate(0, -50%);\n    transform: translate(0, -50%);\n    padding: 0;\n    border: none;\n    outline: none;\n    &:hover,\n    &:focus {\n      outline: none;\n      background: transparent;\n      color: transparent;\n      &:before {\n        opacity: $slick-opacity-on-hover;\n      }\n    }\n    &.slick-disabled:before {\n      opacity: $slick-opacity-not-active;\n    }\n    &:before {\n      font-family: $slick-font-family;\n      font-size: 1.125rem;\n      line-height: 1;\n      color: $slick-arrow-color;\n      opacity: $slick-opacity-default;\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale;\n    }\n  }\n\n  .slick-prev {\n    left: -25px;\n    [dir="rtl"] & {\n      left: auto;\n      right: -25px;\n    }\n  }\n\n  .slick-next {\n    right: -25px;\n    [dir="rtl"] & {\n      left: -25px;\n      right: auto;\n    }\n  }\n\n  /* Dots */\n\n  .slick-dotted.slick-slider {\n    margin-bottom: 30px;\n  }\n\n  .slick-dots {\n    position: absolute;\n    bottom: -25px;\n    list-style: none;\n    display: block;\n    text-align: center;\n    padding: 0;\n    margin: 0;\n    width: 100%;\n    li {\n      position: relative;\n      display: inline-block;\n      height: 20px;\n      width: 20px;\n      margin: 0 5px;\n      padding: 0;\n      cursor: pointer;\n      button {\n        border: 0;\n        background: transparent;\n        display: block;\n        height: 20px;\n        width: 20px;\n        outline: none;\n        line-height: 0px;\n        font-size: 0rem;\n        color: transparent;\n        padding: 5px;\n        cursor: pointer;\n        &:hover,\n        &:focus {\n          outline: none;\n          &:before {\n            opacity: $slick-opacity-on-hover;\n          }\n        }\n        &:before {\n          position: absolute;\n          top: 0;\n          left: 0;\n          width: 20px;\n          height: 20px;\n          font-family: $slick-font-family;\n          font-size: $slick-dot-size;\n          line-height: 20px;\n          text-align: center;\n          color: $slick-dot-color;\n          opacity: $slick-opacity-not-active;\n          -webkit-font-smoothing: antialiased;\n          -moz-osx-font-smoothing: grayscale;\n        }\n      }\n      &.slick-active button:before {\n        color: $slick-dot-color-active;\n        opacity: $slick-opacity-default;\n      }\n    }\n  }\n';

;// CONCATENATED MODULE: ./components/core/community/home/stories-slick-carousel/stories-slick-carousel-component.scss.js



var StyledStoriesSlickCarouselComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eywzop90"
})('.items-without-carousel{display:flex;overflow:scroll;-webkit-overflow-scrolling:touch;}.slick-slider{.slick-list{.slick-track{.slick-slide{&.slick-current{z-index:1;// so mouse events will be on current slide. Needed for Fade effect}}}}.slick-arrow{&::before{display:inline-block;content:"";border-width:2px 2px 0 0;border-style:solid;border-color:black;width:8px;height:8px;transform:rotate(45deg);}&.slick-prev{&::before{border-width:0 0 2px 2px;}}}.slick-dots{li{margin:0;button{display:inline-block;width:14px;height:14px;border-radius:50%;border:1px solid #c3c3c3;opacity:1;&::before{display:none;}}&.slick-active{button{background-color:black;}}&:not(.slick-active):hover{button{border-width:2px;}}}}}', slickStyle, "	", slickThemeStyle);

// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
;// CONCATENATED MODULE: ./components/core/community/home/stories-slick-carousel/stories-slick-carousel-component.js





function stories_slick_carousel_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function stories_slick_carousel_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            stories_slick_carousel_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var StoriesSlickCarouselComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(StoriesSlickCarouselComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(StoriesSlickCarouselComponent);
    function StoriesSlickCarouselComponent(props) {
        (0,_class_call_check/* default */.Z)(this, StoriesSlickCarouselComponent);
        var _this;
        _this = _super.call(this, props);
        _this.updateDimensions = _this.updateDimensions.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.state = {
            windowWidth: 0,
            windowHeight: 0
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(StoriesSlickCarouselComponent, [
        {
            /**
   * Add event listener
   */ key: "componentDidMount",
            value: function componentDidMount() {
                this.updateDimensions();
                window.addEventListener("resize", this.updateDimensions);
            }
        },
        {
            /**
   * Remove event listener
   */ key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener("resize", this.updateDimensions);
            }
        },
        {
            /**
   * Calculate & Update state of new dimensions
   */ key: "updateDimensions",
            value: function updateDimensions() {
                this.setState({
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight
                });
            }
        },
        {
            key: "renderItems",
            value: function renderItems() {
                var _props = this.props, items = _props.items, renderItem = _props.renderItem;
                return items.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "carousel-item",
                        children: renderItem(item, index)
                    }, index);
                });
            }
        },
        {
            key: "renderItemsWithCarousel",
            value: function renderItemsWithCarousel(settings) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, _object_spread_props(stories_slick_carousel_component_object_spread({}, settings), {
                    ref: settings.onCarouselMounted,
                    children: this.renderItems()
                }));
            }
        },
        {
            // showing on mobile
            key: "renderItemsWithoutCarousel",
            value: function renderItemsWithoutCarousel(items, renderItem) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "items-without-carousel",
                    children: items.map(function(item, index) {
                        return renderItem(item, index);
                    })
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, items = _this_props.items, renderItem = _this_props.renderItem, minWidthForCarousel = _this_props.minWidthForCarousel, settings = _object_without_properties(_this_props, [
                    "items",
                    "renderItem",
                    "minWidthForCarousel"
                ]);
                var windowWidth = this.state.windowWidth;
                var showCarousel = !windowWidth || windowWidth > minWidthForCarousel;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledStoriesSlickCarouselComponent, {
                    className: classnames_default()("stories-slick-carousel"),
                    children: [
                        showCarousel && this.renderItemsWithCarousel(settings),
                        !showCarousel && this.renderItemsWithoutCarousel(items, renderItem)
                    ]
                });
            }
        }
    ]);
    return StoriesSlickCarouselComponent;
}(react.PureComponent);

StoriesSlickCarouselComponent.defaultProps = {
    dots: true,
    infinite: true,
    fade: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 8000,
    minWidthForCarousel: -1 // if width smaller than that - don't render carousel
};

// EXTERNAL MODULE: ./components/core/colorful-title/colorful-title-component.js
var colorful_title_component = __webpack_require__(34215);
;// CONCATENATED MODULE: ./components/core/videos-carousel/video-carousel-item/video-carousel-item-component.scss.js

var video_carousel_item_component_scss_defaultExport = new String(".video-carousel-item-component{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;.video-part{position:relative;margin:0 16px;-webkit-box-shadow:0 2px 16px 0 rgba(0,0,0,.2);-moz-box-shadow:0 2px 16px 0 rgba(0,0,0,.2);box-shadow:0 2px 16px 0 rgba(0,0,0,.2);-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;cursor:pointer;&:hover{.play-button-container{background-color:".concat(colors/* default.white-smoke */.Z["white-smoke"], "}}.poster-image-wrapper{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;img {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n        }\n      }.play-button-container{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);-o-transform:translate(-50%,-50%);transform:translate(-50%,-50%);width:56px;height:56px;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;background-color:white;-webkit-box-shadow:0 2px 16px 0 rgba(0,0,0,.2);-moz-box-shadow:0 2px 16px 0 rgba(0,0,0,.2);box-shadow:0 2px 16px 0 rgba(0,0,0,.2);pointer-events:none;.play-button{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;border-color:transparent transparent transparent rgb(51,51,51);border-style:solid;border-width:9px 0 9px 14px;position:absolute;left:-webkit-calc(50% + 2px);left:-moz-calc(50% + 2px);left:calc(50% + 2px);top:50%;-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);-o-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}}}&.mobile-layout{.video-part{overflow:hidden;.poster-image-wrapper{position:absolute;top:0;-webkit-transition:opacity.1s ease-out;-moz-transition:opacity.1s ease-out;-o-transition:opacity.1s ease-out;transition:opacity.1s ease-out;opacity:1}.video-component-wrapper{iframe {\n            display: block;\n          }\n          opacity: 0;}}}.title-container.video-title{margin-top:24px;.colorful-title{font-size:.956rem;.colored{font-weight:bold}}}}"));
video_carousel_item_component_scss_defaultExport.__hash = "9176bd70defa8bb3";
/* harmony default export */ var video_carousel_item_component_scss = (video_carousel_item_component_scss_defaultExport);

// EXTERNAL MODULE: ./components/core/youtube-video-with-poster/youtube-video-with-poster-component.js + 1 modules
var youtube_video_with_poster_component = __webpack_require__(86199);
;// CONCATENATED MODULE: ./components/core/videos-carousel/video-carousel-item/video-carousel-item-component.js












var VideoCarouselItemComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(VideoCarouselItemComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(VideoCarouselItemComponent);
    function VideoCarouselItemComponent(props) {
        (0,_class_call_check/* default */.Z)(this, VideoCarouselItemComponent);
        var _this;
        _this = _super.call(this, props);
        _this.onPlayButtonClicked = _this.onPlayButtonClicked.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(VideoCarouselItemComponent, [
        {
            key: "onPlayButtonClicked",
            value: function onPlayButtonClicked() {
                var _props = this.props, onPlay = _props.onPlay, data = _props.data;
                onPlay(data.videoId, data.title);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, data = _props.data, isMobile = _props.isMobile;
                var screenRatios = {
                    mobile: data.mobileImageWidthRatio
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(video_carousel_item_component_scss.__hash) + " " + "video-carousel-item-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(video_carousel_item_component_scss.__hash) + " " + "video-part",
                            children: data.videoId && isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "jsx-".concat(video_carousel_item_component_scss.__hash) + " " + "video-component-wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(youtube_video_with_poster_component/* default */.Z, {
                                    videoId: data.videoId,
                                    poster: data.poster,
                                    muted: false,
                                    volume: 100
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                onClick: this.onPlayButtonClicked,
                                className: "jsx-".concat(video_carousel_item_component_scss.__hash) + " " + "poster-image-wrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                        pictureClass: "poster-image",
                                        src: data.poster,
                                        screenRatios: screenRatios
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "jsx-".concat(video_carousel_item_component_scss.__hash) + " " + "play-button-container",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "jsx-".concat(video_carousel_item_component_scss.__hash) + " " + "play-button"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(colorful_title_component/* default */.Z, {
                            className: "video-title",
                            text: data.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: video_carousel_item_component_scss.__hash,
                            children: video_carousel_item_component_scss
                        })
                    ]
                });
            }
        }
    ]);
    return VideoCarouselItemComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./components/core/carousel-arrow/carousel-round-arrow-component.scss.js

var StyledCarouselRoundArrowComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e12tded20"
})("&.slick-arrow{border-radius:50%;background-color:white;border:1px solid black;width:37px;height:37px;top:calc(50% - 38px);&.slick-prev{left:-64px;&::before{position:absolute;right:11px;top:12px;}}&.slick-next{right:-60px;&::before{position:absolute;right:14px;top:12px;}}}");

;// CONCATENATED MODULE: ./components/core/carousel-arrow/carousel-round-arrow-component.js








var CarouselRoundArrowComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(CarouselRoundArrowComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(CarouselRoundArrowComponent);
    function CarouselRoundArrowComponent(props) {
        (0,_class_call_check/* default */.Z)(this, CarouselRoundArrowComponent);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(CarouselRoundArrowComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, className = _props.className, style = _props.style, onClick = _props.onClick;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCarouselRoundArrowComponent, {
                    className: classnames_default()(className, "carousel-round-arrow"),
                    onClick: onClick
                });
            }
        }
    ]);
    return CarouselRoundArrowComponent;
}(react.PureComponent);


// EXTERNAL MODULE: ./components/core/youtube-video-modal/youtube-video-modal-component.js + 7 modules
var youtube_video_modal_component = __webpack_require__(60202);
// EXTERNAL MODULE: ./node_modules/is-mobile/index.js
var is_mobile = __webpack_require__(63805);
var is_mobile_default = /*#__PURE__*/__webpack_require__.n(is_mobile);
;// CONCATENATED MODULE: ./components/core/videos-carousel/desktop/videos-carousel-desktop-component.js

















var youtubeModalStyle = {
    overlay: {
        backgroundColor: "rgba(0, 0, 0, 0.75)",
        zIndex: "".concat(z_index/* MODAL_BACKGROUND */.AE)
    },
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        transform: "translate(-50%, -50%)",
        padding: "0",
        border: "none",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "transparent",
        minWidth: "960px",
        overflow: "visible",
        borderRadius: "4px"
    }
};
var VideosCarouselDesktopComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(VideosCarouselDesktopComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(VideosCarouselDesktopComponent);
    function VideosCarouselDesktopComponent(props) {
        (0,_class_call_check/* default */.Z)(this, VideosCarouselDesktopComponent);
        var _this;
        _this = _super.call(this, props);
        _this.closeModal = _this.closeModal.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onPlay = _this.onPlay.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.renderItem = _this.renderItem.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.state = {
            videoId: null,
            videoTitle: null
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(VideosCarouselDesktopComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.isMobile = is_mobile_default()();
            }
        },
        {
            key: "renderItem",
            value: function renderItem(currentItem, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoCarouselItemComponent, {
                    data: currentItem,
                    onPlay: this.onPlay,
                    isMobile: this.isMobile
                }, index);
            }
        },
        {
            key: "onPlay",
            value: function onPlay(videoId, title) {
                BigBrain("track", bigbrain_event_types.YOUTUBE_MODAL_OPEN, {
                    kind: title
                });
                this.setState({
                    videoId: videoId,
                    videoTitle: title
                });
            }
        },
        {
            key: "closeModal",
            value: function closeModal() {
                var videoTitle = this.state.videoTitle;
                BigBrain("track", bigbrain_event_types.YOUTUBE_MODAL_CLOSE, {
                    kind: videoTitle
                });
                this.setState({
                    videoId: null,
                    videoTitle: null
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, videos = _props.videos, title = _props.title;
                var videoId = this.state.videoId;
                var responsive = [
                    {
                        breakpoint: 1250,
                        settings: {
                            slidesToShow: Math.min(2, videos.length)
                        }
                    },
                    {
                        breakpoint: 1150,
                        settings: {
                            className: "center",
                            centerMode: true,
                            infinite: false,
                            focusOnSelect: true,
                            initialSlide: Math.min(1, videos.length),
                            variableWidth: false,
                            slidesToShow: Math.min(1, videos.length)
                        }
                    }
                ];
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(videos_carousel_desktop_component_scss.__hash) + " " + "video-carousel-desktop-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(videos_carousel_desktop_component_scss.__hash) + " " + "video-carousel-title",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(colorful_title_component/* default */.Z, {
                                text: title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StoriesSlickCarouselComponent, {
                            autoplay: false,
                            infinite: false,
                            items: videos,
                            renderItem: this.renderItem,
                            responsive: responsive,
                            slidesToShow: Math.min(3, videos.length),
                            slidesToScroll: 1,
                            dots: false,
                            nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselRoundArrowComponent, {}),
                            prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselRoundArrowComponent, {}),
                            minWidthForCarousel: 768
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(youtube_video_modal_component/* default */.Z, {
                            footerText: "Simplify the way your team works",
                            videoId: videoId,
                            minHeight: 546,
                            isOpen: !!videoId,
                            opts: {
                                width: 970,
                                height: 546,
                                playerVars: {
                                    autoplay: 1,
                                    rel: 0,
                                    showinfo: 0
                                }
                            },
                            onCloseModal: this.closeModal,
                            style: youtubeModalStyle,
                            withSignup: false
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: videos_carousel_desktop_component_scss.__hash,
                            children: videos_carousel_desktop_component_scss
                        })
                    ]
                });
            }
        }
    ]);
    return VideosCarouselDesktopComponent;
}(react.PureComponent);

VideosCarouselDesktopComponent.defaultProps = {
    videos: []
};

;// CONCATENATED MODULE: ./components/core/videos-carousel/videos-carousel-component.js




function videos_carousel_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function videos_carousel_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            videos_carousel_component_define_property(target, key, source[key]);
        });
    }
    return target;
}



var VideosCarouselComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(VideosCarouselComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(VideosCarouselComponent);
    function VideosCarouselComponent() {
        (0,_class_call_check/* default */.Z)(this, VideosCarouselComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(VideosCarouselComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "videos-carousel-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "videos-carousel-desktop-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideosCarouselDesktopComponent, videos_carousel_component_object_spread({}, this.props))
                    })
                });
            }
        }
    ]);
    return VideosCarouselComponent;
}(react.PureComponent);

VideosCarouselComponent.defaultProps = {
    title: "A new way to manage your <brand-purple>workflow.</end>",
    videos: [
        {
            title: "Nate Travers <brand-blue>Manufactoring</end>",
            videoId: "1UbaEcto56k",
            poster: "/static/img/templates/long-template/segments/boards/board-with-cactus-and-phone.png"
        },
        {
            title: "Aleah Jean Rosales <brand-green>Creative</end>",
            videoId: "1UbaEcto56k",
            poster: "/static/img/templates/long-template/segments/boards/board-with-timeline-and-cactus.png"
        },
        {
            title: "Brad Wohlgemuth <brand-pink>Broadcast</end>",
            videoId: "1UbaEcto56k",
            poster: "/static/img/templates/long-template/segments/boards/board-with-pencils.png"
        }
    ]
};

;// CONCATENATED MODULE: ./components/segments/videos-carousel/videos-carousel-segment-component.js




function videos_carousel_segment_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function videos_carousel_segment_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            videos_carousel_segment_component_define_property(target, key, source[key]);
        });
    }
    return target;
}



var VideosCarouselSegmentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(VideosCarouselSegmentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(VideosCarouselSegmentComponent);
    function VideosCarouselSegmentComponent() {
        (0,_class_call_check/* default */.Z)(this, VideosCarouselSegmentComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(VideosCarouselSegmentComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "video-carousel-segment",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideosCarouselComponent, videos_carousel_segment_component_object_spread({}, this.props))
                });
            }
        }
    ]);
    return VideosCarouselSegmentComponent;
}(react.PureComponent);


// EXTERNAL MODULE: ./components/core/paragraph/paragraph-component.js + 1 modules
var paragraph_component = __webpack_require__(94950);
;// CONCATENATED MODULE: ./components/segments/board-views/board-views-component.scss.js


var StyledBoardViewsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eonel7a0"
})(".lottie-gallery-wrapper{display:flex;flex-wrap:wrap;justify-content:center;margin-top:24px;}.paragraph-component{.body{max-width:650px;}}");
var StylesLottieItemWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eonel7a1"
})("max-width:300px;margin:16px;box-shadow:0 8px 16px 0 rgba(0,0,0,0.1);border-radius:8px;a{display:block;text-decoration:none;color:", colors/* default.black */.Z.black, ";}.board-view-item-text{padding:16px;text-align:center;}.board-view-item-title{margin-bottom:8px;}");

// EXTERNAL MODULE: ./components/core/lottie/lottie-component.js + 1 modules
var lottie_component = __webpack_require__(94703);
;// CONCATENATED MODULE: ./components/segments/board-views/board-views-component.js





function board_views_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function board_views_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            board_views_component_define_property(target, key, source[key]);
        });
    }
    return target;
}





var BOARD_VIEWS_ANIMATIONS = [
    {
        jsonPath: "/static/lottie/board-views/calendar.json",
        title: "boardView.calendar",
        href: "/features"
    },
    {
        jsonPath: "/static/lottie/board-views/graph.json",
        title: "boardView.chart",
        href: "/features"
    },
    {
        jsonPath: "/static/lottie/board-views/files.json",
        title: "boardView.files",
        href: "/features"
    },
    {
        jsonPath: "/static/lottie/board-views/kanban.json",
        title: "boardView.kanban",
        href: "/features"
    },
    {
        jsonPath: "/static/lottie/board-views/map.json",
        title: "boardView.map",
        href: "/features"
    },
    {
        jsonPath: "/static/lottie/board-views/timeline.json",
        title: "boardView.timeline",
        href: "/features"
    }
];
var BoardViewsComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BoardViewsComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BoardViewsComponent);
    function BoardViewsComponent(props) {
        (0,_class_call_check/* default */.Z)(this, BoardViewsComponent);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            playAnimation: null
        };
        _this.stopAnimation = _this.stopAnimation.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(BoardViewsComponent, [
        {
            key: "stopAnimation",
            value: function stopAnimation() {
                this.setState({
                    playAnimation: null
                });
            }
        },
        {
            key: "playAnimation",
            value: function playAnimation(animation) {
                this.setState({
                    playAnimation: animation
                });
            }
        },
        {
            key: "renderAnimatedGallery",
            value: function renderAnimatedGallery() {
                var _this = this;
                var translate = this.props.translate;
                return BOARD_VIEWS_ANIMATIONS.map(function(lottieAnimation) {
                    var shouldPlay = _this.state.playAnimation === lottieAnimation.jsonPath;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StylesLottieItemWrapper, {
                        className: "lottie-item-wrapper",
                        onMouseEnter: _this.playAnimation.bind(_this, lottieAnimation.jsonPath),
                        onMouseLeave: _this.stopAnimation,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: lottieAnimation.href,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(lottie_component/* default */.Z, {
                                    jsonPath: lottieAnimation.jsonPath,
                                    autoplay: false,
                                    shouldPlay: shouldPlay,
                                    shouldPause: !shouldPlay,
                                    loop: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "board-view-item-text",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "board-view-item-title",
                                        children: translate(lottieAnimation.title)
                                    })
                                })
                            ]
                        })
                    }, lottieAnimation.jsonPath);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBoardViewsComponent, {
                    className: "board-views-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "paragraph-with-logos-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph_component/* default */.Z, board_views_component_object_spread({}, this.props.paragraph))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "lottie-gallery-wrapper",
                            children: this.renderAnimatedGallery()
                        })
                    ]
                });
            }
        }
    ]);
    return BoardViewsComponent;
}(react.PureComponent);

BoardViewsComponent.defaultProps = {
    paragraph: {
        topic: {
            text: "Plan and track visually",
            color: "brand-red"
        },
        title: "Know where everything stands",
        body: [
            "Track all your team work and know where everything stand in a glance.",
            "Choose the best view for you that will boost your productivity."
        ],
        textDirection: "center"
    }
};

// EXTERNAL MODULE: ./components/core/video/video-component.js + 1 modules
var video_component = __webpack_require__(3773);
// EXTERNAL MODULE: ./static/svg/decorators/signup/signup-decoration-right.svg
var signup_decoration_right = __webpack_require__(59365);
;// CONCATENATED MODULE: ./components/segments/embedded-form/embedded-form-component.js


var BASE_FORM_URL = "https://forms.monday.com/forms/embed";
var FORM_IFRAME = "formIframe";
var EmbeddedFormComponent = function(props) {
    var _iframe = (0,react.useRef)(null);
    var _columnsMappingFromParams = props.columnsMappingFromParams, columnsMappingFromParams = _columnsMappingFromParams === void 0 ? [] : _columnsMappingFromParams, formToken = props.formToken, width = props.width, height = props.height, boxShadow = props.boxShadow, marginTop = props.marginTop, marginLeft = props.marginLeft, position = props.position, borderRadius = props.borderRadius, paddingTop = props.paddingTop;
    var getUrlParameter = function(name) {
        var parsedName = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]".concat(parsedName, "=([^&#]*)"));
        var results = regex.exec(location.search);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    };
    var appendQueryParamByColumnId = function(queryParams, column) {
        var columnId = column.columnId, columnParamName = column.columnParamName;
        queryParams[columnId] = getUrlParameter(columnParamName);
        return queryParams;
    };
    var addDataFromParameter = function(data) {
        return columnsMappingFromParams.reduce(appendQueryParamByColumnId, data);
    };
    var sendPlaceholderAndSource = function() {
        var _iframe_current_contentWindow, _iframe_current;
        _iframe === null || _iframe === void 0 ? void 0 : (_iframe_current = _iframe.current) === null || _iframe_current === void 0 ? void 0 : (_iframe_current_contentWindow = _iframe_current.contentWindow) === null || _iframe_current_contentWindow === void 0 ? void 0 : _iframe_current_contentWindow.postMessage({
            formIframe: FORM_IFRAME,
            formData: addDataFromParameter({})
        }, "*");
    };
    var formURL = "".concat(BASE_FORM_URL, "/").concat(formToken);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "embedded-form-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
            ref: _iframe,
            src: formURL,
            style: {
                width: width,
                height: height,
                boxShadow: boxShadow,
                marginTop: marginTop,
                marginLeft: marginLeft,
                position: position,
                borderRadius: borderRadius,
                paddingTop: paddingTop
            },
            frameBorder: "0",
            onLoad: sendPlaceholderAndSource
        })
    });
};
/* harmony default export */ var embedded_form_component = (EmbeddedFormComponent);

;// CONCATENATED MODULE: ./components/segments/form-with-text-and-assets/form-with-text-and-assets-component.js




function form_with_text_and_assets_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function form_with_text_and_assets_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            form_with_text_and_assets_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function form_with_text_and_assets_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function form_with_text_and_assets_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        form_with_text_and_assets_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var FormWithTextAndAssetsComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(FormWithTextAndAssetsComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(FormWithTextAndAssetsComponent);
    function FormWithTextAndAssetsComponent(props) {
        (0,_class_call_check/* default */.Z)(this, FormWithTextAndAssetsComponent);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(FormWithTextAndAssetsComponent, [
        {
            key: "renderParagraph",
            value: function renderParagraph() {
                var _props = this.props, paragraph = _props.paragraph, marginBottomParagraph = _props.marginBottomParagraph;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        marginBottom: marginBottomParagraph
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph_component/* default */.Z, form_with_text_and_assets_component_object_spread({}, paragraph))
                });
            }
        },
        {
            key: "renderVideo",
            value: function renderVideo() {
                var video = this.props.video;
                if (video && video.src) {
                    var formats = video.src.formats;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(video_component/* default */.Z, form_with_text_and_assets_component_object_spread_props(form_with_text_and_assets_component_object_spread({}, video, video.src), {
                        formats: formats
                    }));
                }
            }
        },
        {
            key: "renderForm",
            value: function renderForm() {
                var _props = this.props, formToken = _props.formToken, width = _props.width, height = _props.height, boxShadow = _props.boxShadow, marginLeft = _props.marginLeft, borderRadius = _props.borderRadius, showFormDecorations = _props.showFormDecorations, columnsMappingFromParams = _props.columnsMappingFromParams;
                var circle = this.props.circle;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "embedded-form-component",
                    style: {
                        width: width,
                        height: height,
                        boxShadow: boxShadow,
                        marginLeft: marginLeft,
                        position: "relative",
                        borderRadius: borderRadius
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: form_with_text_and_assets_component_object_spread({}, circle)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(embedded_form_component, {
                            formToken: formToken,
                            width: width,
                            height: height,
                            columnsMappingFromParams: columnsMappingFromParams
                        }),
                        showFormDecorations && /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_decoration_right/* default */.Z, {
                            style: {
                                transform: "rotate(-25deg)",
                                position: "absolute",
                                top: "-20px",
                                left: "92%"
                            }
                        }, "right-decoration")
                    ]
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, marginTop = _props.marginTop, marginTopAsset = _props.marginTopAsset;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "paragaph-and-asset-component",
                        style: {
                            marginTop: marginTop,
                            display: "flex",
                            flexWrap: "wrap",
                            margin: "4px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    display: "block",
                                    marginTop: marginTopAsset,
                                    maxWidth: "50%"
                                },
                                children: [
                                    this.renderParagraph(),
                                    this.renderVideo()
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    display: "flex"
                                },
                                children: this.renderForm()
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return FormWithTextAndAssetsComponent;
}(react.PureComponent);

FormWithTextAndAssetsComponent.defaultProps = {
    content: {
        topic: {
            text: "Simple and intuitive",
            color: "brand-blue"
        },
        title: "Easy onboarding, fast adoption",
        body: [
            "Getting your team onboard recuires sending an invatation, and that’s it! It’s so visual and easy to use your teammates will get hooked immediatly."
        ],
        bottomLink: {
            href: "/",
            text: "See all features"
        }
    },
    asset: {
        side: "right",
        shadow: false
    }
};

;// CONCATENATED MODULE: ./components/core/boards-and-quotes-carousel/boards-carousel/boards-carousel-component.scss.js




var desktopSlickSize = vp_sizes/* MAX_DESKTOP_CONTENT_WIDTH */.O$ - 200;
var StyledBoardsCarouselComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e3vuhmr0"
})(".boards-carousel-frame{.stories-slick-carousel{.slick-slider{width:100%;}.slick-list{overflow:visible;}.slick-arrow{z-index:", z_index/* TOP_LAYER */.nA, ";top:100px;border:1.5px solid black;&.slick-prev{left:25px;}&.slick-next{right:25px;}&:hover{border-color:", colors/* default.brand-dark-blue */.Z["brand-dark-blue"], ";&.slick-prev{&::before{border-color:", colors/* default.brand-dark-blue */.Z["brand-dark-blue"], ";}}&.slick-next{&::before{border-color:", colors/* default.brand-dark-blue */.Z["brand-dark-blue"], ";}}}}}.slick-slide{cursor:grab;width:", desktopSlickSize, "px;transition:opacity 0.8s ease;opacity:0.3;cursor:grab;.quote-component{transition:opacity 0.8s ease;opacity:0;}.board-carousel-image{border:none;}&.slick-center{opacity:1;.quote-component{opacity:1;}.board-carousel-image{border:2px solid;}}&:active{cursor:grabbing;}}.custom-arrows{position:absolute;display:flex;justify-content:flex-end;top:82%;right:70px;width:100%;max-width:", desktopSlickSize, "px;}.custom-arrow{font-size:1.688rem;top:50%;cursor:pointer;z-index:1;width:36px;height:36px;border-radius:50%;border:1px solid;display:flex;justify-content:center;align-items:center;background:white;&:hover{border-color:", colors/* default.brand-dark-blue */.Z["brand-dark-blue"], ";svg{fill:", colors/* default.brand-dark-blue */.Z["brand-dark-blue"], ";}}&.left-arrow{margin-right:16px;}}.board-carousel-item{.board-carousel-image-wrapper{padding:24px;margin-bottom:8px;.board-carousel-image{width:100%;margin:0px auto;background-size:contain;background-position:center;background-repeat:no-repeat;transition:all 0.2s ease;box-shadow:0 0 40px 0 rgba(0,0,0,0.1);}}}.stop-area{position:absolute;bottom:0px;height:300px;left:0px;right:0px;pointer-events:none;}&.remove-border{.slick-slide{&.slick-center{.board-carousel-image{box-shadow:none;border:none;}}}.board-carousel-item .board-carousel-image-wrapper .board-carousel-image{box-shadow:none;}}@media (min-width:", vp_sizes/* FOLD_TEST_MAX_WIDTH */.LM, "){&.above-the-fold{.slick-slide{opacity:0;cursor:default;&.slick-center{opacity:1;cursor:grab;}}}}}@media (max-width:", vp_sizes/* MAX_DESKTOP_CONTENT_WIDTH */.O$, "px){.boards-carousel-frame{.slick-slide{width:800px;}.custom-arrows{right:60px;}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){padding-bottom:8px;.boards-carousel-frame{position:relative;.items-without-carousel{width:100vw;overflow-x:scroll;overflow-y:hidden;}.custom-arrow{display:none;}.board-carousel-item{min-width:85vw;margin-right:-24px;.board-carousel-image-wrapper{margin-bottom:16px;}}}}");

;// CONCATENATED MODULE: ./static/svg/arrow-left-no-fill.svg
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgArrowLeftNoFill = function SvgArrowLeftNoFill(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 14,
        viewBox: "0 0 8 14"
    }, props), _path || (_path = /*#__PURE__*/ react.createElement("path", {
        d: "M7.687 12.045 2.574 6.933l5.113-5.112A1.065 1.065 0 1 0 6.18.312L.313 6.18a1.064 1.064 0 0 0 0 1.508l5.867 5.867a1.065 1.065 0 1 0 1.507-1.508"
    })));
};
/* harmony default export */ var arrow_left_no_fill = (SvgArrowLeftNoFill);

;// CONCATENATED MODULE: ./static/svg/arrow-right2.svg
var arrow_right2_path;
function arrow_right2_extends() {
    arrow_right2_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return arrow_right2_extends.apply(this, arguments);
}

var SvgArrowRight2 = function SvgArrowRight2(props) {
    return /*#__PURE__*/ react.createElement("svg", arrow_right2_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 14,
        viewBox: "0 0 8 14"
    }, props), arrow_right2_path || (arrow_right2_path = /*#__PURE__*/ react.createElement("path", {
        d: "m.313 12.045 5.113-5.112L.313 1.821A1.065 1.065 0 1 1 1.82.312L7.687 6.18a1.064 1.064 0 0 1 0 1.508L1.82 13.554a1.065 1.065 0 1 1-1.507-1.508"
    })));
};
/* harmony default export */ var arrow_right2 = (SvgArrowRight2);

// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/visibility-sensor.js
var visibility_sensor = __webpack_require__(51529);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./utils/mobile.js
var mobile = __webpack_require__(34955);
// EXTERNAL MODULE: ./services/community/url-service.js
var url_service = __webpack_require__(932);
;// CONCATENATED MODULE: ./components/core/boards-and-quotes-carousel/quote/quote-component.scss.js


var quote_component_scss_componentStyles = new String(".quote-component.jsx-ce5357416a557620{.quote-component-inner.jsx-ce5357416a557620{max-width:900px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;padding:0 20px;.person-image-section.jsx-ce5357416a557620{-webkit-flex-basis:70px;-ms-flex-preferred-size:70px;flex-basis:70px;margin-right:32px;position:relative;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;.person-image{width:70px;height:70px;-webkit-background-size:contain;-moz-background-size:contain;-o-background-size:contain;background-size:contain;background-position:center;background-repeat:no-repeat;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;-webkit-box-shadow:0 2px 16px rgba(0,0,0,.2);-moz-box-shadow:0 2px 16px rgba(0,0,0,.2);box-shadow:0 2px 16px rgba(0,0,0,.2)}}.person-text-setcion.jsx-ce5357416a557620{width:80%;.title.jsx-ce5357416a557620{font-size:.875rem;font-weight:500;margin-bottom:16px}.person-quote.jsx-ce5357416a557620{margin-bottom:16px;font-size:1.125rem;line-height:26px}.person-title.jsx-ce5357416a557620{font-size:.875rem;color:#a1a1a1}}@media(min-width:".concat(vp_sizes/* FOLD_TEST_MAX_WIDTH */.LM, "){&.above-the-fold.jsx-ce5357416a557620{max-width:600px;.person-text-setcion.jsx-ce5357416a557620{.person-quote.jsx-ce5357416a557620{font-size:.875rem}}}}}}@media(max-width:").concat(vp_sizes/* MAX_DESKTOP_CONTENT_WIDTH */.O$ + "px", "){.quote-component.jsx-ce5357416a557620{.quote-component-inner.jsx-ce5357416a557620{.person-text-setcion.jsx-ce5357416a557620{width:70%}}}}@media(max-width:").concat(vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.quote-component.jsx-ce5357416a557620{.quote-component-inner.jsx-ce5357416a557620{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-align:center;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;.person-text-setcion.jsx-ce5357416a557620{.person-quote.jsx-ce5357416a557620{font-size:1rem}}.person-image-section.jsx-ce5357416a557620{margin:0px auto 8px auto;.person-image{width:80px;height:80px;margin-bottom:16px}}}}}"));
quote_component_scss_componentStyles.__hash = "ce5357416a557620";

;// CONCATENATED MODULE: ./components/core/boards-and-quotes-carousel/quote/quote-component.js











var QuoteComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(QuoteComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(QuoteComponent);
    function QuoteComponent() {
        (0,_class_call_check/* default */.Z)(this, QuoteComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(QuoteComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, activeQuote = _props.activeQuote, aboveTheFold = _props.aboveTheFold;
                var personImage = activeQuote.personImage, personTitle = activeQuote.personTitle, quoteText = activeQuote.quoteText, title = activeQuote.title, color = activeQuote.color;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(quote_component_scss_componentStyles.__hash) + " " + "quote-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-".concat(quote_component_scss_componentStyles.__hash) + " " + (classnames_default()("quote-component-inner", {
                                "above-the-fold": aboveTheFold
                            }) || ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-".concat(quote_component_scss_componentStyles.__hash) + " " + "person-image-section",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                        className: "person-image",
                                        src: personImage,
                                        extraCloudinaryTransformations: {
                                            height: 100,
                                            width: 100
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "jsx-".concat(quote_component_scss_componentStyles.__hash) + " " + "person-text-setcion",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                color: colors/* default */.Z[color]
                                            },
                                            className: "jsx-".concat(quote_component_scss_componentStyles.__hash) + " " + "title",
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "jsx-".concat(quote_component_scss_componentStyles.__hash) + " " + "person-quote",
                                            children: quoteText
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "jsx-".concat(quote_component_scss_componentStyles.__hash) + " " + "person-title",
                                            children: personTitle
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: quote_component_scss_componentStyles.__hash,
                            children: quote_component_scss_componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return QuoteComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./components/core/boards-and-quotes-carousel/boards-carousel/boards-carousel-item/boards-carousel-item-component.js









var BoardsCarouselItemComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BoardsCarouselItemComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BoardsCarouselItemComponent);
    function BoardsCarouselItemComponent(props) {
        (0,_class_call_check/* default */.Z)(this, BoardsCarouselItemComponent);
        var _this;
        _this = _super.call(this, props);
        _this.onClick = _this.onClick.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(BoardsCarouselItemComponent, [
        {
            key: "onClick",
            value: function onClick() {
                var _props = this.props, index = _props.index, onClick1 = _props.onClick;
                onClick1(index);
            }
        },
        {
            key: "shouldRenderQuote",
            value: function shouldRenderQuote() {
                var item = this.props.item;
                var personImage = item.personImage, personTitle = item.personTitle, quoteText = item.quoteText;
                return personImage || personTitle || quoteText;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, index = _props.index, url = _props.url, borderColor = _props.borderColor, item = _props.item, aboveTheFold = _props.aboveTheFold;
                var mobileImageWidthRatio = item.mobileImageWidthRatio;
                var screenRatios = {
                    mobile: mobileImageWidthRatio
                };
                var renderQuote = this.shouldRenderQuote();
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "board-carousel-item-component board-carousel-item",
                    onClick: this.onClick,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "board-carousel-image-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                className: "board-carousel-image",
                                src: url,
                                specificImageStyle: {
                                    borderColor: borderColor
                                },
                                screenRatios: screenRatios
                            })
                        }),
                        renderQuote && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuoteComponent, {
                            activeQuote: item,
                            aboveTheFold: aboveTheFold
                        })
                    ]
                }, index);
            }
        }
    ]);
    return BoardsCarouselItemComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./components/core/boards-and-quotes-carousel/boards-carousel/boards-carousel-component.js





















var mod = function(x, y) {
    return (x % y + y) % y;
};
var BoardsCarouselComponent = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(BoardsCarouselComponent, Component);
    var _super = (0,_create_super/* default */.Z)(BoardsCarouselComponent);
    function BoardsCarouselComponent(props) {
        (0,_class_call_check/* default */.Z)(this, BoardsCarouselComponent);
        var _this;
        _this = _super.call(this, props);
        _this.state = {};
        _this.onCarouselMounted = _this.onCarouselMounted.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.beforeChange = _this.beforeChange.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.renderItem = _this.renderItem.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onItemClick = _this.onItemClick.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onLeftClick = _this.onLeftClick.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onRightClick = _this.onRightClick.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onVisibilityChange = _this.onVisibilityChange.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(BoardsCarouselComponent, [
        {
            key: "onVisibilityChange",
            value: function onVisibilityChange(visible, data) {
                var _props = this.props, stopAutoSlide = _props.stopAutoSlide, startAutoSlide = _props.startAutoSlide;
                if (stopAutoSlide && startAutoSlide) {
                    visible ? stopAutoSlide() : startAutoSlide();
                }
            }
        },
        {
            key: "renderItem",
            value: function renderItem(item, index) {
                var aboveTheFold = this.props.aboveTheFold;
                var url = (0,url_service.fixDevImageUrl)(item.boardImage);
                var borderColor = !(0,mobile/* isMobile */.tq)() ? colors/* default */.Z[item.color] : "none";
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(BoardsCarouselItemComponent, {
                    index: index,
                    url: url,
                    borderColor: borderColor,
                    item: item,
                    onClick: this.onItemClick,
                    aboveTheFold: aboveTheFold
                }, index);
            }
        },
        {
            key: "onCarouselMounted",
            value: function onCarouselMounted(el) {
                this._carousel = el;
            }
        },
        {
            key: "onLeftClick",
            value: function onLeftClick() {
                var changing = this.state.changing;
                if (changing) return;
                var _props = this.props, setActive = _props.setActive, active = _props.active, quotes = _props.quotes;
                var nextActive = mod(active - 1, quotes.length);
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.CAROUSEL_SWITCH_BOARD_CLICKED, {
                    kind: "quotesArrow"
                });
                setActive(nextActive);
            }
        },
        {
            key: "onRightClick",
            value: function onRightClick() {
                var changing = this.state.changing;
                if (changing) return;
                var _props = this.props, setActive = _props.setActive, active = _props.active, quotes = _props.quotes;
                var nextActive = mod(active + 1, quotes.length);
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.CAROUSEL_SWITCH_BOARD_CLICKED, {
                    kind: "quotesArrow"
                });
                setActive(nextActive);
            }
        },
        {
            key: "beforeChange",
            value: function beforeChange(prevIndex, nextIndex) {
                var _props = this.props, setActive = _props.setActive, active = _props.active;
                this.currentActiveSlide = nextIndex;
                if (!(0,mobile/* isMobile */.tq)() && active != nextIndex) {
                    setActive(nextIndex);
                }
            }
        },
        {
            key: "slideTo",
            value: function slideTo(prev, current) {
                var n = this.props.quotes.length;
                if (!this._carousel) return;
                if (current == (prev + 1) % n) {
                    this._carousel.slickNext();
                } else if (current == ((prev - 1) % n + n) % n) {
                    this._carousel.slickPrev();
                } else {
                    this._carousel.slickGoTo(current);
                }
            }
        },
        {
            key: "onItemClick",
            value: function onItemClick(itemIndex) {
                var active = this.props.active;
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.CAROUSEL_SWITCH_BOARD_CLICKED, {
                    kind: "boardClicked"
                });
                this.slideTo(active, itemIndex);
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var active = nextProps.active, showNavigationArrows = nextProps.showNavigationArrows;
                return this.currentActiveSlide !== active || showNavigationArrows !== this.props.showNavigationArrows;
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var prev = prevProps.active;
                var current = this.props.active;
                this.slideTo(prev, current);
            }
        },
        {
            key: "multipleQuotes",
            value: function multipleQuotes() {
                var quotes = this.props.quotes;
                if (!quotes) return false;
                return quotes.length > 1;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, quotes = _props.quotes, active = _props.active, showNavigationArrows = _props.showNavigationArrows, removeBoardBorder = _props.removeBoardBorder, aboveTheFold = _props.aboveTheFold;
                var renderNavigationArrows = this.multipleQuotes() && showNavigationArrows;
                var showBoardsArrows = this.multipleQuotes() && !showNavigationArrows;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBoardsCarouselComponent, {
                    className: "boards-carousel-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()("boards-carousel-frame", {
                            "remove-border": removeBoardBorder,
                            "above-the-fold": aboveTheFold
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StoriesSlickCarouselComponent, {
                                autoplay: false,
                                items: quotes,
                                renderItem: this.renderItem,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                dots: false,
                                onCarouselMounted: this.onCarouselMounted,
                                initialSlide: active,
                                variableWidth: false,
                                active: true,
                                speed: 800,
                                minWidthForCarousel: vp_sizes.XS,
                                beforeChange: this.beforeChange,
                                arrows: showBoardsArrows,
                                centerMode: true,
                                nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselRoundArrowComponent, {}),
                                prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselRoundArrowComponent, {})
                            }),
                            renderNavigationArrows && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "custom-arrows",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "custom-arrow left-arrow",
                                        onClick: this.onLeftClick,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_left_no_fill, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "custom-arrow right-arrow",
                                        onClick: this.onRightClick,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right2, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
                                partialVisibility: false,
                                onChange: this.onVisibilityChange,
                                active: true,
                                scrollCheck: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "stop-area"
                                })
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return BoardsCarouselComponent;
}(react.Component);

BoardsCarouselComponent.defaultProps = {
    showNavigationArrows: true,
    removeBoardBorder: false
};

;// CONCATENATED MODULE: ./components/core/boards-and-quotes-carousel/boards-and-quotes-carousel-component.scss.js

var StyledBoardsAndQoutesCarouselComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1t6l8i00"
})(".boards-carousel-wrapper{position:relative;}.people-carousel-wrapper{margin-top:60px;}");

;// CONCATENATED MODULE: ./components/core/boards-and-quotes-carousel/boards-and-quotes-carousel-component.js









var BoardsAndQoutesCarouselComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BoardsAndQoutesCarouselComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BoardsAndQoutesCarouselComponent);
    function BoardsAndQoutesCarouselComponent(props) {
        (0,_class_call_check/* default */.Z)(this, BoardsAndQoutesCarouselComponent);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            active: 0
        };
        _this.setActive = _this.setActive.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(BoardsAndQoutesCarouselComponent, [
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                if (nextProps.activeIndex != this.state.active) {
                    this.setState({
                        active: nextProps.activeIndex
                    });
                }
            }
        },
        {
            key: "setActive",
            value: function setActive(active) {
                var setActive1 = this.props.setActive;
                if (setActive1) {
                    setActive1(active);
                } else {
                    this.setState({
                        active: active
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, quotes = _props.quotes, stopAutoSlide = _props.stopAutoSlide, startAutoSlide = _props.startAutoSlide, showNavigationArrows = _props.showNavigationArrows, removeBoardBorder = _props.removeBoardBorder, aboveTheFold = _props.aboveTheFold;
                var active = Math.min(quotes.length - 1, this.state.active);
                if (!quotes[active]) return false;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBoardsAndQoutesCarouselComponent, {
                    className: "boards-and-quotes-carousel-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "boards-carousel-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BoardsCarouselComponent, {
                            quotes: quotes,
                            active: active,
                            setActive: this.setActive,
                            stopAutoSlide: stopAutoSlide,
                            startAutoSlide: startAutoSlide,
                            showNavigationArrows: showNavigationArrows,
                            removeBoardBorder: removeBoardBorder,
                            aboveTheFold: aboveTheFold
                        })
                    })
                });
            }
        }
    ]);
    return BoardsAndQoutesCarouselComponent;
}(react.PureComponent);

BoardsAndQoutesCarouselComponent.defaultProps = {
    quotes: []
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./components/core/switching-words/switching-words-component.scss.js

var StyledSwitchingWordsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eiytq4h0"
})('@keyframes animateEntrance{0%{opacity:0;transform:translate(0px,-40px);}50%{opacity:0;}100%{opacity:1;transform:translate(0px,0px);}}@keyframes animateExit{0%{opacity:1;transform:translate(0px,0px);}37%{transform:translate(0px,-10px);}75%{transform:translate(0px,51px);}100%{opacity:1;transform:translate(0px,60px);}}position:relative;align-self:stretch;text-align:left;&:after{content:"";position:absolute;background:#fff;left:0;bottom:-74px;width:400px;height:68px;}.switching-word-item-wrapper{position:absolute;top:0;&.active:not(.animate-entrance):not(.animate-exit){opacity:1;}&.animate-entrance{animation-name:animateEntrance;animation-duration:0.8s;animation-iteration-count:1;animation-timing-function:cubic-bezier(0.58,0.1,0.6,1.26);}&.animate-exit{animation-name:animateExit;animation-duration:0.8s;animation-iteration-count:1;animation-timing-function:cubic-bezier(0,0,0,0.91);}&:not(.animate-entrance){opacity:0;}}');

;// CONCATENATED MODULE: ./components/core/switching-words/switching-words-component.js










var SwitchingWordsComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SwitchingWordsComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SwitchingWordsComponent);
    function SwitchingWordsComponent(props) {
        (0,_class_call_check/* default */.Z)(this, SwitchingWordsComponent);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            activeIndex: props.activeIndex,
            prevActiveIndex: null
        };
        _this._isMounted = false;
        _this.changeActiveIndex = _this.changeActiveIndex.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.renderWord = _this.renderWord.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this._changeActiveIndexInterval = null;
        return _this;
    }
    (0,_create_class/* default */.Z)(SwitchingWordsComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var animationInterval = this.props.animationInterval;
                if (animationInterval) {
                    this._changeActiveIndexInterval = setInterval(this.changeActiveIndex, animationInterval);
                }
                this._isMounted = true;
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                clearInterval(this._changeActiveIndexInterval);
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                if (nextProps.activeIndex != this.state.activeIndex) {
                    this.setState({
                        activeIndex: nextProps.activeIndex,
                        prevActiveIndex: this.state.activeIndex
                    });
                }
            }
        },
        {
            key: "changeActiveIndex",
            value: function changeActiveIndex() {
                var words = this.props.words;
                var activeIndex = this.state.activeIndex;
                var nextActiveIndex = (activeIndex + 1) % words.length;
                this.setState({
                    activeIndex: nextActiveIndex,
                    prevActiveIndex: activeIndex
                });
            }
        },
        {
            key: "shouldAnimateWordEntrance",
            value: function shouldAnimateWordEntrance(wordIndex) {
                var skipAnimation = this.props.skipAnimation;
                if (skipAnimation) return false;
                var activeIndex = this.state.activeIndex;
                return activeIndex === wordIndex && this._isMounted;
            }
        },
        {
            key: "shouldAnimateWordExit",
            value: function shouldAnimateWordExit(wordIndex) {
                var skipAnimation = this.props.skipAnimation;
                if (skipAnimation) return false;
                var _state = this.state, activeIndex = _state.activeIndex, prevActiveIndex = _state.prevActiveIndex;
                return prevActiveIndex === wordIndex && this._isMounted;
            }
        },
        {
            key: "renderWord",
            value: function renderWord(word, index) {
                var _state = this.state, activeIndex = _state.activeIndex, prevActiveIndex = _state.prevActiveIndex;
                var text = word.text, color = word.color;
                var style = {
                    color: colors/* default */.Z[color]
                };
                var active = activeIndex === index;
                var animateEntrance = this.shouldAnimateWordEntrance(index);
                var animateExit = this.shouldAnimateWordExit(index);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("switching-word-item-wrapper", {
                        active: active,
                        "animate-entrance": animateEntrance,
                        "animate-exit": animateExit
                    }),
                    style: style,
                    children: text
                }, index);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, words = _props.words, wordWidth = _props.wordWidth;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSwitchingWordsComponent, {
                    className: "switching-words-component",
                    style: {
                        width: wordWidth
                    },
                    children: words.map(this.renderWord)
                });
            }
        }
    ]);
    return SwitchingWordsComponent;
}(react.PureComponent);

SwitchingWordsComponent.defaultProps = {
    words: [],
    activeIndex: 0,
    skipAnimation: false
};

// EXTERNAL MODULE: ./components/enhancements/responsive-hoc/responsive-hoc-component.js + 1 modules
var responsive_hoc_component = __webpack_require__(27190);
;// CONCATENATED MODULE: ./components/core/switching-title-with-signup/switching-title/switching-title-component.scss.js


var StyledSwitchingTitleComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1j0g2c0"
})("display:flex;justify-content:center;align-items:center;margin-bottom:16px;font-size:2.75rem;font-weight:500;@media (min-width:", vp_sizes/* FOLD_TEST_MAX_WIDTH */.LM, "){&.above-the-fold{flex-direction:column;text-align:left;font-size:3.938rem;.switching-words-wrapper{min-height:80px;}}}.colorful-title-wrapper{margin-right:10px;}.switching-words-wrapper{align-self:stretch;display:flex;}.colorful-title,.colorful-title .colored,.switching-word-item-wrapper{font-weight:700;font-size:2.75rem;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){font-size:2.25rem;}");

;// CONCATENATED MODULE: ./components/core/switching-title-with-signup/switching-title/switching-title-component.js




function switching_title_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function switching_title_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            switching_title_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function switching_title_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function switching_title_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        switching_title_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var SwitchingTitleComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SwitchingTitleComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SwitchingTitleComponent);
    function SwitchingTitleComponent() {
        (0,_class_call_check/* default */.Z)(this, SwitchingTitleComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SwitchingTitleComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, switchingWords = _props.switchingWords, activeIndex = _props.activeIndex, aboveTheFold = _props.aboveTheFold;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSwitchingTitleComponent, {
                    className: classnames_default()("switching-title-component", {
                        "above-the-fold": aboveTheFold
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "colorful-title-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(colorful_title_component/* default */.Z, {
                                text: title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "switching-words-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchingWordsComponent, switching_title_component_object_spread_props(switching_title_component_object_spread({}, switchingWords), {
                                activeIndex: activeIndex
                            }))
                        })
                    ]
                });
            }
        }
    ]);
    return SwitchingTitleComponent;
}(react.PureComponent);
var SwitchingTitleMobileComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SwitchingTitleMobileComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SwitchingTitleMobileComponent);
    function SwitchingTitleMobileComponent() {
        (0,_class_call_check/* default */.Z)(this, SwitchingTitleMobileComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SwitchingTitleMobileComponent, [
        {
            key: "render",
            value: function render() {
                var mobileTitle = this.props.mobileTitle;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSwitchingTitleComponent, {
                    className: "switching-title-component switching-title-mobile-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "colorful-title-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(colorful_title_component/* default */.Z, {
                            text: mobileTitle
                        })
                    })
                });
            }
        }
    ]);
    return SwitchingTitleMobileComponent;
}(react.PureComponent);
/* harmony default export */ var switching_title_component = ((0,responsive_hoc_component/* default */.Z)(SwitchingTitleComponent, SwitchingTitleMobileComponent));

// EXTERNAL MODULE: ./components/segments/lottie-animtaion/lottie-animation-component.js + 1 modules
var lottie_animation_component = __webpack_require__(74476);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
;// CONCATENATED MODULE: ./components/core/switching-title-with-signup/switching-title-with-signup-component.scss.js


var StyledSwitchingTitleWithSignupComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ehmq6870"
})("text-align:center;padding:0 16px;.subtitle-wrapper{&.mobile-only{display:none;}position:relative;margin-bottom:46px;margin-top:24px;h2{line-height:1.3;font-size:1.125rem;}}.signup-form-with-decorations-wrapper{display:flex;justify-content:center;}.arrow-wrapper{display:none;}@media (min-width:", vp_sizes/* FOLD_TEST_MAX_WIDTH */.LM, "){&.above-the-fold{.subtitle-wrapper{margin-bottom:24px;text-align:left;h2{line-height:1.5;font-size:1.375rem;}}.signup-form-with-decorations-wrapper{justify-content:flex-start;}.arrow-wrapper{display:block;padding-top:20px;}}}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.subtitle-wrapper{&.desktop-only{display:none;}}.switching-title-wrapper{&.subtitle-desktop-only{margin-bottom:46px;// instead of the subtitle margin-bottom}font-size:1.75rem;}.subtitle-wrapper{h2{font-size:1.125rem;}}}");

;// CONCATENATED MODULE: ./components/core/switching-title-with-signup/switching-title-with-signup-component.js





function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function switching_title_with_signup_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function switching_title_with_signup_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function switching_title_with_signup_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        switching_title_with_signup_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








var _obj;
var SUBTITLE_MODE_CLASS = (_obj = {}, (0,src_define_property/* default */.Z)(_obj, "mobile", "mobile-only"), (0,src_define_property/* default */.Z)(_obj, "desktop", "desktop-only"), _obj);
var SwitchingTitleWithSignupComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SwitchingTitleWithSignupComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SwitchingTitleWithSignupComponent);
    function SwitchingTitleWithSignupComponent() {
        (0,_class_call_check/* default */.Z)(this, SwitchingTitleWithSignupComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SwitchingTitleWithSignupComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, mobileTitle = _props.mobileTitle, switchingWords = _props.switchingWords, subtitle = _props.subtitle, signupForm = _props.signupForm, activeIndex = _props.activeIndex, showSignup = _props.showSignup, showSubtitle = _props.showSubtitle, aboveTheFold = _props.aboveTheFold, abTests = _props.abTests;
                var subtitleModeClass = SUBTITLE_MODE_CLASS[showSubtitle];
                var signupFormExt = signupForm;
                if (aboveTheFold) {
                    signupFormExt = switching_title_with_signup_component_object_spread_props(switching_title_with_signup_component_object_spread({}, signupForm), {
                        showDecorations: false
                    });
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSwitchingTitleWithSignupComponent, {
                    className: classnames_default()("switching-title-with-signup-component", {
                        "above-the-fold": aboveTheFold
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("switching-title-wrapper", "subtitle-".concat(subtitleModeClass)),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(switching_title_component, {
                                title: title,
                                switchingWords: switchingWords,
                                activeIndex: activeIndex,
                                mobileTitle: mobileTitle,
                                aboveTheFold: aboveTheFold
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("subtitle-wrapper", subtitleModeClass),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                dangerouslySetInnerHTML: {
                                    __html: subtitle
                                }
                            })
                        }),
                        showSignup && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "signup-form-with-decorations-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, switching_title_with_signup_component_object_spread_props(switching_title_with_signup_component_object_spread({}, signupFormExt), {
                                placement: "switching_words_title",
                                focusOnLoad: true
                            }))
                        }),
                        aboveTheFold && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "arrow-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lottie_animation_component/* default */.Z, {
                                aboveTheFold: true
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return SwitchingTitleWithSignupComponent;
}(react.PureComponent);
/* harmony default export */ var switching_title_with_signup_component = ((0,ab_tests_context/* withAbTests */.k)(SwitchingTitleWithSignupComponent));
SwitchingTitleWithSignupComponent.defaultProps = {
    title: "A great way to manage your",
    mobileTitle: "A great way to manage your <brand-blue>work</end>",
    subtitle: "Plan, organize and track your work. All in one visual collaborative place",
    switchingWords: {
        wordWidth: "124px",
        words: [
            {
                text: "work",
                color: "brand-red"
            },
            {
                text: "team",
                color: "brand-green"
            },
            {
                text: "leads",
                color: "brand-yellow"
            },
            {
                text: "jobs",
                color: "brand-iris"
            }
        ],
        animationInterval: "1000"
    },
    showSignup: true,
    signupForm: {}
};

;// CONCATENATED MODULE: ./components/segments/switching-title-with-quotes-carousel/switching-title-with-quotes-carousel-component.scss.js



var StyledSwitchingTitleWithQuotesCarouselComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1se4b5v0"
})(".switching-title-with-signup-wrapper{margin-bottom:64px;}@media (min-width:", vp_sizes/* FOLD_TEST_MAX_WIDTH */.LM, "){&.above-the-fold{display:flex;justify-content:center;min-width:1410px;margin-left:-180px;//calc:(1410 - 1050) /2\n\n      .switching-title-with-signup-wrapper{margin-bottom:0;padding-top:45px;padding-left:5vw;min-width:610px;z-index:", z_index/* TOP_LAYER */.nA, ";background:white;}.boards-and-quotes-carousel-wrapper{margin-left:32px;min-width:0;padding-top:24px;}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.switching-title-with-signup-wrapper{margin-bottom:32px;}}");

;// CONCATENATED MODULE: ./components/segments/switching-title-with-quotes-carousel/switching-title-with-quotes-carousel-component.js





function switching_title_with_quotes_carousel_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function switching_title_with_quotes_carousel_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            switching_title_with_quotes_carousel_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function switching_title_with_quotes_carousel_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function switching_title_with_quotes_carousel_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        switching_title_with_quotes_carousel_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var SwitchingTitleWithQuotesCarouselComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SwitchingTitleWithQuotesCarouselComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SwitchingTitleWithQuotesCarouselComponent);
    function SwitchingTitleWithQuotesCarouselComponent(props) {
        (0,_class_call_check/* default */.Z)(this, SwitchingTitleWithQuotesCarouselComponent);
        var _this;
        _this = _super.call(this, props);
        _this.setActive = _this.setActive.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onCaruoselActiveChange = _this.onCaruoselActiveChange.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.incrementActiveIndex = _this.incrementActiveIndex.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.clearIncrementActiveIndexInterval = _this.clearIncrementActiveIndexInterval.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.setIncrementActiveIndexInterval = _this.setIncrementActiveIndexInterval.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.incrementActiveIndexInterval = null;
        _this.state = {
            activeIndex: 0
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(SwitchingTitleWithQuotesCarouselComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var animationInterval = this.props.animationInterval;
                if (animationInterval) {
                    this.setIncrementActiveIndexInterval();
                } else {
                    this.clearIncrementActiveIndexInterval();
                }
            }
        },
        {
            key: "setIncrementActiveIndexInterval",
            value: function setIncrementActiveIndexInterval() {
                var animationInterval = this.props.animationInterval;
                this.clearIncrementActiveIndexInterval();
                this.incrementActiveIndexInterval = setInterval(this.incrementActiveIndex, animationInterval);
            }
        },
        {
            key: "incrementActiveIndex",
            value: function incrementActiveIndex() {
                var activeIndex = this.state.activeIndex;
                var useCases = this.props.useCases;
                var nextActiveIndex = (activeIndex + 1) % useCases.length;
                this.setActive(nextActiveIndex);
            }
        },
        {
            key: "setActive",
            value: function setActive(activeIndex) {
                this.setState({
                    activeIndex: activeIndex
                });
            }
        },
        {
            key: "onCaruoselActiveChange",
            value: function onCaruoselActiveChange(activeIndex) {
                this.clearIncrementActiveIndexInterval();
                this.setActive(activeIndex);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.clearIncrementActiveIndexInterval();
            }
        },
        {
            key: "clearIncrementActiveIndexInterval",
            value: function clearIncrementActiveIndexInterval() {
                if (this.incrementActiveIndexInterval) {
                    clearInterval(this.incrementActiveIndexInterval);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, useCases = _props.useCases, title = _props.title, subtitle = _props.subtitle, mobileTitle = _props.mobileTitle, showSignup = _props.showSignup, showSubtitle = _props.showSubtitle, showNavigationArrows = _props.showNavigationArrows, removeBoardBorder = _props.removeBoardBorder, aboveTheFold = _props.aboveTheFold, signupForm = _props.signupForm, isMobileOrTabletBrowser = _props.isMobileOrTabletBrowser;
                var useAboveTheFoldLayout = aboveTheFold && !isMobileOrTabletBrowser;
                var activeIndex = Math.min(useCases.length - 1, this.state.activeIndex);
                if (!useCases[activeIndex]) return false;
                var switchingWords = {
                    wordWidth: "124px",
                    words: useCases.map(function(uc, i) {
                        return switching_title_with_quotes_carousel_component_object_spread_props(switching_title_with_quotes_carousel_component_object_spread({}, uc.word), {
                            color: useCases[i].color
                        });
                    })
                };
                var stopAutoSlide = this.clearIncrementActiveIndexInterval;
                var startAutoSlide = this.setIncrementActiveIndexInterval;
                var showArrowsInQuotes = showNavigationArrows;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSwitchingTitleWithQuotesCarouselComponent, {
                    className: classnames_default()("switching-title-with-quotes-carousel-component", {
                        "above-the-fold": useAboveTheFoldLayout
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "switching-title-with-signup-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(switching_title_with_signup_component, {
                                title: title,
                                subtitle: subtitle,
                                switchingWords: switchingWords,
                                activeIndex: activeIndex,
                                mobileTitle: mobileTitle,
                                showSignup: showSignup,
                                showSubtitle: showSubtitle,
                                aboveTheFold: useAboveTheFoldLayout,
                                signupForm: signupForm
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "boards-and-quotes-carousel-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BoardsAndQoutesCarouselComponent, {
                                quotes: useCases,
                                activeIndex: activeIndex,
                                setActive: this.onCaruoselActiveChange,
                                stopAutoSlide: stopAutoSlide,
                                startAutoSlide: startAutoSlide,
                                showNavigationArrows: showArrowsInQuotes,
                                removeBoardBorder: removeBoardBorder,
                                aboveTheFold: useAboveTheFoldLayout
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return SwitchingTitleWithQuotesCarouselComponent;
}(react.PureComponent);

SwitchingTitleWithQuotesCarouselComponent.defaultProps = {
    title: "A new way to manage your",
    subtitle: "Plan, organize and track your work. All in one visual collaborative place",
    useCases: [
        {
            boardImage: "/static/img/community/board-image3.jpg",
            personTitle: "Bla Bla",
            personImage: "/static/img/exit-popup/exit-popup-social-proof-person-avater.png",
            quoteText: '"It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more "',
            active: true,
            word: {
                text: "workflows"
            },
            color: "brand-red"
        },
        {
            boardImage: "/static/img/lp/fb/designers-long/timeline.png20180125-30832-j2m2hz.png",
            personImage: "/static/img/jobs-page/cs.png",
            personTitle: "Tan Ha",
            quoteText: '"It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged"',
            active: false,
            word: {
                text: "work"
            },
            color: "brand-blue"
        },
        {
            boardImage: "/static/img/community/board-image2.jpg",
            personImage: "/static/img/jobs-page/design.png",
            personTitle: "Product Designer",
            quoteText: "123qweqwedawa dwkdj awkdj aw;kdj akw;ldj aw;kdj aw;kdj aklw;djaklw;d jawkld jakl;wdj ak;lwdj ",
            active: false,
            word: {
                text: "clients"
            },
            color: "brand-green"
        },
        {
            boardImage: "/static/img/s/car-manufacturing-management/high-level-board.png",
            personImage: "/static/img/s/construction-management-software/original-real_photo.png",
            personTitle: "Dude",
            quoteText: '"Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book"',
            active: false,
            word: {
                text: "tasks"
            },
            color: "brand-purple"
        },
        {
            personTitle: "Tal",
            quoteText: "dawd awdawdaw da wd awd awd aw daw dawd",
            personImage: "/static/img/s/multitasking-work-productivity/Picture1.png",
            boardImage: "/static/img/s/agile-management-software/project_status.png",
            active: false,
            word: {
                text: "blabla"
            },
            color: "brand-iris"
        }
    ],
    animationInterval: "3000",
    paddingTop: "100px"
};
SwitchingTitleWithQuotesCarouselComponent.baseSegmentStyleOverride = {
    paddingLeft: 0,
    paddingRight: 0
};

;// CONCATENATED MODULE: ./components/segments/header-with-image-and-title/header-with-image-and-title-component.scss.js




var StyledHeaderWithImageAndTitleComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1hiqbhd0"
})("position:relative;.header-with-image-content{position:relative;display:flex;flex-direction:column;justify-content:center;align-items:center;z-index:", z_index/* LAYER_ONE */.KW, ";.signup-form{margin-top:32px;}.title{margin-top:4vh;margin-bottom:2vh;text-align:center;max-width:80vw;font-size:3.5vw;font-weight:300;:global(b){font-weight:500;}}.subtitle{font-size:1.8vw;margin-top:0;font-weight:300;max-width:80vw;text-align:center;line-height:2.4vw;margin-bottom:10px;}&.white-text{.title,.subtitle{color:", colors/* default.white */.Z.white, ";}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, '){.header-with-image-content{min-height:auto;padding:0px 20px;text-align:center;.title{font-size:1.575rem;margin-bottom:1.5vh;line-height:1.3;font-weight:300;}.subtitle{font-size:0.875rem;line-height:1.5;}}}.hot-dog{content:"";position:absolute;width:120vw;height:120vw;background:', function(param) {
    var hotDogColor = param.hotDogColor;
    return colors/* default */.Z[hotDogColor];
}, ";border-radius:999px;top:-88vw;left:-10vw;z-index:", z_index/* ZERO */.xE, ";@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){width:210vw;height:220vw;max-height:160vh;left:-50vw;}@media (max-width:", vp_sizes.XS, "px){top:-110vw;width:220vw;height:220vw;max-height:140vh;left:-55vw;}}.header-with-image-content{margin-bottom:50px;.main-image{position:relative;width:", function(param) {
    var imageWidth = param.imageWidth;
    return imageWidth;
}, ";margin-top:48px;&.with-shadow{img{box-shadow:0 2px 40px 1px rgba(60,60,60,0.3);border:12px solid white;border-radius:6px;}}img{width:100%;}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.main-image{width:90%;margin-bottom:20px;}}}");

;// CONCATENATED MODULE: ./components/segments/header-with-image-and-title/header-with-image-and-title-component.js




function header_with_image_and_title_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function header_with_image_and_title_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            header_with_image_and_title_component_define_property(target, key, source[key]);
        });
    }
    return target;
}







var HeaderWithImageAndTitleComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(HeaderWithImageAndTitleComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(HeaderWithImageAndTitleComponent);
    function HeaderWithImageAndTitleComponent() {
        (0,_class_call_check/* default */.Z)(this, HeaderWithImageAndTitleComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(HeaderWithImageAndTitleComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, signupForm = _props.signupForm, backgroundColor = _props.backgroundColor, hotdog = _props.hotdog, title = _props.title, subtitle = _props.subtitle, image = _props.image, textColor = _props.textColor, imageWidth = _props.imageWidth, useTemplateButton = _props.useTemplateButton;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeaderWithImageAndTitleComponent, {
                    imageWidth: imageWidth,
                    hotDogColor: backgroundColor,
                    className: "header-with-image-and-title-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hot-dog",
                            style: {
                                backgroundColor: colors/* default */.Z[backgroundColor]
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()("header-with-image-content", {
                                "white-text": textColor === "white"
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "title",
                                    dangerouslySetInnerHTML: {
                                        __html: title
                                    }
                                }),
                                subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "subtitle",
                                    dangerouslySetInnerHTML: {
                                        __html: subtitle
                                    }
                                }),
                                signupForm && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "signup-form",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, {
                                        focusOnLoad: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()("main-image", {
                                        "with-shadow": image.shadow
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, header_with_image_and_title_component_object_spread({}, image))
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return HeaderWithImageAndTitleComponent;
}(react.PureComponent);

HeaderWithImageAndTitleComponent.defaultProps = {
    backgroundColor: "brand-purple",
    image: {},
    title: "",
    subtitle: "",
    signupForm: true,
    textColor: "",
    imageWidth: "50%"
};

;// CONCATENATED MODULE: ./components/core/fact-card/card/card-component.scss.js


var StyledCardComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eb85aqg0"
})("border-radius:5px;padding:24px 40px;box-shadow:0px 2px 16px 0px rgba(195,195,195,0.5);@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){padding:0px;height:100% !important;width:100% !important;}");

;// CONCATENATED MODULE: ./components/core/fact-card/card/card-component.js








var CardComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(CardComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(CardComponent);
    function CardComponent(props) {
        (0,_class_call_check/* default */.Z)(this, CardComponent);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(CardComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, height = _props.height, width = _props.width, children = _props.children, background = _props.background;
                var style = {
                    height: height,
                    width: width,
                    backgroundColor: colors/* default */.Z[background]
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCardComponent, {
                    className: "card-component",
                    style: style,
                    children: children
                });
            }
        }
    ]);
    return CardComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./components/core/fact-card/fact-details/fact-details-component.scss.js



var titleFontSize = "56px";
var StyledFactDetailsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1t14tqe0"
})("width:100%;height:calc(100% - 40px);display:flex;align-items:center;color:", colors/* default.white */.Z.white, ";.title{font-weight:700;font-size:", titleFontSize, ";margin-right:36px;line-height:", titleFontSize, ";}.content{flex-grow:1;font-size:1.375rem;line-height:34px;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){flex-direction:column;text-align:center;padding:0px 32px;.title{margin-top:36px;margin-right:0px;}.content{line-height:30px;margin-top:18px;}}");

;// CONCATENATED MODULE: ./components/core/fact-card/fact-details/fact-details-component.js








var FactDetailsComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(FactDetailsComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(FactDetailsComponent);
    function FactDetailsComponent(props) {
        (0,_class_call_check/* default */.Z)(this, FactDetailsComponent);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(FactDetailsComponent, [
        {
            key: "renderParagraphs",
            value: function renderParagraphs(paragraphs) {
                return paragraphs.map(function(paragraph, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: paragraph
                        }
                    }, index);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, body = _props.body;
                var contentBody = (0,arrays.convertToArrayIfNeeded)(body);
                contentBody = this.renderParagraphs(contentBody);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFactDetailsComponent, {
                    className: "fact-details-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "title",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "content",
                            children: contentBody
                        })
                    ]
                });
            }
        }
    ]);
    return FactDetailsComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./components/core/fact-card/fact-quote/fact-quote-component.scss.js



var StyledFactQuoteComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1od2cpf0"
})("width:100%;height:100%;display:flex;color:", colors/* default.black */.Z.black, ";align-items:center;.quote-person-image{img{height:60px;width:120px;}}.content-container{display:flex;flex-direction:column;margin-left:36px;line-height:27px;flex:1 1 100%;.quote{word-break:break-word;}.details{font-size:0.875rem;margin-top:16px;.person-name,.company-name{font-weight:700;}.seperator{margin:0px 4px;}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){position:relative;flex-direction:column;align-items:center;padding:16px 32px 32px;.content-container{margin-left:0px;text-align:center;}}");

;// CONCATENATED MODULE: ./components/core/fact-card/fact-quote/fact-quote-component.js




function fact_quote_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function fact_quote_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            fact_quote_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function fact_quote_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function fact_quote_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        fact_quote_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var FactQuoteComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(FactQuoteComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(FactQuoteComponent);
    function FactQuoteComponent(props) {
        (0,_class_call_check/* default */.Z)(this, FactQuoteComponent);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(FactQuoteComponent, [
        {
            key: "renderParagraphs",
            value: function renderParagraphs(paragraphs) {
                return paragraphs.map(function(paragraph, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: paragraph
                        }
                    }, index);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, image = _props.image, body = _props.body, personName = _props.personName, companyName = _props.companyName;
                var contentBody = (0,arrays.convertToArrayIfNeeded)(body);
                contentBody = this.renderParagraphs(contentBody);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFactQuoteComponent, {
                    className: "fact-quote-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, fact_quote_component_object_spread_props(fact_quote_component_object_spread({}, image), {
                            pictureClass: "quote-person-image"
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "content-container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("q", {
                                    className: "quote",
                                    children: contentBody
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "details",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "person-name",
                                            children: personName
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "seperator",
                                            children: "|"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "company-name",
                                            children: companyName
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return FactQuoteComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./components/core/fact-card/fact-card-component.scss.js


var StyledFactCardComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e12epmv70"
})("display:flex;flex-direction:column;.fact-details-wrapper{align-self:flex-start;}.fact-quote-wrapper{transform:translateY(-40px);align-self:flex-end;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){align-items:center;.fact-details-wrapper{align-self:auto;width:100%;height:300px;}.fact-quote-wrapper{width:90%;transform:translateY(-50px);align-self:auto;}}");

;// CONCATENATED MODULE: ./components/core/fact-card/fact-card-component.js




function fact_card_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function fact_card_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            fact_card_component_define_property(target, key, source[key]);
        });
    }
    return target;
}






var FactCardComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(FactCardComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(FactCardComponent);
    function FactCardComponent(props) {
        (0,_class_call_check/* default */.Z)(this, FactCardComponent);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(FactCardComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, width = _props.width, height = _props.height, detailsCard = _props.detailsCard, quoteCard = _props.quoteCard;
                var detailsCardBackground = detailsCard.background;
                var quoteCardBackground = quoteCard.background;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFactCardComponent, {
                    className: "fact-card-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "fact-details-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardComponent, {
                                width: width,
                                height: height,
                                background: detailsCardBackground,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FactDetailsComponent, fact_card_component_object_spread({}, detailsCard))
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "fact-quote-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardComponent, {
                                width: width,
                                height: height,
                                background: quoteCardBackground,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FactQuoteComponent, fact_card_component_object_spread({}, quoteCard))
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return FactCardComponent;
}(react.PureComponent);

FactCardComponent.defaultProps = {
    detailsCard: {},
    quoteCard: {}
};

;// CONCATENATED MODULE: ./components/segments/fact-cards/fact-cards-component.scss.js

var StyledFactCardsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e13hey760"
})("display:flex;flex-direction:column;.header{margin-bottom:48px;}");

;// CONCATENATED MODULE: ./components/segments/fact-cards/fact-cards-component.js




function fact_cards_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function fact_cards_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            fact_cards_component_define_property(target, key, source[key]);
        });
    }
    return target;
}





var FactCardsComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(FactCardsComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(FactCardsComponent);
    function FactCardsComponent(props) {
        (0,_class_call_check/* default */.Z)(this, FactCardsComponent);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(FactCardsComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, paragraph = _props.paragraph, general = _props.general, cards = _props.cards;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFactCardsComponent, {
                    className: "fact-cards-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "header",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph_component/* default */.Z, fact_cards_component_object_spread({}, paragraph))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cards",
                            children: cards.map(function(card, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FactCardComponent, fact_cards_component_object_spread({}, card, general), index);
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return FactCardsComponent;
}(react.PureComponent);

FactCardsComponent.defaultProps = {
    cards: []
};

;// CONCATENATED MODULE: ./components/segments/simpo/simpo-component.scss.js

var simpo_component_scss_componentStyles = new String(".simpo-component-wrapper.jsx-3ccce5a4b4c749fd{.action-bar-wrapper.jsx-3ccce5a4b4c749fd{min-height:150px}}");
simpo_component_scss_componentStyles.__hash = "3ccce5a4b4c749fd";

;// CONCATENATED MODULE: ./components/segments/simpo/simpo-component.js




function simpo_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function simpo_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            simpo_component_define_property(target, key, source[key]);
        });
    }
    return target;
}






var MAIN_SCRIPT = '!function(){var r=window.actionbar=window.actionbar||[];if(!r.initialize&&!r.invoked){r.invoked=!0,r.methods=["configure","identify","reset","ready","debug","off","on"],r.generator=function(t){return function(){var e=Array.prototype.slice.call(arguments);return e.unshift(t),r.push(e),r}};for(var e=0;e<r.methods.length;e++){var t=r.methods[e];r[t]=r.generator(t)}r.load=function(e){var t=document.createElement("script");t.type="text/javascript",t.async=!0,t.src="https://cdn.simpo.io/actionbar.js",r.ucid=e;var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n)},r.SNIPPET_VERSION="2.0.0"}}();;\nactionbar.load("fnvrfechqj2ppxqjue0ketduibbin46thb9wcatpbz8");';
var STARTUP_SCRIPT = "actionbar.configure({\n  bar: {\n      embedMode: 'inline',\n      container: '.action-bar-wrapper',\n      width: '100%'\n  },\n  widget: {\n      show: false\n  }\n});\n";
var HIDE_SCRIPT = "actionbar.on('ready', function() {\n  actionbar.jQuery(\"form[role='search']\").remove();\n});";
var SimpoComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SimpoComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SimpoComponent);
    function SimpoComponent(props) {
        (0,_class_call_check/* default */.Z)(this, SimpoComponent);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(SimpoComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.runScript(MAIN_SCRIPT);
                this.runScript(STARTUP_SCRIPT);
                this.runScript(HIDE_SCRIPT);
            }
        },
        {
            key: "runScript",
            value: function runScript(script) {
                var s = document.createElement("script");
                s.type = "text/javascript";
                s.async = true;
                s.innerHTML = script;
                this.instance.appendChild(s);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, backgroundColor = _props.backgroundColor, paragraph = _props.paragraph;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        backgroundColor: backgroundColor
                    },
                    ref: function(el) {
                        return _this.instance = el;
                    },
                    className: "jsx-".concat(simpo_component_scss_componentStyles.__hash) + " " + "simpo-component-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph_component/* default */.Z, simpo_component_object_spread({}, paragraph)),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(simpo_component_scss_componentStyles.__hash) + " " + "action-bar-wrapper"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: simpo_component_scss_componentStyles.__hash,
                            children: simpo_component_scss_componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return SimpoComponent;
}(react.PureComponent);


// EXTERNAL MODULE: ./components/core/button/button-component.js + 5 modules
var button_component = __webpack_require__(20776);
;// CONCATENATED MODULE: ./static/svg/checklist_checked.svg
var _g;
function checklist_checked_extends() {
    checklist_checked_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return checklist_checked_extends.apply(this, arguments);
}

var SvgChecklistChecked = function SvgChecklistChecked(props) {
    return /*#__PURE__*/ react.createElement("svg", checklist_checked_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24"
    }, props), _g || (_g = /*#__PURE__*/ react.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("circle", {
        cx: 12,
        cy: 12,
        r: 12,
        fill: "#02A1E5"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#FFF",
        d: "M16.337 7.43a.63.63 0 0 1 .924-.055c.27.254.292.689.051.972l-6.696 7.847a.633.633 0 0 1-.95.028l-3.074-3.234a.714.714 0 0 1 0-.973.63.63 0 0 1 .925 0l2.585 2.719z"
    }))));
};
/* harmony default export */ var checklist_checked = (SvgChecklistChecked);

;// CONCATENATED MODULE: ./static/svg/checklist_empty.svg
var _circle;
function checklist_empty_extends() {
    checklist_empty_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return checklist_empty_extends.apply(this, arguments);
}

var SvgChecklistEmpty = function SvgChecklistEmpty(props) {
    return /*#__PURE__*/ react.createElement("svg", checklist_empty_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 26,
        height: 26,
        viewBox: "0 0 26 26"
    }, props), _circle || (_circle = /*#__PURE__*/ react.createElement("circle", {
        cx: 12,
        cy: 12,
        r: 12,
        fill: "none",
        fillRule: "evenodd",
        stroke: "#0CA5E7",
        opacity: 0.5,
        transform: "translate(1 1)"
    })));
};
/* harmony default export */ var checklist_empty = (SvgChecklistEmpty);

;// CONCATENATED MODULE: ./components/segments/cluster-selection/cluster-option-component/cluster-option-component.scss.js

var cluster_option_component_scss_componentStyles = new String(".cluster-manage-option.jsx-6fda037a9974b8c8{-webkit-border-radius:6px;-moz-border-radius:6px;border-radius:6px;-webkit-box-shadow:0px 3px 5px 0px rgba(0,0,0,.14);-moz-box-shadow:0px 3px 5px 0px rgba(0,0,0,.14);box-shadow:0px 3px 5px 0px rgba(0,0,0,.14);background-color:rgba(255,255,255,1);display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;width:232px;height:136px;.cluster-image-wrapper.jsx-6fda037a9974b8c8{-webkit-box-flex:66;-webkit-flex:66;-moz-box-flex:66;-ms-flex:66;flex:66;.cluster-option-image.jsx-6fda037a9974b8c8{width:100%;-webkit-border-top-left-radius:3px;-moz-border-radius-topleft:3px;border-top-left-radius:3px;-webkit-border-top-right-radius:3px;-moz-border-radius-topright:3px;border-top-right-radius:3px}}.cluster-text-wrapper.jsx-6fda037a9974b8c8{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-flex:34;-webkit-flex:34;-moz-box-flex:34;-ms-flex:34;flex:34;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;.cluster-option-text.jsx-6fda037a9974b8c8{max-width:300px;font-size:.875rem;font-weight:500;text-align:center;padding-bottom:6px}}&.big-image.jsx-6fda037a9974b8c8{width:420px;height:250px;-webkit-box-shadow:0px 12px 14px 0px rgba(0,0,0,.12);-moz-box-shadow:0px 12px 14px 0px rgba(0,0,0,.12);box-shadow:0px 12px 14px 0px rgba(0,0,0,.12);.cluster-text-wrapper.jsx-6fda037a9974b8c8{.cluster-option-text.jsx-6fda037a9974b8c8{font-size:1.463rem;&.is-other.jsx-6fda037a9974b8c8{font-size:1.125rem}}}}&.selected.jsx-6fda037a9974b8c8{&.jsx-6fda037a9974b8c8:not(.big-image){border:2px solid rgba(2,161,229,1);.cluster-option-text.jsx-6fda037a9974b8c8{color:rgba(2,161,229,1)}}}&.jsx-6fda037a9974b8c8:not(.big-image){margin:0 12px 24px 12px;@media(min-width:".concat(vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){&.jsx-6fda037a9974b8c8:hover{&.jsx-6fda037a9974b8c8:not(.selected){-webkit-box-shadow:0px 12px 14px 0px rgba(0,0,0,.12);-moz-box-shadow:0px 12px 14px 0px rgba(0,0,0,.12);box-shadow:0px 12px 14px 0px rgba(0,0,0,.12);-webkit-transform:translatey(-10px);-moz-transform:translatey(-10px);-ms-transform:translatey(-10px);-o-transform:translatey(-10px);transform:translatey(-10px);cursor:pointer;.cluster-option-text.jsx-6fda037a9974b8c8{color:rgba(2,161,229,1)}}}}}}@media(max-width:").concat(vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.cluster-manage-option.jsx-6fda037a9974b8c8,.cluster-manage-option.big-image.jsx-6fda037a9974b8c8{width:327px;height:192px;-webkit-box-shadow:0px 3px 50px 0px rgba(0,0,0,.14);-moz-box-shadow:0px 3px 50px 0px rgba(0,0,0,.14);box-shadow:0px 3px 50px 0px rgba(0,0,0,.14);.cluster-text-wrapper.jsx-6fda037a9974b8c8{.cluster-option-text.jsx-6fda037a9974b8c8{font-size:1.125rem}&.with-checkbox.jsx-6fda037a9974b8c8{-webkit-box-pack:start;-webkit-justify-content:flex-start;-moz-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;padding-left:16px;.cluster-option-text.jsx-6fda037a9974b8c8{padding-left:8px;text-align:left}}}}}@media(max-width:").concat(vp_sizes/* SMALL_MOBILE_QUERY_MAX_WIDTH */.cb, "){.cluster-manage-option.jsx-6fda037a9974b8c8,.cluster-manage-option.big-image.jsx-6fda037a9974b8c8{width:261px;height:153px}}"));
cluster_option_component_scss_componentStyles.__hash = "6fda037a9974b8c8";

;// CONCATENATED MODULE: ./components/segments/cluster-selection/cluster-option-component/cluster-option-component.jsx













var ClusterOptionComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ClusterOptionComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ClusterOptionComponent);
    function ClusterOptionComponent(props) {
        (0,_class_call_check/* default */.Z)(this, ClusterOptionComponent);
        var _this;
        _this = _super.call(this, props);
        _this.onSelect = _this.onSelect.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(ClusterOptionComponent, [
        {
            key: "onSelect",
            value: function onSelect() {
                var _props = this.props, selectCallback = _props.selectCallback, option = _props.option;
                selectCallback(option.id);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, selected = _props.selected, singleImage = _props.singleImage, option = _props.option, showCheckboxIcon = _props.showCheckboxIcon;
                var image = singleImage && option.detailsImage ? option.detailsImage : option.image;
                var text = singleImage && option.detailsText ? option.detailsText : option.text;
                var ChecklistComponent = singleImage ? checklist_checked : checklist_empty;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    onMouseDown: this.onSelect,
                    className: "jsx-".concat(cluster_option_component_scss_componentStyles.__hash) + " " + (classnames_default()("cluster-manage-option", {
                        selected: selected,
                        "big-image": singleImage
                    }) || ""),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(cluster_option_component_scss_componentStyles.__hash) + " " + "cluster-image-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: image,
                                className: "jsx-".concat(cluster_option_component_scss_componentStyles.__hash) + " " + "cluster-option-image"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-".concat(cluster_option_component_scss_componentStyles.__hash) + " " + (classnames_default()("cluster-text-wrapper", {
                                "with-checkbox": showCheckboxIcon
                            }) || ""),
                            children: [
                                showCheckboxIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChecklistComponent, {
                                    className: "jsx-".concat(cluster_option_component_scss_componentStyles.__hash)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "jsx-".concat(cluster_option_component_scss_componentStyles.__hash) + " " + (classnames_default()("cluster-option-text", {
                                        "is-other": option.detailsText
                                    }) || ""),
                                    children: [
                                        " ",
                                        text
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: cluster_option_component_scss_componentStyles.__hash,
                            children: cluster_option_component_scss_componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return ClusterOptionComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./components/segments/cluster-selection/layout-option-component/layout-option-component.scss.js

var layout_option_component_scss_componentStyles = new String(".manage-option.jsx-3988f6ebf6054f3e{-webkit-border-radius:6px;-moz-border-radius:6px;border-radius:6px;-webkit-box-shadow:0px 3px 5px 0px rgba(0,0,0,.14);-moz-box-shadow:0px 3px 5px 0px rgba(0,0,0,.14);box-shadow:0px 3px 5px 0px rgba(0,0,0,.14);background-color:rgba(255,255,255,1);border:3px solid transparent;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;width:327px;height:232px;margin:0 8px 32px 8px;.text-wrapper.jsx-3988f6ebf6054f3e{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-flex:25;-webkit-flex:25;-moz-box-flex:25;-ms-flex:25;flex:25;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;.option-text.jsx-3988f6ebf6054f3e{font-size:1rem;text-align:center;color:white}}.image-wrapper.jsx-3988f6ebf6054f3e{-webkit-box-flex:75;-webkit-flex:75;-moz-box-flex:75;-ms-flex:75;flex:75;padding:0 12px 12px 12px;.option-image.jsx-3988f6ebf6054f3e{width:100%;-webkit-border-top-left-radius:3px;-moz-border-radius-topleft:3px;border-top-left-radius:3px;-webkit-border-top-right-radius:3px;-moz-border-radius-topright:3px;border-top-right-radius:3px}}&.big-image.jsx-3988f6ebf6054f3e{margin:0 8px}&.selected.jsx-3988f6ebf6054f3e{&.jsx-3988f6ebf6054f3e:not(.big-image){border:3px solid rgba(2,161,229,1)}}}@media(max-width:".concat(vp_sizes/* SMALL_MOBILE_QUERY_MAX_WIDTH */.cb, "){.manage-option.jsx-3988f6ebf6054f3e{width:278px;height:197px}}"));
layout_option_component_scss_componentStyles.__hash = "3988f6ebf6054f3e";

;// CONCATENATED MODULE: ./components/segments/cluster-selection/layout-option-component/layout-option-component.jsx











var LayoutOptionComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(LayoutOptionComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(LayoutOptionComponent);
    function LayoutOptionComponent(props) {
        (0,_class_call_check/* default */.Z)(this, LayoutOptionComponent);
        var _this;
        _this = _super.call(this, props);
        _this.onSelect = _this.onSelect.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(LayoutOptionComponent, [
        {
            key: "onSelect",
            value: function onSelect() {
                var _props = this.props, selectCallback = _props.selectCallback, option = _props.option;
                selectCallback(option.id);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, selected = _props.selected, singleImage = _props.singleImage, option = _props.option;
                var image = singleImage && option.detailsImage ? option.detailsImage : option.image;
                var text = singleImage && option.detailsText ? option.detailsText : option.text;
                var style = {
                    backgroundColor: colors/* default */.Z[option.backgroundColor]
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    onMouseDown: this.onSelect,
                    style: style,
                    className: "jsx-".concat(layout_option_component_scss_componentStyles.__hash) + " " + (classnames_default()("manage-option", {
                        selected: selected,
                        "big-image": singleImage
                    }) || ""),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(layout_option_component_scss_componentStyles.__hash) + " " + "text-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "jsx-".concat(layout_option_component_scss_componentStyles.__hash) + " " + (classnames_default()("option-text", {
                                    "is-other": option.detailsText
                                }) || ""),
                                children: [
                                    " ",
                                    text
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(layout_option_component_scss_componentStyles.__hash) + " " + "image-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: image,
                                className: "jsx-".concat(layout_option_component_scss_componentStyles.__hash) + " " + "option-image"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: layout_option_component_scss_componentStyles.__hash,
                            children: layout_option_component_scss_componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return LayoutOptionComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./components/segments/cluster-selection/cluster-solutions-component/cluster-solutions-component.scss.js

var cluster_solutions_component_scss_componentStyles = new String(".cluster-solutions{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;.signup-button-wrapper{max-width:600px}.solutions-image-wrapper{width:80vw;.solutions-image{width:100%}}}@media(max-width:".concat(vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.cluster-solutions{.solutions-image-wrapper{padding-top:32px;width:95vw}}}@media(max-width:").concat(vp_sizes/* SMALL_MOBILE_QUERY_MAX_WIDTH */.cb, "){.cluster-solutions{.solutions-image-wrapper{padding-top:48px}}}"));
cluster_solutions_component_scss_componentStyles.__hash = "c0c77ba0997a26be";

;// CONCATENATED MODULE: ./components/segments/cluster-selection/cluster-solutions-component/cluster-solutions-component.jsx










var ClusterSolutionsComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ClusterSolutionsComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ClusterSolutionsComponent);
    function ClusterSolutionsComponent() {
        (0,_class_call_check/* default */.Z)(this, ClusterSolutionsComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ClusterSolutionsComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, showDecorations = _props.showDecorations, cta = _props.cta, selectedCluster = _props.selectedCluster;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(cluster_solutions_component_scss_componentStyles.__hash) + " " + "cluster-solutions",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(cluster_solutions_component_scss_componentStyles.__hash) + " " + "signup-button-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, {
                                buttonColor: "brand-blue",
                                ctaText: cta,
                                showDecorations: showDecorations
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(cluster_solutions_component_scss_componentStyles.__hash) + " " + "solutions-image-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                className: "solutions-image",
                                src: selectedCluster.solutionsImage
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: cluster_solutions_component_scss_componentStyles.__hash,
                            children: cluster_solutions_component_scss_componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return ClusterSolutionsComponent;
}(react.PureComponent);


// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
// EXTERNAL MODULE: ./services/clusters/clusters-service-mobile.js
var clusters_service_mobile = __webpack_require__(82249);
// EXTERNAL MODULE: ./services/clusters/clusters-service.js
var clusters_service = __webpack_require__(74138);
// EXTERNAL MODULE: ./services/clusters/clusters-with-solutions-service.js
var clusters_with_solutions_service = __webpack_require__(54632);
// EXTERNAL MODULE: ./services/clusters/layout-service.js
var layout_service = __webpack_require__(25800);
// EXTERNAL MODULE: ./services/dom-utils-service.js
var dom_utils_service = __webpack_require__(44566);
;// CONCATENATED MODULE: ./components/segments/cluster-selection/cluster-selection-component.scss.js

var cluster_selection_component_scss_componentStyles = new String(".cluster-selection-wrapper{max-width:1050px;.form-wrapper{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;.manage-title{font-size:1.913rem;text-align:center;strong {\n          font-weight: bold;\n        }\n      }.manage-subtitle{font-size:.875rem;text-align:center;line-height:26px;padding-top:8px}.cluster-selection-options-wrapper{padding-top:32px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;min-height:360px}.selected-cluster-wrapper{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;min-height:360px}.cluster-solutions-wrapper{padding-top:32px}.button-wrapper{padding-top:42px}.button-wrapper-signup{padding-top:32px}}}@media(max-width:".concat(vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.cluster-selection-wrapper{.form-wrapper{.manage-title{font-size:1.375rem}.manage-subtitle{font-size:1rem}.cluster-selection-options-wrapper{}.selected-cluster-wrapper{min-height:auto;padding-top:40px}.button-wrapper{padding-top:8px}.button-wrapper-signup{padding-top:40px}}}}"));
cluster_selection_component_scss_componentStyles.__hash = "1b2a7305846a108b";

;// CONCATENATED MODULE: ./components/segments/cluster-selection/cluster-selection-component.js




















var STEP2_HASH = "#step2";
var ClusterSelectionComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ClusterSelectionComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ClusterSelectionComponent);
    function ClusterSelectionComponent(props) {
        (0,_class_call_check/* default */.Z)(this, ClusterSelectionComponent);
        var _this;
        _this = _super.call(this, props);
        _this.nextStep = _this.nextStep.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.renderOption = _this.renderOption.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.selectItem = _this.selectItem.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onBrowserHashChangeEvent = _this.onBrowserHashChangeEvent.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.renderItemSelectionForm = _this.renderItemSelectionForm.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.renderSecondStep = _this.renderSecondStep.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this._nextButton = null;
        _this._config = _this.getConfigFromSelection(props.selection);
        _this.state = {
            selectedId: null,
            firstStepCompleted: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(ClusterSelectionComponent, [
        {
            key: "getConfigFromSelection",
            value: function getConfigFromSelection(selection) {
                switch(selection){
                    case clusters_service/* CLUSTER_OPTION_VALUE */.z:
                        return clusters_service/* CLUSTER_CONFIG */.a;
                    case clusters_with_solutions_service/* CLUSTER_WITH_SOLUTION_OPTION_VALUE */.O:
                        return clusters_with_solutions_service/* CLUSTER_WITH_SOLUTION_CONFIG */.Z;
                    case layout_service/* LAYOUT_OPTION_VALUE */.o:
                        return layout_service/* LAYOUT_CONFIG */.W;
                    case clusters_service_mobile/* CLUSTER_MOBILE_OPTION_VALUE */.Q:
                        return clusters_service_mobile/* CLUSTER_CONFIG_MOBILE */.e;
                    default:
                        return clusters_service/* CLUSTER_CONFIG */.a;
                }
            }
        },
        {
            key: "getOptionComponentFromSelection",
            value: function getOptionComponentFromSelection(selection) {
                switch(selection){
                    case clusters_service/* CLUSTER_OPTION_VALUE */.z:
                    case clusters_with_solutions_service/* CLUSTER_WITH_SOLUTION_OPTION_VALUE */.O:
                    case clusters_service_mobile/* CLUSTER_MOBILE_OPTION_VALUE */.Q:
                        return ClusterOptionComponent;
                    case layout_service/* LAYOUT_OPTION_VALUE */.o:
                        return LayoutOptionComponent;
                    default:
                        return ClusterOptionComponent;
                }
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                window.onhashchange = this.onBrowserHashChangeEvent;
            }
        },
        {
            key: "onBrowserHashChangeEvent",
            value: function onBrowserHashChangeEvent() {
                var hash = window.location.hash;
                if (hash.length === 0) {
                    this.setState({
                        firstStepCompleted: false
                    });
                }
            }
        },
        {
            key: "getSelectedItem",
            value: function getSelectedItem() {
                var selectedId = this.state.selectedId;
                var options = this._config.options;
                return options.filter(function(option) {
                    return option.id === selectedId;
                })[0];
            }
        },
        {
            key: "selectItem",
            value: function selectItem(id) {
                var __config = this._config, itemClickedEvent = __config.itemClickedEvent, withoutContinueButton = __config.withoutContinueButton;
                BigBrain("track", itemClickedEvent, {
                    kind: id
                });
                this.setState({
                    selectedId: id
                });
                if (withoutContinueButton) {
                    this.nextStep(id);
                } else if (this._nextButton) {
                    (0,dom_utils_service.scrollTo)(this._nextButton.offsetTop, 600);
                }
            }
        },
        {
            key: "renderOption",
            value: function renderOption(option, singleImage) {
                var selectedId = this.state.selectedId;
                var selection = this.props.selection;
                var withoutContinueButton = this._config.withoutContinueButton;
                var OptionComponent = this.getOptionComponentFromSelection(selection);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionComponent, {
                    option: option,
                    selected: option.id === selectedId,
                    selectCallback: this.selectItem,
                    singleImage: singleImage,
                    showCheckboxIcon: withoutContinueButton
                }, option.id);
            }
        },
        {
            key: "nextStep",
            value: function nextStep(id) {
                var selectedId;
                if (typeof id === "string") {
                    selectedId = id;
                }
                selectedId = selectedId || this.state.selectedId;
                var clusterKind = selectedId;
                var __config = this._config, itemSelectedEvent = __config.itemSelectedEvent, selectedItemCookieName = __config.selectedItemCookieName;
                if (!selectedId) {
                    clusterKind = "empty";
                    selectedId = "other";
                }
                BigBrain("track", itemSelectedEvent, {
                    kind: clusterKind
                });
                if (selectedItemCookieName) {
                    (0,cookies_service/* setCookie */.d8)(selectedItemCookieName, selectedId);
                }
                if (!window.location.hash) {
                    window.location.href = window.location.href + STEP2_HASH;
                }
                this.setState({
                    firstStepCompleted: true,
                    selectedId: selectedId
                });
            }
        },
        {
            key: "renderItemSelectionForm",
            value: function renderItemSelectionForm() {
                var _this = this;
                var __config = this._config, options = __config.options, withoutContinueButton = __config.withoutContinueButton;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cluster-selection-options-wrapper",
                            children: options.map(function(option) {
                                return _this.renderOption(option);
                            })
                        }),
                        !withoutContinueButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "button-wrapper",
                            ref: function(el) {
                                return _this._nextButton = el;
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_component/* default */.Z, {
                                className: "btn-continue",
                                onClickCallback: this.nextStep,
                                color: "brand-blue",
                                children: "Continue"
                            })
                        })
                    ]
                });
            }
        },
        {
            key: "renderSecondStep",
            value: function renderSecondStep() {
                var secondStepScreen = this._config.secondStepScreen;
                if (secondStepScreen === "Solutions") return this.renderSolutionsScreen();
                return this.renderSelectedItemStep();
            }
        },
        {
            key: "renderSolutionsScreen",
            value: function renderSolutionsScreen() {
                var showDecorations = this.props.showDecorations;
                var selectedItem = this.getSelectedItem();
                var cta = this._config.ctaText || "Create your account";
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cluster-solutions-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClusterSolutionsComponent, {
                        showDecorations: showDecorations,
                        selectedCluster: selectedItem,
                        cta: cta
                    })
                });
            }
        },
        {
            key: "renderSelectedItemStep",
            value: function renderSelectedItemStep() {
                var showDecorations = this.props.showDecorations;
                var cta = this._config.ctaText || "Create your account";
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "selected-cluster-wrapper",
                            children: [
                                " ",
                                this.renderOption(this.getSelectedItem(), true)
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "button-wrapper-signup",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, {
                                buttonColor: "brand-blue",
                                ctaText: cta,
                                showDecorations: showDecorations
                            })
                        })
                    ]
                });
            }
        },
        {
            key: "getTitleHtml",
            value: function getTitleHtml() {
                var firstStepCompleted = this.state.firstStepCompleted;
                var __config = this._config, firstStepHtmlTitle = __config.firstStepHtmlTitle, secondStepHtmlTitle = __config.secondStepHtmlTitle, otherDetailsHtmlTitle = __config.otherDetailsHtmlTitle;
                if (!firstStepCompleted) return firstStepHtmlTitle;
                var selectedItem = this.getSelectedItem();
                if (selectedItem.secondStepHtmlTitle) return selectedItem.secondStepHtmlTitle;
                return selectedItem.isOther ? otherDetailsHtmlTitle : secondStepHtmlTitle;
            }
        },
        {
            key: "getSubtitleHtml",
            value: function getSubtitleHtml() {
                var __config = this._config, subtitleHtml = __config.subtitleHtml, secondStepSubtitleHtml = __config.secondStepSubtitleHtml;
                var firstStepCompleted = this.state.firstStepCompleted;
                if (firstStepCompleted) return secondStepSubtitleHtml;
                return subtitleHtml;
            }
        },
        {
            key: "render",
            value: function render() {
                var firstStepCompleted = this.state.firstStepCompleted;
                var titleHtml = this.getTitleHtml();
                var subTitleHtml = this.getSubtitleHtml();
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(cluster_selection_component_scss_componentStyles.__hash) + " " + "cluster-selection-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-".concat(cluster_selection_component_scss_componentStyles.__hash) + " " + "form-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: titleHtml
                                    },
                                    className: "jsx-".concat(cluster_selection_component_scss_componentStyles.__hash) + " " + "manage-title"
                                }),
                                subTitleHtml && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: subTitleHtml
                                    },
                                    className: "jsx-".concat(cluster_selection_component_scss_componentStyles.__hash) + " " + "manage-subtitle"
                                }),
                                firstStepCompleted ? this.renderSecondStep() : this.renderItemSelectionForm()
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: cluster_selection_component_scss_componentStyles.__hash,
                            children: cluster_selection_component_scss_componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return ClusterSelectionComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./components/segments/cluster-selection-one-step/clusters-selection-service.js

var ELEMENT_DIMENSIONS = {
    CLUSTER_SELECTION_ITEM_HEIGHT: 66,
    CLUSTER_SELECTION_ITEM_WIDTH: 540,
    CLUSTER_SELECTION_ITEM_MARGIN: 16
};
var OPEN_SIGNUP_ITEM_ANIMATION_DURATION = 300;
var CLUSTERS_SELECTION_CONFIG = [
    {
        id: "internal_projects",
        imgSrc: "/static/img/clusters-selection/projects_and_tasks.png",
        imgDimensions: {
            width: 20
        },
        title: "Projects & Tasks",
        color: colors/* default.brand-dark-blue */.Z["brand-dark-blue"],
        activeQuote: {
            personImage: "/static/img/clusters-selection/Ben_Allen_EQC_IT.png",
            personTitle: "Ben Allen, EQC IT",
            quoteText: '"It is a single easy to read one stop to see what projects are in the works and where we are at as well as plans for the future."'
        }
    },
    {
        id: "marketing",
        imgSrc: "/static/img/clusters-selection/marketing_and_creative.png",
        title: "Marketing & Creative",
        color: colors/* default.brand-yellow */.Z["brand-yellow"],
        activeQuote: {
            personImage: "/static/img/clusters-selection/Jelena_Tomic_Bell.png",
            personTitle: "Jelena Tomic, Bell",
            quoteText: '"It increases efficiency and overall communication, we are able to finish this within a week as opposed to previously. Without monday.com, it took us almost a month."'
        }
    },
    {
        id: "crm",
        imgSrc: "/static/img/clusters-selection/sales_and_crm.png",
        title: "Sales & CRM",
        color: colors/* default.brand-blue */.Z["brand-blue"],
        activeQuote: {
            personImage: "/static/img/clusters-selection/Aaste_Palczewski_Lostcabincapital.png",
            personTitle: "Aaste Palczewski, Lostcabincapital",
            quoteText: '"My team and I know exactly who we need to contact and where we are at with potential clients."'
        }
    },
    {
        id: "orders",
        imgSrc: "/static/img/clusters-selection/orders_and_production.png",
        title: "Orders & Production",
        color: colors/* default.brand-green */.Z["brand-green"],
        activeQuote: {
            personImage: "/static/img/clusters-selection/Gabriela_Luna",
            personTitle: "Gabriela Luna, Alvear",
            quoteText: '"monday.com has helped us keep all in order and allows everyone on our team to plan accordingly knowing exactly when it all will happen."'
        }
    },
    {
        id: "tech",
        imgSrc: "/static/img/clusters-selection/product_and_rnd.png",
        title: "Product & R&D",
        color: colors/* default.brand-red */.Z["brand-red"],
        activeQuote: {
            personImage: "/static/img/clusters-selection/Shachar_Tal_Loginno.png",
            personTitle: "Shachar Tal, Loginno",
            quoteText: '"Within a minute we understand exactly what is the status. It negates the need to have a weekly meeting and actually saves us time and improves our dev speed."'
        }
    },
    {
        id: "other",
        imgSrc: "/static/img/clusters-selection/other.png",
        title: "Other",
        color: colors/* default.brand-purple */.Z["brand-purple"],
        activeQuote: {
            personImage: "/static/img/clusters-selection/Ben_Allen_EQC_IT.png",
            personTitle: "Ben Allen, EQC IT",
            quoteText: '"It is a single easy to read one stop to see what projects are in the works and where we are at as well as plans for the future."'
        }
    }
];

;// CONCATENATED MODULE: ./components/segments/cluster-selection-one-step/cluster-selection-one-step-component.scss.js

var TRANSITION = "top ".concat(OPEN_SIGNUP_ITEM_ANIMATION_DURATION, "ms ease, bottom ").concat(OPEN_SIGNUP_ITEM_ANIMATION_DURATION, "ms ease");
var cluster_selection_one_step_component_scss_componentStyles = new String(".cluster-selection-one-step-component{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;.first-title{margin-top:65px;font-size:1.75rem;font-weight:700}.second-title{margin-top:16px;font-size:.875rem}.cluster-selection-items-wrapper{margin-top:40px;position:relative;.cluster-selection-item-component-wrapper{position:absolute;right:0;left:0;z-index:1;-webkit-transition:".concat(TRANSITION, ";-moz-transition:").concat(TRANSITION, ";-o-transition:").concat(TRANSITION, ";transition:").concat(TRANSITION, "}}}"));
cluster_selection_one_step_component_scss_componentStyles.__hash = "55a98ca0b365e1f8";

;// CONCATENATED MODULE: ./components/segments/cluster-selection-one-step/cluster-selection-item/cluster-selection-item-component.scss.js
var cluster_selection_item_component_scss_componentStyles = new String(".cluster-selection-item-component{position:absolute;top:0;right:0;bottom:16px;left:0;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;border:3px solid;-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px;cursor:pointer;padding:0px 24px;background-color:white;-webkit-box-shadow:0px 4px 8px 0px rgba(0,0,0,.14);-moz-box-shadow:0px 4px 8px 0px rgba(0,0,0,.14);box-shadow:0px 4px 8px 0px rgba(0,0,0,.14);-webkit-transition:-webkit-transform 200ms ease;-moz-transition:-moz-transform 200ms ease;-o-transition:-o-transform 200ms ease;transition:-webkit-transform 200ms ease;transition:-moz-transform 200ms ease;transition:-o-transform 200ms ease;transition:transform 200ms ease;&:hover{-webkit-transform:scale(1.025);-moz-transform:scale(1.025);-ms-transform:scale(1.025);-o-transform:scale(1.025);transform:scale(1.025)}.cluster-selection-item-image{width:30px;margin-right:16px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center}.title{-webkit-box-flex:1;-webkit-flex-grow:1;-moz-box-flex:1;-ms-flex-positive:1;flex-grow:1}}");
cluster_selection_item_component_scss_componentStyles.__hash = "ebcddd7151ed07b2";

;// CONCATENATED MODULE: ./components/segments/cluster-selection-one-step/cluster-selection-item/cluster-selection-item-component.js





function cluster_selection_item_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}






var ClusterSelectionItemComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ClusterSelectionItemComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ClusterSelectionItemComponent);
    function ClusterSelectionItemComponent(props) {
        (0,_class_call_check/* default */.Z)(this, ClusterSelectionItemComponent);
        var _this;
        _this = _super.call(this, props);
        cluster_selection_item_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onClick", function() {
            var _props = _this.props, id = _props.id, onClick = _props.onClick;
            onClick(id);
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(ClusterSelectionItemComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, imgSrc = _props.imgSrc, color = _props.color, isSelected = _props.isSelected, imgDimensions = _props.imgDimensions;
                var componentStyle = {
                    borderColor: color
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: componentStyle,
                    onClick: this.onClick,
                    className: "jsx-".concat(cluster_selection_item_component_scss_componentStyles.__hash) + " " + (classnames_default()("cluster-selection-item-component", {
                        selected: isSelected
                    }) || ""),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            pictureClass: "cluster-selection-item-image",
                            src: imgSrc,
                            alt: title,
                            specificImageStyle: imgDimensions
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(cluster_selection_item_component_scss_componentStyles.__hash) + " " + "title",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: cluster_selection_item_component_scss_componentStyles.__hash,
                            children: cluster_selection_item_component_scss_componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return ClusterSelectionItemComponent;
}(react.PureComponent);

ClusterSelectionItemComponent.defaultProps = {
    imgDimensions: {
        width: 30
    }
};

;// CONCATENATED MODULE: ./components/segments/cluster-selection-one-step/cluster-selection-signup-item/cluster-selection-signup-item-component.scss.js

var cluster_selection_signup_item_component_scss_componentStyles = new String(".cluster-selection-signup-item-component{position:absolute;top:0;right:0;bottom:16px;left:0;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;border:3px solid;-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px;background-color:white;-webkit-box-shadow:0px 4px 8px 0px rgba(0,0,0,.14);-moz-box-shadow:0px 4px 8px 0px rgba(0,0,0,.14);box-shadow:0px 4px 8px 0px rgba(0,0,0,.14);overflow:hidden;.close-icon-wrapper{position:absolute;top:11px;right:11px;padding:5px;cursor:pointer;svg {\n        height: 12px;\n      }\n    }.header{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;.image{width:30px;margin-right:16px}.title{font-size:1.688rem;font-weight:700}}.signup-form-wrapper{margin-top:24px}.quote-component-wrapper{margin-top:40px;padding:0px 32px;.person-quote{font-size:.875rem!important;line-height:22px!important}.person-title{font-size:.8125rem!important}.person-text-setcion{width:auto!important}}}");
cluster_selection_signup_item_component_scss_componentStyles.__hash = "f2f277ab31a3a66a";

// EXTERNAL MODULE: ./static/svg/icons/close.svg
var icons_close = __webpack_require__(2002);
;// CONCATENATED MODULE: ./components/segments/cluster-selection-one-step/cluster-selection-signup-item/cluster-selection-signup-item-component.js












var ClusterSelectionSignupItemComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ClusterSelectionSignupItemComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ClusterSelectionSignupItemComponent);
    function ClusterSelectionSignupItemComponent(props) {
        (0,_class_call_check/* default */.Z)(this, ClusterSelectionSignupItemComponent);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(ClusterSelectionSignupItemComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, imgSrc = _props.imgSrc, color = _props.color, onClick = _props.onClick, activeQuote = _props.activeQuote;
                var componentStyle = {
                    borderColor: color
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: componentStyle,
                    className: "jsx-".concat(cluster_selection_signup_item_component_scss_componentStyles.__hash) + " " + "cluster-selection-signup-item-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onClick: onClick,
                            className: "jsx-".concat(cluster_selection_signup_item_component_scss_componentStyles.__hash) + " " + "close-icon-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_close/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-".concat(cluster_selection_signup_item_component_scss_componentStyles.__hash) + " " + "header",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                    className: "image",
                                    src: imgSrc,
                                    alt: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-".concat(cluster_selection_signup_item_component_scss_componentStyles.__hash) + " " + "title",
                                    children: title
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(cluster_selection_signup_item_component_scss_componentStyles.__hash) + " " + "signup-form-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, {
                                buttonColor: "brand-iris",
                                ctaText: "Start now",
                                useCtaText: true,
                                forceHorizontal: true,
                                focusOnLoad: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(cluster_selection_signup_item_component_scss_componentStyles.__hash) + " " + "quote-component-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuoteComponent, {
                                activeQuote: activeQuote
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: cluster_selection_signup_item_component_scss_componentStyles.__hash,
                            children: cluster_selection_signup_item_component_scss_componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return ClusterSelectionSignupItemComponent;
}(react.PureComponent);


// EXTERNAL MODULE: ./constants/cookies.js
var cookies = __webpack_require__(13019);
;// CONCATENATED MODULE: ./components/segments/cluster-selection-one-step/cluster-selection-one-step-component.js





function cluster_selection_one_step_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function cluster_selection_one_step_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            cluster_selection_one_step_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function cluster_selection_one_step_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function cluster_selection_one_step_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        cluster_selection_one_step_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}











var ClusterSelectionOneStepComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ClusterSelectionOneStepComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ClusterSelectionOneStepComponent);
    function ClusterSelectionOneStepComponent(props) {
        (0,_class_call_check/* default */.Z)(this, ClusterSelectionOneStepComponent);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            selectedClusterSelectionItemId: null
        };
        _this.ITEM_HEIGHT = ELEMENT_DIMENSIONS.CLUSTER_SELECTION_ITEM_HEIGHT + ELEMENT_DIMENSIONS.CLUSTER_SELECTION_ITEM_MARGIN;
        _this.selectItem = _this.selectItem.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.clearSelectedItem = _this.clearSelectedItem.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(ClusterSelectionOneStepComponent, [
        {
            key: "selectItem",
            value: function selectItem(id) {
                this.setClusterItemZIndex(id, 2);
                this.setState({
                    selectedClusterSelectionItemId: id
                });
                BigBrain("track", bigbrain_event_types.CLUSTER_CLICKED, {
                    kind: id
                });
                (0,cookies_service/* setCookie */.d8)(cookies.USER_SELECTED_CLUSTER_COOKIE, id);
            }
        },
        {
            key: "clearSelectedItem",
            value: function clearSelectedItem() {
                var _this = this;
                var selectedClusterSelectionItemId = this.state.selectedClusterSelectionItemId;
                setTimeout(function() {
                    _this.setClusterItemZIndex(selectedClusterSelectionItemId, 1);
                }, OPEN_SIGNUP_ITEM_ANIMATION_DURATION);
                this.setState({
                    selectedClusterSelectionItemId: null
                });
            }
        },
        {
            key: "setClusterItemZIndex",
            value: function setClusterItemZIndex(id, zIndex) {
                document.getElementById(id).style.zIndex = zIndex;
            }
        },
        {
            key: "getClusterSelectionItemsWrapperHeight",
            value: function getClusterSelectionItemsWrapperHeight() {
                var numberOfItems = CLUSTERS_SELECTION_CONFIG.length;
                return numberOfItems * this.ITEM_HEIGHT;
            }
        },
        {
            key: "renderClusterItems",
            value: function renderClusterItems() {
                var _this = this;
                var selectedClusterSelectionItemId = this.state.selectedClusterSelectionItemId;
                return CLUSTERS_SELECTION_CONFIG.map(function(clusterSelection, index) {
                    var id = clusterSelection.id;
                    var isSelected = id === selectedClusterSelectionItemId;
                    var style = _this.getItemStyle(index, isSelected);
                    var Component = isSelected ? ClusterSelectionSignupItemComponent : ClusterSelectionItemComponent;
                    var onClick = isSelected ? _this.clearSelectedItem : _this.selectItem;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: id,
                        className: classnames_default()("cluster-selection-item-component-wrapper", {
                            selected: isSelected
                        }),
                        style: style,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, cluster_selection_one_step_component_object_spread_props(cluster_selection_one_step_component_object_spread({}, clusterSelection), {
                            onClick: onClick
                        }))
                    }, id);
                });
            }
        },
        {
            key: "getItemStyle",
            value: function getItemStyle(index, isSelected) {
                return {
                    top: isSelected ? 0 : this.ITEM_HEIGHT * index,
                    bottom: isSelected ? 0 : this.ITEM_HEIGHT * (CLUSTERS_SELECTION_CONFIG.length - 1 - index)
                };
            }
        },
        {
            key: "getClusterSelectionItemsWrapperStyle",
            value: function getClusterSelectionItemsWrapperStyle() {
                var clusterSelectionItemsWrapperHeight = this.getClusterSelectionItemsWrapperHeight();
                var clusterSelectionItemsWrapperWidth = ELEMENT_DIMENSIONS.CLUSTER_SELECTION_ITEM_WIDTH;
                return {
                    height: clusterSelectionItemsWrapperHeight,
                    width: clusterSelectionItemsWrapperWidth
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var clusterSelectionItemsWrapperStyle = this.getClusterSelectionItemsWrapperStyle();
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(cluster_selection_one_step_component_scss_componentStyles.__hash) + " " + "cluster-selection-one-step-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(cluster_selection_one_step_component_scss_componentStyles.__hash) + " " + "first-title",
                            children: "What would you like to manage ?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(cluster_selection_one_step_component_scss_componentStyles.__hash) + " " + "second-title",
                            children: "You can always change this later"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: clusterSelectionItemsWrapperStyle,
                            className: "jsx-".concat(cluster_selection_one_step_component_scss_componentStyles.__hash) + " " + "cluster-selection-items-wrapper",
                            children: this.renderClusterItems()
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: cluster_selection_one_step_component_scss_componentStyles.__hash,
                            children: cluster_selection_one_step_component_scss_componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return ClusterSelectionOneStepComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./components/segments/industry-selection/industry-selection-component.scss.js

var industry_selection_component_scss_componentStyles = new String(".industry-selection-wrapper{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center}@media(max-width:".concat(vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.industry-selection-wrapper{}}"));
industry_selection_component_scss_componentStyles.__hash = "d7cc0c9fc7c454d0";

// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.browser.esm.js + 13 modules
var react_select_browser_esm = __webpack_require__(16455);
// EXTERNAL MODULE: ./components/templates-generator/fields/dropdown/react-select.scss.js
var react_select_scss = __webpack_require__(80257);
;// CONCATENATED MODULE: ./services/industries/industries-service.js
var MANAGE_OPTION_TASKS = "Tasks";
var MANAGE_OPTION_RESOURCES = "Resources";
var MANAGE_OPTION_TIME_TRACKING = "Time tracking";
var MANAGE_OPTION_PROJECT_PLAN = "Project plan";
var MANAGE_OPTION_APPROVAL_PROCESS = "Approval process";
var MANAGE_OPTION_CLIENT_AND_BILLING = "Clients & Billing";
var MANAGE_OPTION_ROADMAP = "Roadmap";
var MANAGE_OPTION_TASK_ASSIGNMENT = "Task assignment";
var MANAGE_OPTION_TIMELINE = "Timeline";
var MANAGE_OPTION_PROGRESS_TRACKING = "Progress tracking";
var MANAGE_OPTION_SALES_PIPELINE = "Sales Pipeline";
var MANAGE_OPTION_CONTACTS = "Contacts";
var MANAGE_OPTION_PARTNERS = "Partners";
var MANAGE_OPTION_HR = "HR & Recruiting";
var MANAGE_OPTION_OPERATIONS = "Operations";
var MANAGE_OPTION_CAMPAIGNS = "Campaigns";
var MANAGE_OPTION_CREATIVE_ASSETS = "Creative assets";
var MANAGE_OPTION_EVENTS = "Events";
var MANAGE_OPTION_CAMPAIGN_SCHEDULE = "Campaign schedule";
var MANAGE_OPTION_SOCIAL_MEDIA_CALENDAR = "Social media calendar";
var MANAGE_OPTION_CREATIVE_REQUESTS = "Creative requests & approvals";
var MANAGE_OPTION_STORIES = "Stories & Epics";
var MANAGE_OPTION_SPRINTS = "Sprints";
var MANAGE_OPTION_FILES = "Files & assets";
var MANAGE_OPTION_BUGS = "Bugs queue";
var MANAGE_OPTION_CONTACTS_AND_LEADS = "Contacts & Leads";
var MANAGE_OPTION_PROJECT_GANTT = "Project gantt";
var MANAGE_OPTION_BACKLOG = "Backlog";
var MANAGE_OPTION_TICKETS_AND_REQUESTS = "Tickets & Requests";
var MANAGE_OPTION_EVENT_PLANNING = "Event planning";
var MANAGE_OPTION_INCOMMING_REQUESTS = "Incoming requests";
var MANAGE_OPTION_SUPPLY_CHAIN = "Supply chain";
var MANAGE_OPTION_ORDERS = "Orders";
var MANAGE_OPTION_PRODUCTION_FLOW = "Production Flow";
var MANAGE_OPTION_PROPERTIES = "Properties";
var MANAGE_OPTION_PAYMENTS_AND_BILLING = "Billing & Payments";
var MANAGE_OPTION_PROCESS_TRACKING = "Process tracking";
var MANAGE_OPTION_ASSIGNMENT = "Assignments";
var MANAGE_OPTION_RESEARCH = "Research";
var MANAGE_OPTION_ATTENDANCE = "Attendance";
var MANAGE_OPTION_DOCUMENTS = "Documents";
var DEFAULT_CLUSTER = "client_projects";
var INDUSTRIES_CONFIG = {
    firstStepHtmlTitle: "What does <strong>your team</strong> do?",
    secondStepHtmlTitle: "What would you like to <strong>manage</strong> with monday.com?",
    selectionDisclaimerHtml: "( Select as many as you want )",
    signupHtmlSubTitle: "We have the perfect solution waiting for you inside.<br>Sign up and get started.",
    options: [
        {
            value: "Accounting",
            label: "Accounting/Finance",
            clusterId: "client_projects",
            manageOptions: [
                MANAGE_OPTION_TIMELINE,
                MANAGE_OPTION_TASKS,
                MANAGE_OPTION_RESOURCES,
                MANAGE_OPTION_TIME_TRACKING,
                MANAGE_OPTION_APPROVAL_PROCESS,
                MANAGE_OPTION_PROJECT_PLAN,
                MANAGE_OPTION_CLIENT_AND_BILLING,
                MANAGE_OPTION_ROADMAP
            ]
        },
        {
            value: "Administrative",
            label: "Administrative/Operations",
            clusterId: "internal_projects",
            manageOptions: [
                MANAGE_OPTION_PROJECT_PLAN,
                MANAGE_OPTION_TASK_ASSIGNMENT,
                MANAGE_OPTION_TIMELINE,
                MANAGE_OPTION_RESOURCES,
                MANAGE_OPTION_TIME_TRACKING,
                MANAGE_OPTION_APPROVAL_PROCESS,
                MANAGE_OPTION_CLIENT_AND_BILLING,
                MANAGE_OPTION_PROGRESS_TRACKING
            ]
        },
        {
            value: "Architecture",
            label: "Architecture/Engineering",
            clusterId: "client_projects",
            manageOptions: [
                MANAGE_OPTION_PROJECT_PLAN,
                MANAGE_OPTION_PROCESS_TRACKING,
                MANAGE_OPTION_TASKS,
                MANAGE_OPTION_FILES,
                MANAGE_OPTION_CLIENT_AND_BILLING,
                MANAGE_OPTION_TIME_TRACKING,
                MANAGE_OPTION_APPROVAL_PROCESS,
                MANAGE_OPTION_TIMELINE,
                MANAGE_OPTION_OPERATIONS
            ]
        },
        {
            value: "Business Development",
            label: "Business Development",
            clusterId: "crm",
            manageOptions: [
                MANAGE_OPTION_TIMELINE,
                MANAGE_OPTION_SALES_PIPELINE,
                MANAGE_OPTION_CONTACTS,
                MANAGE_OPTION_TASK_ASSIGNMENT,
                MANAGE_OPTION_TIME_TRACKING,
                MANAGE_OPTION_PROJECT_PLAN,
                MANAGE_OPTION_PARTNERS,
                MANAGE_OPTION_PROGRESS_TRACKING
            ]
        },
        {
            value: "Business Owner",
            label: "Business Owner",
            clusterId: "internal_projects",
            manageOptions: [
                MANAGE_OPTION_PROJECT_PLAN,
                MANAGE_OPTION_TASK_ASSIGNMENT,
                MANAGE_OPTION_ROADMAP,
                MANAGE_OPTION_TIMELINE,
                MANAGE_OPTION_RESOURCES,
                MANAGE_OPTION_APPROVAL_PROCESS,
                MANAGE_OPTION_CLIENT_AND_BILLING,
                MANAGE_OPTION_HR,
                MANAGE_OPTION_OPERATIONS
            ]
        },
        {
            value: "Consulting",
            label: "Consulting",
            clusterId: "crm",
            manageOptions: [
                MANAGE_OPTION_PROJECT_PLAN,
                MANAGE_OPTION_TIME_TRACKING,
                MANAGE_OPTION_TASKS,
                MANAGE_OPTION_CLIENT_AND_BILLING,
                MANAGE_OPTION_PROGRESS_TRACKING,
                MANAGE_OPTION_APPROVAL_PROCESS,
                MANAGE_OPTION_RESOURCES,
                MANAGE_OPTION_TIMELINE
            ]
        },
        {
            value: "Creative",
            label: "Creative Services/Design",
            clusterId: "marketing",
            manageOptions: [
                MANAGE_OPTION_CREATIVE_REQUESTS,
                MANAGE_OPTION_CAMPAIGNS,
                MANAGE_OPTION_PROJECT_PLAN,
                MANAGE_OPTION_CREATIVE_ASSETS,
                MANAGE_OPTION_TIME_TRACKING,
                MANAGE_OPTION_CLIENT_AND_BILLING,
                MANAGE_OPTION_APPROVAL_PROCESS,
                MANAGE_OPTION_TASK_ASSIGNMENT
            ]
        },
        {
            value: "Education",
            label: "Education",
            clusterId: "internal_projects",
            manageOptions: [
                MANAGE_OPTION_PROJECT_PLAN,
                MANAGE_OPTION_TASKS,
                MANAGE_OPTION_ASSIGNMENT,
                MANAGE_OPTION_OPERATIONS,
                MANAGE_OPTION_RESOURCES,
                MANAGE_OPTION_RESEARCH,
                MANAGE_OPTION_EVENTS,
                MANAGE_OPTION_ATTENDANCE
            ]
        },
        {
            value: "Events",
            label: "Events",
            clusterId: "client_projects",
            manageOptions: [
                MANAGE_OPTION_TIMELINE,
                MANAGE_OPTION_TASK_ASSIGNMENT,
                MANAGE_OPTION_SOCIAL_MEDIA_CALENDAR,
                MANAGE_OPTION_CREATIVE_REQUESTS,
                MANAGE_OPTION_EVENT_PLANNING,
                MANAGE_OPTION_CLIENT_AND_BILLING,
                MANAGE_OPTION_TIME_TRACKING,
                MANAGE_OPTION_PROCESS_TRACKING
            ]
        },
        {
            value: "IT",
            label: "IT",
            clusterId: "client_projects",
            manageOptions: [
                MANAGE_OPTION_PROJECT_PLAN,
                MANAGE_OPTION_TASK_ASSIGNMENT,
                MANAGE_OPTION_TICKETS_AND_REQUESTS,
                MANAGE_OPTION_TIMELINE,
                MANAGE_OPTION_SPRINTS,
                MANAGE_OPTION_TIME_TRACKING,
                MANAGE_OPTION_CLIENT_AND_BILLING,
                MANAGE_OPTION_RESOURCES,
                MANAGE_OPTION_APPROVAL_PROCESS
            ]
        },
        {
            value: "Legal",
            label: "Legal",
            clusterId: "client_projects",
            manageOptions: [
                MANAGE_OPTION_PROJECT_PLAN,
                MANAGE_OPTION_TIMELINE,
                MANAGE_OPTION_TIME_TRACKING,
                MANAGE_OPTION_CLIENT_AND_BILLING,
                MANAGE_OPTION_TASKS,
                MANAGE_OPTION_DOCUMENTS,
                MANAGE_OPTION_INCOMMING_REQUESTS,
                MANAGE_OPTION_APPROVAL_PROCESS
            ]
        },
        {
            value: "Manufacturing",
            label: "Manufacturing/Production",
            clusterId: "orders",
            manageOptions: [
                MANAGE_OPTION_SUPPLY_CHAIN,
                MANAGE_OPTION_ORDERS,
                MANAGE_OPTION_PRODUCTION_FLOW,
                MANAGE_OPTION_RESOURCES,
                MANAGE_OPTION_TIMELINE,
                MANAGE_OPTION_TIME_TRACKING,
                MANAGE_OPTION_APPROVAL_PROCESS,
                MANAGE_OPTION_PROGRESS_TRACKING,
                MANAGE_OPTION_PROJECT_PLAN
            ]
        },
        {
            value: "Marketing",
            label: "Marketing/Media/Advertising",
            clusterId: "marketing",
            manageOptions: [
                MANAGE_OPTION_TIMELINE,
                MANAGE_OPTION_TASK_ASSIGNMENT,
                MANAGE_OPTION_CAMPAIGN_SCHEDULE,
                MANAGE_OPTION_SOCIAL_MEDIA_CALENDAR,
                MANAGE_OPTION_CREATIVE_REQUESTS,
                MANAGE_OPTION_EVENT_PLANNING,
                MANAGE_OPTION_CLIENT_AND_BILLING,
                MANAGE_OPTION_TIME_TRACKING,
                MANAGE_OPTION_PROGRESS_TRACKING
            ]
        },
        {
            value: "Product Management",
            label: "Product Management",
            clusterId: "tech",
            manageOptions: [
                MANAGE_OPTION_ROADMAP,
                MANAGE_OPTION_STORIES,
                MANAGE_OPTION_SPRINTS,
                MANAGE_OPTION_TASKS,
                MANAGE_OPTION_TIMELINE,
                MANAGE_OPTION_RESOURCES,
                MANAGE_OPTION_PROJECT_PLAN,
                MANAGE_OPTION_FILES
            ]
        },
        {
            value: "Project Management",
            label: "Project Management",
            clusterId: "internal_projects",
            manageOptions: [
                MANAGE_OPTION_PROJECT_PLAN,
                MANAGE_OPTION_TASK_ASSIGNMENT,
                MANAGE_OPTION_TIMELINE,
                MANAGE_OPTION_RESOURCES,
                MANAGE_OPTION_TIME_TRACKING,
                MANAGE_OPTION_APPROVAL_PROCESS,
                MANAGE_OPTION_CLIENT_AND_BILLING,
                MANAGE_OPTION_PROGRESS_TRACKING,
                MANAGE_OPTION_ROADMAP
            ]
        },
        {
            value: "Real Estate",
            label: "Real Estate",
            clusterId: "crm",
            manageOptions: [
                MANAGE_OPTION_PROPERTIES,
                MANAGE_OPTION_PAYMENTS_AND_BILLING,
                MANAGE_OPTION_PROJECT_PLAN,
                MANAGE_OPTION_TIMELINE,
                MANAGE_OPTION_SALES_PIPELINE,
                MANAGE_OPTION_CONTACTS_AND_LEADS,
                MANAGE_OPTION_TASKS,
                MANAGE_OPTION_PROGRESS_TRACKING,
                MANAGE_OPTION_PAYMENTS_AND_BILLING
            ]
        },
        {
            value: "Research",
            label: "Reasearch/BI/Data",
            clusterId: "internal_projects",
            manageOptions: [
                MANAGE_OPTION_PROJECT_PLAN,
                MANAGE_OPTION_TIMELINE,
                MANAGE_OPTION_TASK_ASSIGNMENT,
                MANAGE_OPTION_RESOURCES,
                MANAGE_OPTION_TASKS,
                MANAGE_OPTION_APPROVAL_PROCESS,
                MANAGE_OPTION_FILES,
                MANAGE_OPTION_TIME_TRACKING,
                MANAGE_OPTION_RESEARCH
            ]
        },
        {
            value: "Sales",
            label: "Sales",
            clusterId: "crm",
            manageOptions: [
                MANAGE_OPTION_SALES_PIPELINE,
                MANAGE_OPTION_CONTACTS_AND_LEADS,
                MANAGE_OPTION_PROJECT_PLAN,
                MANAGE_OPTION_TASK_ASSIGNMENT,
                MANAGE_OPTION_PROGRESS_TRACKING,
                MANAGE_OPTION_PAYMENTS_AND_BILLING,
                MANAGE_OPTION_RESOURCES,
                MANAGE_OPTION_TIMELINE
            ]
        },
        {
            value: "Software Development",
            label: "Software Development",
            clusterId: "tech",
            manageOptions: [
                MANAGE_OPTION_SPRINTS,
                MANAGE_OPTION_ROADMAP,
                MANAGE_OPTION_TASKS,
                MANAGE_OPTION_BUGS,
                MANAGE_OPTION_TIME_TRACKING,
                MANAGE_OPTION_PROJECT_GANTT,
                MANAGE_OPTION_BACKLOG,
                MANAGE_OPTION_TIMELINE
            ]
        },
        {
            value: "Other",
            label: "Other",
            clusterId: "client_projects",
            manageOptions: [
                MANAGE_OPTION_PROJECT_PLAN,
                MANAGE_OPTION_TASK_ASSIGNMENT,
                MANAGE_OPTION_TIMELINE,
                MANAGE_OPTION_RESOURCES,
                MANAGE_OPTION_TIME_TRACKING,
                MANAGE_OPTION_APPROVAL_PROCESS,
                MANAGE_OPTION_CLIENT_AND_BILLING,
                MANAGE_OPTION_PROGRESS_TRACKING
            ]
        }
    ]
};
var getIndustryOptionByValue = function(industry) {
    return INDUSTRIES_CONFIG.options.filter(function(option) {
        return option.value === industry;
    })[0];
};

;// CONCATENATED MODULE: ./components/segments/industry-selection/manage-options/manage-options-component.scss.js
var manage_options_component_scss_componentStyles = new String(".manage-options-wrapper.jsx-67fca27265b77cfa{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;max-width:800px;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center}");
manage_options_component_scss_componentStyles.__hash = "67fca27265b77cfa";

;// CONCATENATED MODULE: ./components/segments/industry-selection/manage-options/manage-option-component.scss.js
var manage_option_component_scss_componentStyles = new String(".manage-option-box.jsx-7032eb4b5c67b7aa{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;height:40px;margin:12px 12px 0 0;padding:0 16px;-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px;cursor:pointer;border:1px solid rgba(225,225,225,1);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;.manage-option.jsx-7032eb4b5c67b7aa{font-size:.875rem;line-height:30px}&.selected.jsx-7032eb4b5c67b7aa{border:1px solid transparent}}");
manage_option_component_scss_componentStyles.__hash = "7032eb4b5c67b7aa";

;// CONCATENATED MODULE: ./components/segments/industry-selection/manage-options/manage-option-component.js










var ManageOptionComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ManageOptionComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ManageOptionComponent);
    function ManageOptionComponent(props) {
        (0,_class_call_check/* default */.Z)(this, ManageOptionComponent);
        var _this;
        _this = _super.call(this, props);
        _this.onSelectItem = _this.onSelectItem.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(ManageOptionComponent, [
        {
            key: "onSelectItem",
            value: function onSelectItem() {
                var _props = this.props, optionText = _props.optionText, onSelect = _props.onSelect;
                onSelect(optionText);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, optionText = _props.optionText, isSelected = _props.isSelected;
                var backgroundColor = isSelected ? "rgba(163, 88, 223, 0.1)" : "none";
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        background: backgroundColor
                    },
                    onClick: this.onSelectItem,
                    className: "jsx-".concat(manage_option_component_scss_componentStyles.__hash) + " " + (classnames_default()("manage-option-box", {
                        selected: isSelected
                    }) || ""),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(manage_option_component_scss_componentStyles.__hash) + " " + "manage-option",
                            children: optionText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: manage_option_component_scss_componentStyles.__hash,
                            children: manage_option_component_scss_componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return ManageOptionComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./components/segments/industry-selection/manage-options/manage-options-component.js










var ManageOptionsComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ManageOptionsComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ManageOptionsComponent);
    function ManageOptionsComponent(props) {
        (0,_class_call_check/* default */.Z)(this, ManageOptionsComponent);
        var _this;
        _this = _super.call(this, props);
        _this.renderOption = _this.renderOption.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(ManageOptionsComponent, [
        {
            key: "renderOption",
            value: function renderOption(option) {
                var _props = this.props, onSelect = _props.onSelect, selectedOptions = _props.selectedOptions;
                var isSelected = selectedOptions.indexOf(option) > -1;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ManageOptionComponent, {
                    optionText: option,
                    onSelect: onSelect,
                    isSelected: isSelected
                }, option);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var options = this.props.options;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(manage_options_component_scss_componentStyles.__hash) + " " + "manage-options-wrapper",
                    children: [
                        options.map(function(option) {
                            return _this.renderOption(option);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: manage_options_component_scss_componentStyles.__hash,
                            children: manage_options_component_scss_componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return ManageOptionsComponent;
}(react.PureComponent);


// EXTERNAL MODULE: ./static/svg/arrow-right.svg
var arrow_right = __webpack_require__(6051);
;// CONCATENATED MODULE: ./components/segments/industry-selection/industry-selection-first-step/industry-selection-first-step-component.scss.js


var industry_selection_first_step_component_scss_componentStyles = new String(".industry-selection-first-step-wrapper{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;.industry-selection-questions{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-height:80vh;.industry-question-wrapper{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding-top:15vh;-webkit-transition:padding.2s;-moz-transition:padding.2s;-o-transition:padding.2s;transition:padding.2s;.industry-question{font-size:1.375rem;padding-top:8px;text-align:center;strong {\n            font-weight: bold;\n          }\n        }.industry-selection-options-wrapper{padding-top:24px;.Select-control{cursor:pointer}.Select-menu-outer{max-height:none;.Select-menu{min-height:255px}}}&.industry-selected{padding-top:5vh}}.manage-question-wrapper{padding-top:60px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;opacity:0;-webkit-transition:opacity.2s ease-in-out;-moz-transition:opacity.2s ease-in-out;-o-transition:opacity.2s ease-in-out;transition:opacity.2s ease-in-out;.select-disclaimer{font-size:.875rem;font-weight:300;text-align:center;padding-top:16px}.manage-options-question{font-size:1.375rem;padding-top:16px;text-align:center;strong {\n            font-weight: bold;\n          }\n        }&.visible{opacity:1}}}.next-wrapper{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;font-size:1rem;letter-spacing:-.01em;line-height:30px;color:".concat(colors/* default.brand-blue */.Z["brand-blue"], ";opacity:0;-webkit-transition:opacity.2s;-moz-transition:opacity.2s;-o-transition:opacity.2s;transition:opacity.2s;svg {\n        fill: ").concat(colors/* default.brand-blue */.Z["brand-blue"], ";\n      }\n\n      &.visible {\n        opacity: 1;\n      }\n\n      .next-link {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n\n        .next-circle {\n          background: rgba(43, 185, 255, 1);\n          box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);\n          width: 28px;\n          height: 28px;\n          border-radius: 50%;\n          color: white;\n          font-size: 1.125rem;\n          line-height: 24px;\n          text-align: center;\n\n          .arrow {\n            padding-top: 2px;\n            padding-left: 2px;\n          }\n\n          svg {\n            fill: white;\n          }\n        }\n      }\n    }}@media(max-width:").concat(vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.industry-selection-first-step-wrapper{}}"));
industry_selection_first_step_component_scss_componentStyles.__hash = "b8ef98c1e9da05c6";
var stepNumberStyles = new String(".step-number-circle.jsx-f17ebfa745dafa4{border:1px solid rgba(43,185,255,1);width:28px;height:28px;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;color:rgba(43,185,255,1);font-size:1.125rem;line-height:24px;text-align:center}");
stepNumberStyles.__hash = "f17ebfa745dafa4";

;// CONCATENATED MODULE: ./components/segments/industry-selection/industry-selection-first-step/industry-selection-first-step-component.jsx





function industry_selection_first_step_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function industry_selection_first_step_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            industry_selection_first_step_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function industry_selection_first_step_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function industry_selection_first_step_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        industry_selection_first_step_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










var IndustrySelectionFirstStepComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(IndustrySelectionFirstStepComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(IndustrySelectionFirstStepComponent);
    function IndustrySelectionFirstStepComponent(props) {
        (0,_class_call_check/* default */.Z)(this, IndustrySelectionFirstStepComponent);
        var _this;
        _this = _super.call(this, props);
        _this.onNextClick = _this.onNextClick.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.renderNextButton = _this.renderNextButton.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(IndustrySelectionFirstStepComponent, [
        {
            key: "renderStepNumber",
            value: function renderStepNumber(stepNumber) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(stepNumberStyles.__hash) + " " + "step-number-circle",
                            children: stepNumber
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: stepNumberStyles.__hash,
                            children: stepNumberStyles
                        })
                    ]
                });
            }
        },
        {
            key: "renderIndustryQuestion",
            value: function renderIndustryQuestion() {
                var _props = this.props, selectedIndustry = _props.selectedIndustry, handleSelectIndustryChange = _props.handleSelectIndustryChange;
                var questionHtml = INDUSTRIES_CONFIG.firstStepHtmlTitle;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("industry-question-wrapper", {
                        "industry-selected": !!selectedIndustry
                    }),
                    children: [
                        this.renderStepNumber(1),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "industry-question",
                            dangerouslySetInnerHTML: {
                                __html: questionHtml
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-".concat(react_select_scss/* default.__hash */.Z.__hash) + " " + "industry-selection-options-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_browser_esm/* default */.ZP, {
                                    name: "industry-options",
                                    isClearable: false,
                                    isSearchable: false,
                                    styles: {
                                        control: function(base) {
                                            return industry_selection_first_step_component_object_spread_props(industry_selection_first_step_component_object_spread({}, base), {
                                                fontSize: "14px",
                                                height: "40px",
                                                boxShadow: "none",
                                                minWidth: "320px"
                                            });
                                        }
                                    },
                                    placeholder: "Choose one from the list",
                                    value: selectedIndustry,
                                    onChange: handleSelectIndustryChange,
                                    options: INDUSTRIES_CONFIG.options
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                                    id: react_select_scss/* default.__hash */.Z.__hash,
                                    children: react_select_scss/* default */.Z
                                })
                            ]
                        })
                    ]
                });
            }
        },
        {
            key: "renderManageOptionsQuestion",
            value: function renderManageOptionsQuestion() {
                var _props = this.props, selectedIndustry = _props.selectedIndustry, selectedManageOptions = _props.selectedManageOptions, handleOptionsSelected = _props.handleOptionsSelected, onNextClick = _props.onNextClick;
                var questionHtml = INDUSTRIES_CONFIG.secondStepHtmlTitle;
                var diclaimer = INDUSTRIES_CONFIG.selectionDisclaimerHtml;
                var industryData = getIndustryOptionByValue(selectedIndustry) || {};
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("manage-question-wrapper", {
                        visible: !!selectedIndustry
                    }),
                    children: [
                        this.renderStepNumber(2),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "manage-options-question",
                            dangerouslySetInnerHTML: {
                                __html: questionHtml
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "select-disclaimer",
                            dangerouslySetInnerHTML: {
                                __html: diclaimer
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ManageOptionsComponent, {
                            options: industryData.manageOptions || [],
                            selectedOptions: selectedManageOptions,
                            onSelect: handleOptionsSelected
                        })
                    ]
                });
            }
        },
        {
            key: "onNextClick",
            value: function onNextClick() {
                var nextStepCallback = this.props.nextStepCallback;
                nextStepCallback();
            }
        },
        {
            key: "renderNextButton",
            value: function renderNextButton() {
                var selectedManageOptions = this.props.selectedManageOptions;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("next-wrapper", {
                        visible: selectedManageOptions.length > 0
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: "next-link",
                        onClick: this.onNextClick,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "next-circle",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right/* default */.Z, {
                                    className: "arrow"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "next-link",
                                children: "Next"
                            })
                        ]
                    })
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(industry_selection_first_step_component_scss_componentStyles.__hash) + " " + "industry-selection-first-step-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-".concat(industry_selection_first_step_component_scss_componentStyles.__hash) + " " + "industry-selection-questions",
                            children: [
                                this.renderIndustryQuestion(),
                                this.renderManageOptionsQuestion()
                            ]
                        }),
                        this.renderNextButton(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: industry_selection_first_step_component_scss_componentStyles.__hash,
                            children: industry_selection_first_step_component_scss_componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return IndustrySelectionFirstStepComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./components/segments/industry-selection/industry-selection-second-step/industry-selection-second-step.scss.js
var industry_selection_second_step_scss_componentStyles = new String(".industry-selection-second-step-wrapper{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;height:-webkit-calc(100vh - 65px);height:-moz-calc(100vh - 65px);height:calc(100vh - 65px);-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-width:25vw;.done-gif-wrapper{min-height:150px}.signup-title{font-size:1.969rem;font-weight:bold;text-align:center}.signup-subtitle{padding-top:12px;font-size:1rem;font-weight:300;text-align:center;line-height:31px}.signup-wrapper{padding-top:32px;width:100%}}");
industry_selection_second_step_scss_componentStyles.__hash = "942a6ffdad8072f8";

;// CONCATENATED MODULE: ./components/segments/industry-selection/industry-selection-second-step/industry-selection-second-step-component.jsx











var IndustrySelectionSecondStepComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(IndustrySelectionSecondStepComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(IndustrySelectionSecondStepComponent);
    function IndustrySelectionSecondStepComponent(props) {
        (0,_class_call_check/* default */.Z)(this, IndustrySelectionSecondStepComponent);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(IndustrySelectionSecondStepComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(industry_selection_second_step_scss_componentStyles.__hash) + " " + "industry-selection-second-step-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(industry_selection_second_step_scss_componentStyles.__hash) + " " + "done-gif-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/static/img/industry-selection/done.gif",
                                className: "jsx-".concat(industry_selection_second_step_scss_componentStyles.__hash)
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(industry_selection_second_step_scss_componentStyles.__hash) + " " + "signup-title",
                            children: " That’s awesome!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: INDUSTRIES_CONFIG.signupHtmlSubTitle
                            },
                            className: "jsx-".concat(industry_selection_second_step_scss_componentStyles.__hash) + " " + "signup-subtitle"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(industry_selection_second_step_scss_componentStyles.__hash) + " " + "signup-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: industry_selection_second_step_scss_componentStyles.__hash,
                            children: industry_selection_second_step_scss_componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return IndustrySelectionSecondStepComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./components/segments/industry-selection/industry-selection-component.js















var industry_selection_component_STEP2_HASH = "#step2";
var IndustrySelectionComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(IndustrySelectionComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(IndustrySelectionComponent);
    function IndustrySelectionComponent(props) {
        (0,_class_call_check/* default */.Z)(this, IndustrySelectionComponent);
        var _this;
        _this = _super.call(this, props);
        _this.nextStep = _this.nextStep.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onBrowserHashChangeEvent = _this.onBrowserHashChangeEvent.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.handleSelectIndustryChange = _this.handleSelectIndustryChange.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onSelectOption = _this.onSelectOption.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.state = {
            firstStepCompleted: false,
            selectedIndustry: null,
            selectedManageOptions: []
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(IndustrySelectionComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                window.onhashchange = this.onBrowserHashChangeEvent;
            }
        },
        {
            key: "handleSelectIndustryChange",
            value: function handleSelectIndustryChange(selectedOption) {
                var value = selectedOption.value;
                BigBrain("track", bigbrain_event_types.INDUSTRY_SELECTED, {
                    kind: value
                });
                this.setState({
                    selectedIndustry: value,
                    selectedManageOptions: []
                });
            }
        },
        {
            key: "onSelectOption",
            value: function onSelectOption(option) {
                var selectedManageOptions = this.state.selectedManageOptions;
                var newManageOptions;
                var selectedTextForEvent;
                if (selectedManageOptions.indexOf(option) > -1) {
                    newManageOptions = selectedManageOptions.filter(function(selectedOption) {
                        return selectedOption != option;
                    });
                    selectedTextForEvent = "removed";
                } else {
                    newManageOptions = selectedManageOptions.concat(option);
                    selectedTextForEvent = "selected";
                }
                BigBrain("track", bigbrain_event_types.INDUSTRY_MANAGE_OPTION_CLICKED, {
                    kind: option,
                    info1: selectedTextForEvent
                });
                this.setState({
                    selectedManageOptions: newManageOptions
                });
            }
        },
        {
            key: "onBrowserHashChangeEvent",
            value: function onBrowserHashChangeEvent() {
                var hash = window.location.hash;
                if (hash.length === 0) {
                    this.setState({
                        firstStepCompleted: false
                    });
                }
            }
        },
        {
            key: "nextStep",
            value: function nextStep() {
                var _state = this.state, selectedIndustry = _state.selectedIndustry, selectedManageOptions = _state.selectedManageOptions;
                if (!window.location.hash) {
                    window.location.href += industry_selection_component_STEP2_HASH;
                }
                var selectedOption = getIndustryOptionByValue(selectedIndustry);
                BigBrain("track", bigbrain_event_types.INDUSTRY_NEXT_CLICKED, {
                    info1: selectedIndustry,
                    info2: selectedManageOptions.join(",")
                });
                (0,cookies_service/* setCookie */.d8)(cookies.USER_SELECTED_CLUSTER_COOKIE, selectedOption.clusterId || DEFAULT_CLUSTER);
                (0,cookies_service/* setCookie */.d8)(cookies.USER_SELECTED_INDUSTRY_COOKIE, selectedIndustry);
                this.setState({
                    firstStepCompleted: true
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _state = this.state, firstStepCompleted = _state.firstStepCompleted, selectedIndustry = _state.selectedIndustry, selectedManageOptions = _state.selectedManageOptions;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(industry_selection_component_scss_componentStyles.__hash) + " " + "industry-selection-wrapper",
                    children: [
                        !firstStepCompleted && /*#__PURE__*/ (0,jsx_runtime.jsx)(IndustrySelectionFirstStepComponent, {
                            nextStepCallback: this.nextStep,
                            selectedIndustry: selectedIndustry,
                            selectedManageOptions: selectedManageOptions,
                            handleSelectIndustryChange: this.handleSelectIndustryChange,
                            handleOptionsSelected: this.onSelectOption
                        }),
                        firstStepCompleted && /*#__PURE__*/ (0,jsx_runtime.jsx)(IndustrySelectionSecondStepComponent, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: industry_selection_component_scss_componentStyles.__hash,
                            children: industry_selection_component_scss_componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return IndustrySelectionComponent;
}(react.PureComponent);


// EXTERNAL MODULE: ./components/core/tabs/tabs-component.js + 1 modules
var tabs_component = __webpack_require__(10873);
// EXTERNAL MODULE: ./components/core/tabs/tab/tab-component.js + 1 modules
var tab_component = __webpack_require__(20525);
// EXTERNAL MODULE: ./components/core/paragraph-and-asset-columns/paragraph-and-asset-columns-component.js + 1 modules
var paragraph_and_asset_columns_component = __webpack_require__(68137);
;// CONCATENATED MODULE: ./components/segments/multiple-tabs/multiple-tabs-desktop/multiple-tabs-desktop-component.js




function multiple_tabs_desktop_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function multiple_tabs_desktop_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            multiple_tabs_desktop_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function multiple_tabs_desktop_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function multiple_tabs_desktop_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        multiple_tabs_desktop_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var MultipleTabsComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(MultipleTabsComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(MultipleTabsComponent);
    function MultipleTabsComponent(props) {
        (0,_class_call_check/* default */.Z)(this, MultipleTabsComponent);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(MultipleTabsComponent, [
        {
            key: "tabsRenderer",
            value: function tabsRenderer() {
                var _props = this.props, tabs = _props.tabs, tabsColor = _props.tabsColor;
                return tabs.map(function(tab, index) {
                    var tabLabel = tab.tabLabel, paragraphAndAssetColumns = tab.paragraphAndAssetColumns;
                    if (paragraphAndAssetColumns && paragraphAndAssetColumns.content) {
                        paragraphAndAssetColumns.content = multiple_tabs_desktop_component_object_spread({}, paragraphAndAssetColumns.content);
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(tab_component/* default */.Z, {
                        autoTransition: 0,
                        label: tabLabel,
                        color: tabsColor,
                        children: /*#__PURE__*/ (0,react.createElement)(paragraph_and_asset_columns_component/* default */.Z, multiple_tabs_desktop_component_object_spread_props(multiple_tabs_desktop_component_object_spread({}, paragraphAndAssetColumns), {
                            key: index
                        }))
                    }, index);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "multiple-tabs-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_component/* default */.Z, {
                        children: this.tabsRenderer()
                    })
                });
            }
        }
    ]);
    return MultipleTabsComponent;
}(react.PureComponent);

MultipleTabsComponent.defaultProps = {
    tabs: []
};

// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
;// CONCATENATED MODULE: ./components/segments/multiple-tabs/multiple-tabs-mobile/multiple-tabs-mobile-component.js




function multiple_tabs_mobile_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function multiple_tabs_mobile_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            multiple_tabs_mobile_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function multiple_tabs_mobile_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function multiple_tabs_mobile_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        multiple_tabs_mobile_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var multiple_tabs_mobile_component_MultipleTabsComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(MultipleTabsComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(MultipleTabsComponent);
    function MultipleTabsComponent(props) {
        (0,_class_call_check/* default */.Z)(this, MultipleTabsComponent);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(MultipleTabsComponent, [
        {
            key: "tabsRenderer",
            value: function tabsRenderer() {
                var tabs = this.props.tabs;
                return tabs.map(function(tab, index) {
                    var paragraphAndAssetColumns = tab.paragraphAndAssetColumns;
                    var copyParagraphAndAssetColumns = cloneDeep_default()(paragraphAndAssetColumns);
                    if (copyParagraphAndAssetColumns && copyParagraphAndAssetColumns.content) {
                        copyParagraphAndAssetColumns.content = multiple_tabs_mobile_component_object_spread_props(multiple_tabs_mobile_component_object_spread({}, copyParagraphAndAssetColumns.content), {
                            title: tab.tabLabel
                        });
                    }
                    return /*#__PURE__*/ (0,react.createElement)(paragraph_and_asset_columns_component/* default */.Z, multiple_tabs_mobile_component_object_spread_props(multiple_tabs_mobile_component_object_spread({}, copyParagraphAndAssetColumns), {
                        key: index
                    }));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "multiple-tabs-component",
                    children: this.tabsRenderer()
                });
            }
        }
    ]);
    return MultipleTabsComponent;
}(react.PureComponent);

multiple_tabs_mobile_component_MultipleTabsComponent.defaultProps = {
    tabs: []
};

;// CONCATENATED MODULE: ./components/segments/multiple-tabs/multiple-tabs-component.js



/* harmony default export */ var multiple_tabs_component = ((0,responsive_hoc_component/* default */.Z)(MultipleTabsComponent, multiple_tabs_mobile_component_MultipleTabsComponent));

// EXTERNAL MODULE: ./components/core/paragraph-with-logos/paragraph-with-logos-component.js + 1 modules
var paragraph_with_logos_component = __webpack_require__(42832);
;// CONCATENATED MODULE: ./components/segments/integrations/integrations-component.scss.js


var StyledIntegrationsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e9niwj00"
})(".image-gallery{margin:16px;width:20%;.social-proof-gallery-picture{img{width:100%;}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.images-gallery-row{.image-gallery{margin:8px;width:44%;}}}");

;// CONCATENATED MODULE: ./components/segments/integrations/integrations-component.js




function integrations_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function integrations_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            integrations_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function integrations_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function integrations_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        integrations_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




var INTEGRATIONS_ASSETS = [
    [
        {
            url: "/static/img/integrations/dropbox.png",
            alt: "Dropbox",
            href: "https://support.monday.com/hc/en-us/articles/115005339505-How-do-I-upload-files-and-attachments-in-monday-com-"
        },
        {
            url: "/static/img/integrations/excel.png",
            alt: "Excel",
            href: "https://support.monday.com/hc/en-us/articles/360000219209-How-to-import-and-export-to-Excel-"
        },
        {
            url: "/static/img/integrations/google_calendar.png",
            alt: "Google Calendar",
            href: "https://support.monday.com/hc/en-us/articles/360001362725-How-can-I-integrate-my-board-with-my-calendar-"
        },
        {
            url: "/static/img/integrations/google_drive.png",
            alt: "Google Drive",
            href: "https://support.monday.com/hc/en-us/articles/115005339505-How-do-I-upload-files-and-attachments-in-monday-com-"
        },
        {
            url: "/static/img/integrations/integromat.png",
            alt: "Integromat",
            href: "https://support.monday.com/hc/en-us/articles/360001265649-How-to-sync-timelines-between-2-boards-with-Integromat"
        },
        {
            url: "/static/img/integrations/slack.png",
            alt: "Slack",
            href: "https://support.monday.com/hc/en-us/articles/360001183089-How-to-use-the-Slack-internal-integration-"
        },
        {
            url: "/static/img/integrations/trello.png",
            alt: "Trello",
            href: "https://support.monday.com/hc/en-us/articles/360000274165-How-can-I-import-my-boards-from-Trello"
        },
        {
            url: "/static/img/integrations/zapier.png",
            alt: "Zapier",
            href: "https://support.monday.com/hc/en-us/articles/115005934989-How-to-create-an-integration-using-Zapier"
        }
    ]
];
var IntegrationsComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(IntegrationsComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(IntegrationsComponent);
    function IntegrationsComponent() {
        (0,_class_call_check/* default */.Z)(this, IntegrationsComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(IntegrationsComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIntegrationsComponent, {
                    className: "integrations-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "paragraph-with-logos-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph_with_logos_component/* default */.Z, integrations_component_object_spread_props(integrations_component_object_spread({}, this.props), {
                            shadow: true
                        }))
                    })
                });
            }
        }
    ]);
    return IntegrationsComponent;
}(react.PureComponent);

IntegrationsComponent.defaultProps = {
    assets: INTEGRATIONS_ASSETS
};

;// CONCATENATED MODULE: ./static/svg/decorators/main-video/top-left-decoration.svg
var top_left_decoration_g;
function top_left_decoration_extends() {
    top_left_decoration_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return top_left_decoration_extends.apply(this, arguments);
}

var SvgTopLeftDecoration = function SvgTopLeftDecoration(props) {
    return /*#__PURE__*/ react.createElement("svg", top_left_decoration_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 42,
        height: 56,
        viewBox: "0 0 42 56"
    }, props), top_left_decoration_g || (top_left_decoration_g = /*#__PURE__*/ react.createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        transform: "translate(-9)"
    }, /*#__PURE__*/ react.createElement("g", {
        fill: "#333",
        transform: "rotate(-11 78.427 2.537)"
    }, /*#__PURE__*/ react.createElement("rect", {
        width: 6.087,
        height: 21.864,
        x: 39.063,
        y: 0.369,
        rx: 3.043,
        transform: "rotate(-10 42.106 11.301)"
    }), /*#__PURE__*/ react.createElement("rect", {
        width: 6.087,
        height: 27.682,
        x: 14.753,
        y: 0.789,
        rx: 3.043,
        transform: "rotate(-43 17.797 14.63)"
    }), /*#__PURE__*/ react.createElement("rect", {
        width: 6.087,
        height: 24.199,
        x: 10.341,
        y: 28.71,
        rx: 3.043,
        transform: "rotate(-77 13.385 40.81)"
    })), /*#__PURE__*/ react.createElement("circle", {
        cx: 26,
        cy: 3,
        r: 3,
        fill: "#A358DF"
    }), /*#__PURE__*/ react.createElement("circle", {
        cx: 12,
        cy: 37,
        r: 3,
        fill: "#A358DF"
    }))));
};
/* harmony default export */ var top_left_decoration = (SvgTopLeftDecoration);

;// CONCATENATED MODULE: ./components/segments/main-youtube-video/main-youtube-video-component.scss.js


var StyledMainYoutubeVideoComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1m07p7h0"
})("display:flex;flex-direction:column;align-items:center;.video-component-wrapper{display:flex;align-items:center;position:relative;width:", function(param) {
    var width = param.width;
    return width;
}, ";height:", function(param) {
    var height = param.height;
    return height;
}, ";.youtube-video-with-poster-component{box-shadow:0 2px 16px 0 rgba(0,0,0,0.2);}.video-decoration-wrapper{position:absolute;top:-40px;left:-40px;align-self:flex-start;}.poster-image-wrapper img,iframe{width:", function(param) {
    var width = param.width;
    return width;
}, ";height:", function(param) {
    var height = param.height;
    return height;
}, ";}.lottie-animation-wrapper{position:absolute;right:-100px;top:70%;.lottie-animation-component{height:115px;width:88px;}.animation-text{transform:translateX(36%);max-width:100%;}}}.main-video-title{margin-top:24px;font-size:1.375rem;}@media (max-width:", vp_sizes/* MAX_DESKTOP_CONTENT_WIDTH */.O$ + 100, "px){.video-component-wrapper{width:90vw;height:50vw;.video-decoration-wrapper{transform:rotateZ(30deg);top:-36px;left:-14px;svg{width:4vw;}}.poster-image-wrapper img,iframe{width:90vw;height:50vw;}.lottie-animation-wrapper{display:none;}}.main-video-title{margin-top:16px;}}");

;// CONCATENATED MODULE: ./components/segments/main-youtube-video/main-youtube-video-component.js




function main_youtube_video_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function main_youtube_video_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            main_youtube_video_component_define_property(target, key, source[key]);
        });
    }
    return target;
}







var LOTTIE_ANIMATION_CONFIG = {
    animation: {
        jsonPath: "/static/lottie/arrow-turn-left.json",
        loop: false,
        autoplay: false,
        playOnlyWhenVisible: true
    },
    style: {}
};
var MainYoutubeVideoComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(MainYoutubeVideoComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(MainYoutubeVideoComponent);
    function MainYoutubeVideoComponent() {
        (0,_class_call_check/* default */.Z)(this, MainYoutubeVideoComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(MainYoutubeVideoComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, youtubeVideoId = _props.youtubeVideoId, poster = _props.poster, showDecorations = _props.showDecorations, title = _props.title, animationText = _props.animationText, width = _props.width, height = _props.height;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMainYoutubeVideoComponent, {
                    width: width,
                    height: height,
                    className: "main-youtube-video-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "video-component-wrapper",
                            children: [
                                showDecorations && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "video-decoration-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(top_left_decoration, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(youtube_video_with_poster_component/* default */.Z, {
                                    videoId: youtubeVideoId,
                                    poster: poster,
                                    muted: false,
                                    volume: 100
                                }),
                                showDecorations && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "lottie-animation-wrapper",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lottie_animation_component/* default */.Z, main_youtube_video_component_object_spread({}, LOTTIE_ANIMATION_CONFIG)),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "animation-text",
                                            children: animationText
                                        })
                                    ]
                                })
                            ]
                        }),
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(colorful_title_component/* default */.Z, {
                            className: "main-video-title",
                            text: title
                        })
                    ]
                });
            }
        }
    ]);
    return MainYoutubeVideoComponent;
}(react.PureComponent);

MainYoutubeVideoComponent.defaultProps = {
    showDecorations: true,
    youtubeVideoId: "1UbaEcto56k",
    poster: "/static/img/templates/long-template/segments/boards/board-with-cactus-and-phone.png",
    title: "monday.com in 60 sec",
    animationText: "Take a tour",
    width: "1050px",
    height: "570px"
};

;// CONCATENATED MODULE: ./components/segments/button-with-animation/button-with-animation-component.scss.js


var StyledButtonWithAnimationComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e10747st0"
})("position:relative;display:flex;justify-content:center;.inline-flex-wrapper{display:inline-flex;flex-direction:column;justify-content:center;position:relative;}&.left{justify-content:flex-start;}&.right{justify-content:flex-end;}.lottie-animation-wrapper{align-self:flex-end;width:150px;position:absolute;transform:translateX(95%) translateY(30px);top:0;right:0;}.button-wrapper{align-self:flex-end;}.button-wrapper.bounce-button{animation:bounce linear 0.8s;animation-iteration-count:1;transform-origin:50% 50%;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.lottie-animation-wrapper{left:0;right:0;margin:auto;transform:translateX(25%) translateY(86%) rotateZ(45deg);}}@keyframes bounce{0%{transform:translate(0px,0px);}15%{transform:translate(-10px,-10px);}30%{transform:translate(0px,0px);}45%{transform:translate(-7px,-7px);}60%{transform:translate(0px,0px);}75%{transform:translate(-3px,-3px);}100%{transform:translate(0px,0px);}}");

;// CONCATENATED MODULE: ./components/segments/button-with-animation/button-with-animation-component.js






function button_with_animation_component_define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function button_with_animation_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            button_with_animation_component_define_property1(target, key, source[key]);
        });
    }
    return target;
}
function button_with_animation_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function button_with_animation_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        button_with_animation_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var INITIAL_LOTTIE_ANIMATION_CONFIG = {
    animation: {
        jsonPath: "/static/lottie/arrow-swirl-left.json",
        loop: false,
        autoplay: false,
        playOnlyWhenVisible: true
    },
    style: {
        height: "100%"
    }
};
var FIRE_ACTION_FRAME = 27;
var ButtonWithAnimationComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ButtonWithAnimationComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ButtonWithAnimationComponent);
    function ButtonWithAnimationComponent(props) {
        (0,_class_call_check/* default */.Z)(this, ButtonWithAnimationComponent);
        var _this;
        _this = _super.call(this, props);
        _this.bounceSignup = _this.bounceSignup.bind((0,_assert_this_initialized/* default */.Z)(_this));
        INITIAL_LOTTIE_ANIMATION_CONFIG.fireActionOnFrame = {
            frame: FIRE_ACTION_FRAME,
            action: _this.bounceSignup
        };
        _this.state = {
            animated: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(ButtonWithAnimationComponent, [
        {
            key: "bounceSignup",
            value: function bounceSignup() {
                var _this = this;
                if (this.state.animated) return;
                this.setState({
                    animated: true
                }, function() {
                    setTimeout(function() {
                        _this.setState({
                            animated: false
                        });
                    }, 2000);
                });
            }
        },
        {
            key: "getLottieConfig",
            value: function getLottieConfig(color) {
                var lottieConfig = button_with_animation_component_object_spread({}, INITIAL_LOTTIE_ANIMATION_CONFIG);
                lottieConfig.style = button_with_animation_component_object_spread_props(button_with_animation_component_object_spread({}, lottieConfig.style), {
                    color: color
                });
                return lottieConfig;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, lottie = _props.lottie, withAnimation = _props.withAnimation, button = _props.button, direction = _props.direction, textColor = _props.textColor;
                var lottieConfig = this.getLottieConfig(textColor);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonWithAnimationComponent, {
                    className: classnames_default()("button-with-animation-component", (0,src_define_property/* default */.Z)({}, direction, direction)),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "inline-flex-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("button-wrapper", {
                                    "bounce-button": this.state.animated
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_link_component, button_with_animation_component_object_spread_props(button_with_animation_component_object_spread({}, button), {
                                    children: button.text
                                }))
                            }),
                            withAnimation && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lottie-animation-wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lottie_animation_component/* default */.Z, button_with_animation_component_object_spread({}, lottieConfig))
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return ButtonWithAnimationComponent;
}(react.PureComponent);

ButtonWithAnimationComponent.defaultProps = {
    button: {
        color: "brand-dark-blue",
        href: "/help",
        text: "Contact Us",
        fontSize: "16px",
        textColor: "white"
    },
    withAnimation: true
};

// EXTERNAL MODULE: ./components/segments/signup-with-animation/signup-with-animation-component.js + 1 modules
var signup_with_animation_component = __webpack_require__(32201);
;// CONCATENATED MODULE: ./components/segments/hero-image/hero-image-component.scss.js

var StyledHeroImageComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e16parts0"
})("position:relative;overflow:hidden;.hero-image{img{width:100%;}}.text-and-assets-background{position:absolute;z-index:2;height:180vh;width:180vh;top:50%;transform:translateY(-50%);background-color:white;border-radius:50%;}.text-and-assets-component-wrapper{position:absolute;z-index:3;top:0;right:0;bottom:0;left:0;display:flex;align-items:center;margin-left:96px;.paragaph-and-asset-component{flex-grow:1;}}");

;// CONCATENATED MODULE: ./constants/dimensions.js
/* harmony default export */ var dimensions = ({
    TOP_BAR_HEIGHT: 65
});

// EXTERNAL MODULE: ./components/segments/text-and-asset/text-and-asset-component.js
var text_and_asset_component = __webpack_require__(31745);
;// CONCATENATED MODULE: ./components/segments/hero-image/hero-image-component.js




function hero_image_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hero_image_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hero_image_component_define_property(target, key, source[key]);
        });
    }
    return target;
}






var HeroImageComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(HeroImageComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(HeroImageComponent);
    function HeroImageComponent(props) {
        (0,_class_call_check/* default */.Z)(this, HeroImageComponent);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(HeroImageComponent, [
        {
            key: "getComponentStyles",
            value: function getComponentStyles() {
                var height = this.props.height;
                return {
                    height: "calc(".concat(height, " - ").concat(dimensions.TOP_BAR_HEIGHT, "px)")
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, halfMoonWidth = _props.halfMoonWidth, textAndAssets = _props.textAndAssets, heroImage = _props.heroImage;
                var src = heroImage.src, alt = heroImage.alt;
                var styles = this.getComponentStyles();
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroImageComponent, {
                    className: "hero-image-component",
                    style: styles,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            pictureClass: "hero-image",
                            src: src,
                            alt: alt
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-and-assets-background",
                            style: {
                                left: "calc(-180vh + ".concat(halfMoonWidth, ")")
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-and-assets-component-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_and_asset_component/* default */.Z, hero_image_component_object_spread({}, textAndAssets))
                        })
                    ]
                });
            }
        }
    ]);
    return HeroImageComponent;
}(react.PureComponent);

HeroImageComponent.defaultProps = {
    height: "100vh",
    halfMoonWidth: "40vw",
    heroImage: {}
};

// EXTERNAL MODULE: ./components/segments/social-proof/social-proof-component.js + 1 modules
var social_proof_component = __webpack_require__(18925);
;// CONCATENATED MODULE: ./components/segments/index.js
function segments_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function segments_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            segments_define_property(target, key, source[key]);
        });
    }
    return target;
}

























/* harmony default export */ var segments = (segments_object_spread({
    TwoColumnsWithCarousel: TwoColumnsWithCarouselComponent,
    PersonComponent: PersonComponent,
    HeaderWithImageAndTitle: HeaderWithImageAndTitleComponent,
    TitleAndSubtitleComponent: TitleAndSubtitleComponent,
    VideosGalleryComponent: videos_gallery_component/* default */.Z,
    VideosCarouselComponent: VideosCarouselSegmentComponent,
    FormWithTextAndAssetsComponent: FormWithTextAndAssetsComponent,
    SwitchingTitleWithQuotesCarouselComponent: SwitchingTitleWithQuotesCarouselComponent,
    LottieAnimationComponent: lottie_animation_component/* default */.Z,
    BoardViewsComponent: BoardViewsComponent,
    FactCardsComponent: FactCardsComponent,
    MultipleTabsComponent: multiple_tabs_component,
    IntegrationsComponent: IntegrationsComponent,
    MainYoutubeVideoComponent: MainYoutubeVideoComponent,
    ButtonWithAnimationComponent: ButtonWithAnimationComponent,
    SignupWithAnimationComponent: signup_with_animation_component/* default */.Z,
    EmbeddedFormComponent: embedded_form_component,
    SimpoComponent: SimpoComponent,
    ClusterSelectionComponent: ClusterSelectionComponent,
    ClusterSelectionOneStepComponent: ClusterSelectionOneStepComponent,
    IndustrySelectionComponent: IndustrySelectionComponent,
    HeroImageComponent: HeroImageComponent,
    SocialProofComponent: social_proof_component/* default */.Z,
    RegularAssetComponent: regular_asset_component["default"]
}, basic_segments/* default */.Z));


/***/ }),

/***/ 80257:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/**
 * React Select
 * ============
 * Created by Jed Watson and Joss Mackison for KeystoneJS, http://www.keystonejs.com/
 * https://twitter.com/jedwatson https://twitter.com/jossmackison https://twitter.com/keystonejs
 * MIT License: https://github.com/JedWatson/react-select
 */ var _defaultExport = new String(".Select{position:relative}.Select input::-webkit-contacts-auto-fill-button,.Select input::-webkit-credentials-auto-fill-button{display:none!important}.Select input::-ms-clear{display:none!important}.Select input::-ms-reveal{display:none!important}.Select,.Select div,.Select input,.Select span{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.Select.is-disabled .Select-arrow-zone{cursor:default;pointer-events:none;opacity:.35}.Select.is-disabled>.Select-control{background-color:#f9f9f9}.Select.is-disabled>.Select-control:hover{-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none}.Select.is-open>.Select-control{-webkit-border-bottom-right-radius:0;-moz-border-radius-bottomright:0;border-bottom-right-radius:0;-webkit-border-bottom-left-radius:0;-moz-border-radius-bottomleft:0;border-bottom-left-radius:0;background:#fff;border-color:#b3b3b3#ccc#d9d9d9}.Select.is-open>.Select-control .Select-arrow{top:-2px;border-color:transparent transparent#999;border-width:0 5px 5px}.Select.is-searchable.is-open>.Select-control{cursor:text}.Select.is-searchable.is-focused:not(.is-open)>.Select-control{cursor:text}.Select.is-focused>.Select-control{background:#fff}.Select.is-focused:not(.is-open)>.Select-control{border-color:#007eff;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 0 3px rgba(0,126,255,.1);-moz-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 0 3px rgba(0,126,255,.1);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 0 3px rgba(0,126,255,.1);background:#fff}.Select.has-value.is-clearable.Select--single>.Select-control .Select-value{padding-right:42px}.Select.has-value.Select--single>.Select-control .Select-value .Select-value-label,.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value .Select-value-label{color:#333}.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label,.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label{cursor:pointer;text-decoration:none}.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:hover,.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:hover,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus,.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus{color:#007eff;outline:none;text-decoration:underline}.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus,.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus{background:#fff}.Select.has-value.is-pseudo-focused .Select-input{opacity:0}.Select.is-open .Select-arrow,.Select .Select-arrow-zone:hover>.Select-arrow{border-top-color:#666}.Select.Select--rtl{direction:rtl;text-align:right}.Select-control{background-color:#fff;border-color:#d9d9d9#ccc#b3b3b3;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;border:1px solid#ccc;color:#333;cursor:default;display:table;border-spacing:0;border-collapse:separate;height:36px;outline:none;overflow:hidden;position:relative;width:100%}.Select-control:hover{-webkit-box-shadow:0 1px 0 rgba(0,0,0,.06);-moz-box-shadow:0 1px 0 rgba(0,0,0,.06);box-shadow:0 1px 0 rgba(0,0,0,.06)}.Select-control .Select-input:focus{outline:none;background:#fff}.Select-placeholder,.Select--single>.Select-control .Select-value{bottom:0;color:#aaa;left:0;line-height:34px;padding-left:10px;padding-right:10px;position:absolute;right:0;top:0;max-width:100%;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap}.Select-input{height:34px;padding-left:10px;padding-right:10px;vertical-align:middle}.Select-input>input{width:100%;background:none transparent;border:0 none;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;cursor:default;display:inline-block;font-family:inherit;font-size:inherit;margin:0;outline:none;line-height:17px;padding:8px 0 12px;-webkit-appearance:none}.is-focused .Select-input>input{cursor:text}.has-value.is-pseudo-focused .Select-input{opacity:0}.Select-control:not(.is-searchable)>.Select-input{outline:none}.Select-loading-zone{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:16px}.Select-loading{-webkit-animation:Select-animation-spin 400ms infinite linear;-o-animation:Select-animation-spin 400ms infinite linear;-moz-animation:Select-animation-spin 400ms infinite linear;animation:Select-animation-spin 400ms infinite linear;width:16px;height:16px;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;border:2px solid#ccc;border-right-color:#333;display:inline-block;position:relative;vertical-align:middle}.Select-clear-zone{-webkit-animation:Select-animation-fadeIn 200ms;-o-animation:Select-animation-fadeIn 200ms;-moz-animation:Select-animation-fadeIn 200ms;animation:Select-animation-fadeIn 200ms;color:#999;cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:17px}.Select-clear-zone:hover{color:#d0021b}.Select-clear{display:inline-block;font-size:1rem;line-height:1}.Select--multi .Select-clear-zone{width:17px}.Select-arrow-zone{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:25px;padding-right:5px}.Select--rtl .Select-arrow-zone{padding-right:0;padding-left:5px}.Select-arrow{border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 2.5px;display:inline-block;height:0;width:0;position:relative}.Select-control>*:last-child{padding-right:5px}.Select--multi .Select-multi-value-wrapper{display:inline-block}.Select .Select-aria-only{position:absolute;display:inline-block;height:1px;width:1px;margin:-1px;clip:rect(0,0,0,0);overflow:hidden;float:left}@-webkit-keyframes Select-animation-fadeIn{from{opacity:0}to{opacity:1}}@-moz-keyframes Select-animation-fadeIn{from{opacity:0}to{opacity:1}}@-o-keyframes Select-animation-fadeIn{from{opacity:0}to{opacity:1}}@keyframes Select-animation-fadeIn{from{opacity:0}to{opacity:1}}.Select-menu-outer{-webkit-border-bottom-right-radius:4px;-moz-border-radius-bottomright:4px;border-bottom-right-radius:4px;-webkit-border-bottom-left-radius:4px;-moz-border-radius-bottomleft:4px;border-bottom-left-radius:4px;background-color:#fff;border:1px solid#ccc;border-top-color:#e6e6e6;-webkit-box-shadow:0 1px 0 rgba(0,0,0,.06);-moz-box-shadow:0 1px 0 rgba(0,0,0,.06);box-shadow:0 1px 0 rgba(0,0,0,.06);-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;margin-top:-1px;max-height:200px;position:absolute;left:0;top:100%;width:100%;z-index:1;-webkit-overflow-scrolling:touch}.Select-menu{max-height:198px;overflow-y:auto}.Select-option{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;background-color:#fff;color:#666;cursor:pointer;display:block;padding:8px 10px}.Select-option:last-child{-webkit-border-bottom-right-radius:4px;-moz-border-radius-bottomright:4px;border-bottom-right-radius:4px;-webkit-border-bottom-left-radius:4px;-moz-border-radius-bottomleft:4px;border-bottom-left-radius:4px}.Select-option.is-selected{background-color:#f5faff;background-color:rgba(0,126,255,.04);color:#333}.Select-option.is-focused{background-color:#ebf5ff;background-color:rgba(0,126,255,.08);color:#333}.Select-option.is-disabled{color:#ccc;cursor:default}.Select-noresults{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;color:#999;cursor:default;display:block;padding:8px 10px}.Select--multi .Select-input{vertical-align:middle;margin-left:10px;padding:0}.Select--multi.Select--rtl .Select-input{margin-left:0;margin-right:10px}.Select--multi.has-value .Select-input{margin-left:5px}.Select--multi .Select-value{background-color:#ebf5ff;background-color:rgba(0,126,255,.08);-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px;border:1px solid#c2e0ff;border:1px solid rgba(0,126,255,.24);color:#007eff;display:inline-block;font-size:.9em;line-height:1.4;margin-left:5px;margin-top:5px;vertical-align:top}.Select--multi .Select-value-icon,.Select--multi .Select-value-label{display:inline-block;vertical-align:middle}.Select--multi .Select-value-label{-webkit-border-bottom-right-radius:2px;-moz-border-radius-bottomright:2px;border-bottom-right-radius:2px;-webkit-border-top-right-radius:2px;-moz-border-radius-topright:2px;border-top-right-radius:2px;cursor:default;padding:2px 5px}.Select--multi a.Select-value-label{color:#007eff;cursor:pointer;text-decoration:none}.Select--multi a.Select-value-label:hover{text-decoration:underline}.Select--multi .Select-value-icon{cursor:pointer;-webkit-border-bottom-left-radius:2px;-moz-border-radius-bottomleft:2px;border-bottom-left-radius:2px;-webkit-border-top-left-radius:2px;-moz-border-radius-topleft:2px;border-top-left-radius:2px;border-right:1px solid#c2e0ff;border-right:1px solid rgba(0,126,255,.24);padding:1px 5px 3px}.Select--multi .Select-value-icon:hover,.Select--multi .Select-value-icon:focus{background-color:#d8eafd;background-color:rgba(0,113,230,.08);color:#0071e6}.Select--multi .Select-value-icon:active{background-color:#c2e0ff;background-color:rgba(0,126,255,.24)}.Select--multi.Select--rtl .Select-value{margin-left:0;margin-right:5px}.Select--multi.Select--rtl .Select-value-icon{border-right:none;border-left:1px solid#c2e0ff;border-left:1px solid rgba(0,126,255,.24)}.Select--multi.is-disabled .Select-value{background-color:#fcfcfc;border:1px solid#e3e3e3;color:#333}.Select--multi.is-disabled .Select-value-icon{cursor:not-allowed;border-right:1px solid#e3e3e3}.Select--multi.is-disabled .Select-value-icon:hover,.Select--multi.is-disabled .Select-value-icon:focus,.Select--multi.is-disabled .Select-value-icon:active{background-color:#fcfcfc}@-webkit-keyframes Select-animation-spin{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@-moz-keyframes Select-animation-spin{to{-moz-transform:rotate(1turn);transform:rotate(1turn)}}@-o-keyframes Select-animation-spin{to{-o-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes Select-animation-spin{to{-webkit-transform:rotate(1turn);-moz-transform:rotate(1turn);-o-transform:rotate(1turn);transform:rotate(1turn)}}@-webkit-keyframes Select-animation-spin{to{-webkit-transform:rotate(1turn)}}");
_defaultExport.__hash = "de83615747459409";
/* harmony default export */ __webpack_exports__["Z"] = (_defaultExport);


/***/ }),

/***/ 98181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ regular_asset_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./constants/cloudinary-asset-qualities.js
var cloudinary_asset_qualities = __webpack_require__(65832);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(97650);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./contexts/segment-context.js
var segment_context = __webpack_require__(39944);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/regular-asset/regular-asset-component.scss.js


var StyledRegularAssetComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1kmitw10"
})("width:100%;.asset-component-wrapper{max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;display:flex;&.left{justify-content:flex-start;}&.center{justify-content:center;}&.right{justify-content:flex-end;}&.full-width{max-width:none;}.regular-asset-image-wrapper{.regular-asset-image{width:100% !important;height:auto;}}video{display:block !important;}}");

;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/regular-asset/regular-asset-component.js

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}












var RegularAssetComponent = function(props) {
    var isMobileOrTabletBrowser = props.isMobileOrTabletBrowser, backgroundColor = props.backgroundColor, width = props.width, mobileWidth = props.mobileWidth, position = props.position, asset = props.asset, assetQuality = props.assetQuality, useDynamicAsset = props.useDynamicAsset, hideControls = props.hideControls, dynamicAssetParamPath = props.dynamicAssetParamPath, fullWidth = props.fullWidth, useWindowMask = props.useWindowMask, minHeight = props.minHeight, segmentNumber = props.segmentNumber;
    var finalWidth = isMobileOrTabletBrowser && mobileWidth ? mobileWidth : width;
    var widthInPercentage = finalWidth ? "".concat(finalWidth, "%") : "auto";
    var ref = (0,_sliced_to_array/* default */.Z)((0,react_intersection_observer_modern/* useInView */.YD)({
        threshold: 1.0,
        triggerOnce: true
    }), 2), assetRef = ref[0], assetFullyInView = ref[1];
    (0,react.useEffect)(function() {
        if (asset && assetFullyInView) {
            var image = asset.image, video = asset.video;
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.ASSET_COMPONENT_IS_FULLY_VISIBLE, {
                kind: (image === null || image === void 0 ? void 0 : image.src) || (video === null || video === void 0 ? void 0 : video.src),
                info1: segmentNumber
            });
        }
    }, [
        assetFullyInView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRegularAssetComponent, {
        className: "regular-asset-component",
        style: {
            backgroundColor: colors/* default */.Z[backgroundColor],
            minHeight: minHeight
        },
        ref: assetRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()("asset-component-wrapper", position, {
                "full-width": fullWidth
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, _object_spread_props(_object_spread({}, asset), {
                assetQuality: assetQuality,
                useDynamicAsset: useDynamicAsset,
                hideControls: hideControls,
                width: widthInPercentage,
                convertGifToVideo: true,
                className: "regular-asset-image-wrapper",
                imageClassName: "regular-asset-image",
                dynamicAssetParamPath: dynamicAssetParamPath,
                useWindowMask: useWindowMask
            }))
        })
    });
};
RegularAssetComponent.defaultProps = {
    width: 100,
    position: "center",
    asset: {
        image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/img/segment-layout-default-images/asset/timeline-view.png"
        }
    },
    assetQuality: cloudinary_asset_qualities.AUTO,
    fullWidth: false
};
/* harmony default export */ var regular_asset_component = ((0,segment_context/* withSegmentsData */.c)((0,generic_config_context/* withGenericConfig */.P)(RegularAssetComponent)));


/***/ }),

/***/ 14285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ long_footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./client/services/cluster-config-service/cluster-config-service.js
var cluster_config_service = __webpack_require__(79092);
// EXTERNAL MODULE: ./components/core/short-footer/short-footer.js + 5 modules
var short_footer = __webpack_require__(56914);
;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/default-props.js
/* harmony default export */ var default_props = ({});

// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/footer-category/footer-category-component.js + 1 modules
var footer_category_component = __webpack_require__(70212);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/long-footer.scss.js
var long_footer_scss = __webpack_require__(17619);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/footer-bottom-bar-component.js + 10 modules
var footer_bottom_bar_component = __webpack_require__(46374);
// EXTERNAL MODULE: ./services/localization/localization-service.js
var localization_service = __webpack_require__(99952);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/long-footer.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}












var Footer = function(props) {
    var translate = props.translate, localeId = props.localeId, abTests = props.abTests, pageClusterConfig = props.pageClusterConfig, useProductMiniSiteConfig = props.useProductMiniSiteConfig, setStartShowingStickyHeader = props.setStartShowingStickyHeader, isInView = props.isInView;
    (0,react.useEffect)(function() {
        setStartShowingStickyHeader(!isInView);
    }, [
        isInView,
        setStartShowingStickyHeader
    ]);
    var LONG_FOOTER = "long";
    var renderShortFooter = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(short_footer/* default */.Z, _object_spread({}, props));
    };
    var renderLongFooter = function() {
        var getFullFooterForLocalized = true;
        var footerComponents = (0,localization_service/* getFooterComponents */.L8)(localeId, abTests, getFullFooterForLocalized, {});
        if (pageClusterConfig) {
            (0,cluster_config_service/* updateClusterFooterLinks */.R4)(pageClusterConfig, footerComponents, {
                useProductMiniSiteConfig: useProductMiniSiteConfig
            });
        }
        var MondayFooterLinks = footerComponents.MondayFooterLinks, OurTeamFooterLinksV2 = footerComponents.OurTeamFooterLinksV2, MoreByMondayFooterLinks = footerComponents.MoreByMondayFooterLinks, UseCasesFooterLinksV2 = footerComponents.UseCasesFooterLinksV2, ResourcesFooterLinks = footerComponents.ResourcesFooterLinks, ProductsFooterLinks = footerComponents.ProductsFooterLinks, FeaturesFooterLinks = footerComponents.FeaturesFooterLinks;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(long_footer_scss/* StyledFooter */.tc, {
            className: "footer-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "footer-content-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        className: "footer-content",
                        "aria-label": "Footer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "categories-container",
                            children: [
                                MondayFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        title: translate(MondayFooterLinks.title),
                                        links: MondayFooterLinks.links,
                                        hasMondayLogoTitle: MondayFooterLinks.hasMondayLogoTitle
                                    })
                                }),
                                FeaturesFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container features",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        title: translate(FeaturesFooterLinks.title),
                                        links: FeaturesFooterLinks.links
                                    })
                                }),
                                ProductsFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container products",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "categories-colmmn-wrapper",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                                type: ProductsFooterLinks.type,
                                                title: translate(ProductsFooterLinks.title),
                                                links: ProductsFooterLinks.links
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                                type: MoreByMondayFooterLinks.type,
                                                title: translate(MoreByMondayFooterLinks.title),
                                                links: MoreByMondayFooterLinks.links
                                            })
                                        ]
                                    })
                                }),
                                UseCasesFooterLinksV2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        title: translate(UseCasesFooterLinksV2.title),
                                        links: UseCasesFooterLinksV2.links
                                    })
                                }),
                                OurTeamFooterLinksV2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        type: OurTeamFooterLinksV2.type,
                                        title: translate(OurTeamFooterLinksV2.title),
                                        links: OurTeamFooterLinksV2.links
                                    })
                                }),
                                ResourcesFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        type: ResourcesFooterLinks.type,
                                        title: translate(ResourcesFooterLinks.title),
                                        links: ResourcesFooterLinks.links
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_bottom_bar_component/* default */.Z, {
                    SocialFooterLinks: links/* SocialFooterLinks */.Ff7,
                    footerType: LONG_FOOTER
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_scss/* StyledDesktopFooterContainer */.w2, {
                className: "footer-desktop-wrapper",
                children: renderLongFooter()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_scss/* StyledMobileFooterContainer */.qJ, {
                className: "footer-mobile-wrapper",
                children: renderShortFooter()
            })
        ]
    });
};
/* harmony default export */ var long_footer = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(Footer)));
Footer.defaultProps = default_props;


/***/ }),

/***/ 82249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ CLUSTER_MOBILE_OPTION_VALUE; },
/* harmony export */   "e": function() { return /* binding */ CLUSTER_CONFIG_MOBILE; }
/* harmony export */ });
/* harmony import */ var _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65023);

var CLUSTER_MOBILE_OPTION_VALUE = "cluster-mobile";
var CLUSTER_CONFIG_MOBILE = {
    firstStepHtmlTitle: "<strong>What would you like to manage with monday.com?</strong>",
    secondStepHtmlTitle: "That's great! <br><strong>Now, let's get to work</strong>",
    otherDetailsHtmlTitle: "That's great! <br><strong>Now, let's get to work</strong>",
    itemClickedEvent: _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_0__.MOBILE_CLUSTER_CLICKED,
    itemSelectedEvent: _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_0__.MOBILE_CLUSTER_SELECTED,
    withoutContinueButton: true,
    ctaText: "Try it out",
    options: [
        {
            id: "internal_projects",
            text: "Projects",
            image: "/static/img/cluster-selection/projects.png"
        },
        {
            id: "client_projects",
            text: "Projects for Clients",
            image: "/static/img/cluster-selection/client_projects.png"
        },
        {
            id: "todos",
            text: "Tasks & To Do's",
            image: "/static/img/cluster-selection/todos.png"
        },
        {
            id: "crm",
            text: "Sales & CRM",
            image: "/static/img/cluster-selection/crm.png"
        },
        {
            id: "orders",
            text: "Orders & Production",
            image: "/static/img/cluster-selection/orders.png"
        },
        {
            id: "product_roadmap",
            text: "Product Roadmap",
            image: "/static/img/cluster-selection/product_roadmap.png"
        },
        {
            id: "tech",
            text: "Software Development",
            image: "/static/img/cluster-selection/agile.png"
        },
        {
            id: "other",
            text: "I'll decide later",
            image: "/static/img/cluster-selection/other.png",
            detailsImage: "/static/img/cluster-selection/other_details.png",
            detailsText: "Manage anything with monday.com",
            isOther: true
        }
    ]
};


/***/ }),

/***/ 74138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ CLUSTER_CONFIG; },
/* harmony export */   "z": function() { return /* binding */ CLUSTER_OPTION_VALUE; }
/* harmony export */ });
/* harmony import */ var _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65023);
/* harmony import */ var _constants_cookies__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13019);
/* harmony import */ var _constants_cookies__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_constants_cookies__WEBPACK_IMPORTED_MODULE_0__);


var CLUSTER_OPTION_VALUE = "cluster";
var CLUSTER_CONFIG = {
    firstStepHtmlTitle: "What would you like <br><strong>to manage with monday.com?</strong>",
    secondStepHtmlTitle: "That's great! <br><strong>Now, let's get to work</strong>",
    otherDetailsHtmlTitle: "With more than 200 templates <br><strong>we got you covered</strong>",
    subtitleHtml: "You can always change this later",
    itemClickedEvent: _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_1__.CLUSTER_CLICKED,
    itemSelectedEvent: _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_1__.CLUSTER_SELECTED,
    selectedItemCookieName: _constants_cookies__WEBPACK_IMPORTED_MODULE_0__.USER_SELECTED_CLUSTER_COOKIE,
    options: [
        {
            id: "internal_projects",
            text: "Projects",
            image: "/static/img/cluster-selection/projects.png"
        },
        {
            id: "client_projects",
            text: "Projects for Clients",
            image: "/static/img/cluster-selection/client_projects.png"
        },
        {
            id: "todos",
            text: "Tasks & To Do's",
            image: "/static/img/cluster-selection/todos.png"
        },
        {
            id: "crm",
            text: "Sales & CRM",
            image: "/static/img/cluster-selection/crm.png"
        },
        {
            id: "orders",
            text: "Orders & Production",
            image: "/static/img/cluster-selection/orders.png"
        },
        {
            id: "marketing",
            text: "Marketing & Creative",
            image: "/static/img/cluster-selection/marketing.png"
        },
        {
            id: "tech",
            text: "Product and R&D",
            image: "/static/img/cluster-selection/agile.png"
        },
        {
            id: "other",
            text: "Other",
            image: "/static/img/cluster-selection/other.png",
            detailsImage: "/static/img/cluster-selection/other_details.png",
            detailsText: "Manage anything with monday.com",
            isOther: true
        }
    ]
};


/***/ }),

/***/ 54632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ CLUSTER_WITH_SOLUTION_OPTION_VALUE; },
/* harmony export */   "Z": function() { return /* binding */ CLUSTER_WITH_SOLUTION_CONFIG; }
/* harmony export */ });
/* harmony import */ var _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65023);
/* harmony import */ var _constants_cookies__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13019);
/* harmony import */ var _constants_cookies__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_constants_cookies__WEBPACK_IMPORTED_MODULE_0__);


var CLUSTER_WITH_SOLUTION_OPTION_VALUE = "cluster-with-solution ";
var CLUSTER_WITH_SOLUTION_CONFIG = {
    firstStepHtmlTitle: "What would you like <br><strong>to manage with monday.com?</strong>",
    otherDetailsHtmlTitle: "<strong>Manage your team projects visually</strong><br>",
    subtitleHtml: "You can always change this later",
    secondStepHtmlTitle: "<strong>Manage your team projects visually</strong><br>",
    secondStepSubtitleHtml: "Choose from multiple templates or create your own workflow",
    itemClickedEvent: _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_1__.CLUSTER_CLICKED,
    itemSelectedEvent: _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_1__.CLUSTER_SELECTED,
    selectedItemCookieName: _constants_cookies__WEBPACK_IMPORTED_MODULE_0__.USER_SELECTED_CLUSTER_COOKIE,
    secondStepScreen: "Solutions",
    options: [
        {
            id: "internal_projects",
            text: "Projects",
            image: "/static/img/cluster-selection/projects.png",
            solutionsImage: "/static/img/cluster-selection/solutions/internal_projects_solutions.png",
            secondStepHtmlTitle: "<strong>Manage projects visually</strong><br>"
        },
        {
            id: "client_projects",
            text: "Projects for Clients",
            image: "/static/img/cluster-selection/client_projects.png",
            solutionsImage: "/static/img/cluster-selection/solutions/client_projects_solutions.png",
            secondStepHtmlTitle: "<strong>Manage clients projects' visually</strong><br>"
        },
        {
            id: "todos",
            text: "Tasks & To Do's",
            image: "/static/img/cluster-selection/todos.png",
            solutionsImage: "/static/img/cluster-selection/solutions/todos_solutions.png",
            secondStepHtmlTitle: "<strong>Manage tasks & to do's visually</strong><br>"
        },
        {
            id: "crm",
            text: "Sales & CRM",
            image: "/static/img/cluster-selection/crm.png",
            solutionsImage: "/static/img/cluster-selection/solutions/crm_solutions.png",
            secondStepHtmlTitle: "<strong>Manage sales & CRM visually</strong><br>"
        },
        {
            id: "orders",
            text: "Orders & Production",
            image: "/static/img/cluster-selection/orders.png",
            solutionsImage: "/static/img/cluster-selection/solutions/orders_solutions.png",
            secondStepHtmlTitle: "<strong>Manage orders & production visually</strong><br>"
        },
        {
            id: "marketing",
            text: "Marketing & Creative",
            image: "/static/img/cluster-selection/marketing.png",
            solutionsImage: "/static/img/cluster-selection/solutions/marketing_solutions.png",
            secondStepHtmlTitle: "<strong>Manage marketing visually</strong><br>"
        },
        {
            id: "tech",
            text: "Product and R&D",
            image: "/static/img/cluster-selection/agile.png",
            solutionsImage: "/static/img/cluster-selection/solutions/agile_and_product_roadmap_solutions.png",
            secondStepHtmlTitle: "<strong>Manage product and R&D visually</strong><br>"
        },
        {
            id: "other",
            text: "Other",
            image: "/static/img/cluster-selection/other.png",
            detailsImage: "/static/img/cluster-selection/other_details.png",
            detailsText: "Manage anything with monday.com",
            isOther: true,
            solutionsImage: "/static/img/cluster-selection/solutions/other_solutions.png",
            secondStepHtmlTitle: "<strong>Manage your team's projects visually</strong><br>"
        }
    ]
};


/***/ }),

/***/ 25800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ LAYOUT_CONFIG; },
/* harmony export */   "o": function() { return /* binding */ LAYOUT_OPTION_VALUE; }
/* harmony export */ });
/* harmony import */ var _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65023);
var LAYOUT_OPTION_VALUE = "layout";

var LAYOUT_CONFIG = {
    firstStepHtmlTitle: "<strong>What would you like to <br>manage with monday.com?</strong>",
    secondStepHtmlTitle: "That's great! <br><strong>Now let's get to work</strong>",
    otherDetailsHtmlTitle: "With more than 200 templates<br><strong>we got you covered</strong>",
    subtitleHtml: "Pick one, you can easily<br>change it later.",
    itemClickedEvent: _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_0__.LAYOUT_CLICKED,
    itemSelectedEvent: _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_0__.LAYOUT_SELECTED,
    options: [
        {
            id: "tasks",
            text: "Task List",
            image: "/static/img/layout-selection/task_list.png",
            backgroundColor: "brand-iris"
        },
        {
            id: "timeline",
            text: "Timeline",
            image: "/static/img/layout-selection/timeline.png",
            backgroundColor: "brand-yellow"
        },
        {
            id: "processManagement",
            text: "Process Management",
            image: "/static/img/layout-selection/process_management.png",
            backgroundColor: "brand-red"
        },
        {
            id: "kanaban",
            text: "Kanban",
            image: "/static/img/layout-selection/kanban.png",
            backgroundColor: "brand-purple"
        },
        {
            id: "calendar",
            text: "Calendar",
            image: "/static/img/layout-selection/calendar.png",
            backgroundColor: "brand-light-blue"
        },
        {
            id: "list",
            text: "List",
            image: "/static/img/layout-selection/list.png",
            backgroundColor: "brand-green"
        },
        {
            id: "other",
            text: "Other",
            image: "/static/img/layout-selection/other.png",
            detailsImage: "/static/img/layout-selection/other_details.png",
            detailsText: "Manage anything with monday.com",
            isOther: true,
            backgroundColor: "dark-blue"
        }
    ]
};


/***/ })

}]);